
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8812"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8812"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("irwyI", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d6d401235435b965$export$ffb0004e005737fa, (v) => $d6d401235435b965$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d6d401235435b965$export$34b9dba7ce09269b, (v) => $d6d401235435b965$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d6d401235435b965$export$25062201e9e25d76, (v) => $d6d401235435b965$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d6d401235435b965$export$ffb0004e005737fa;
var $d6d401235435b965$export$34b9dba7ce09269b;
var $d6d401235435b965$export$25062201e9e25d76;
"use strict";
var $d6d401235435b965$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d6d401235435b965$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $d6d401235435b965$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $d6d401235435b965$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$d6d401235435b965$export$ffb0004e005737fa = $d6d401235435b965$var$REACT_FRAGMENT_TYPE;
$d6d401235435b965$export$34b9dba7ce09269b = $d6d401235435b965$var$jsxProd;
$d6d401235435b965$export$25062201e9e25d76 = $d6d401235435b965$var$jsxProd;

});

parcelRegister("eij5T", function(module, exports) {

$parcel$export(module.exports, "Children", () => $a6818ed42b6582f8$export$dca3b0875bd9a954, (v) => $a6818ed42b6582f8$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $a6818ed42b6582f8$export$16fa2f45be04daa8, (v) => $a6818ed42b6582f8$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $a6818ed42b6582f8$export$ffb0004e005737fa, (v) => $a6818ed42b6582f8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $a6818ed42b6582f8$export$e2c29f18771995cb, (v) => $a6818ed42b6582f8$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $a6818ed42b6582f8$export$221d75b3f55bb0bd, (v) => $a6818ed42b6582f8$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $a6818ed42b6582f8$export$5f8d39834fd61797, (v) => $a6818ed42b6582f8$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a6818ed42b6582f8$export$74bf444e3cd11ea5, (v) => $a6818ed42b6582f8$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $a6818ed42b6582f8$export$1ced07cd6b1985ce, (v) => $a6818ed42b6582f8$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $a6818ed42b6582f8$export$abd8e32b826d7ea7, (v) => $a6818ed42b6582f8$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $a6818ed42b6582f8$export$69a3209f1a06c04d, (v) => $a6818ed42b6582f8$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $a6818ed42b6582f8$export$e530037191fcd5d7, (v) => $a6818ed42b6582f8$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $a6818ed42b6582f8$export$fd42f52fd3ae1109, (v) => $a6818ed42b6582f8$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $a6818ed42b6582f8$export$c8a8987d4410bf2d, (v) => $a6818ed42b6582f8$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $a6818ed42b6582f8$export$7d1e3a5e95ceca43, (v) => $a6818ed42b6582f8$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $a6818ed42b6582f8$export$257a8862b851cb5b, (v) => $a6818ed42b6582f8$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $a6818ed42b6582f8$export$a8257692ac88316c, (v) => $a6818ed42b6582f8$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $a6818ed42b6582f8$export$488013bae63b21da, (v) => $a6818ed42b6582f8$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $a6818ed42b6582f8$export$7c73462e0d25e514, (v) => $a6818ed42b6582f8$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $a6818ed42b6582f8$export$7568632d0d33d16d, (v) => $a6818ed42b6582f8$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $a6818ed42b6582f8$export$f93f40ac0ca7e3a8, (v) => $a6818ed42b6582f8$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $a6818ed42b6582f8$export$1f96ae73734a86cc, (v) => $a6818ed42b6582f8$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $a6818ed42b6582f8$export$9a47ced3238df325, (v) => $a6818ed42b6582f8$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $a6818ed42b6582f8$export$35808ee640e87ca7, (v) => $a6818ed42b6582f8$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $a6818ed42b6582f8$export$fae74005e78b1a27, (v) => $a6818ed42b6582f8$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $a6818ed42b6582f8$export$dc8fbce3eb94dc1e, (v) => $a6818ed42b6582f8$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $a6818ed42b6582f8$export$6a7bc4e911dc01cf, (v) => $a6818ed42b6582f8$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $a6818ed42b6582f8$export$6d9c69b0de29b591, (v) => $a6818ed42b6582f8$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $a6818ed42b6582f8$export$f680877a34711e37, (v) => $a6818ed42b6582f8$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $a6818ed42b6582f8$export$d5a552a76deda3c2, (v) => $a6818ed42b6582f8$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $a6818ed42b6582f8$export$aaabe4eda9ed9969, (v) => $a6818ed42b6582f8$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $a6818ed42b6582f8$export$e5c5a5f917a5871c, (v) => $a6818ed42b6582f8$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $a6818ed42b6582f8$export$1538c33de8887b59, (v) => $a6818ed42b6582f8$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $a6818ed42b6582f8$export$fca7f784ae7a249a, (v) => $a6818ed42b6582f8$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $a6818ed42b6582f8$export$13e3392192263954, (v) => $a6818ed42b6582f8$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $a6818ed42b6582f8$export$b8f5890fc79d6aca, (v) => $a6818ed42b6582f8$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $a6818ed42b6582f8$export$60241385465d0a34, (v) => $a6818ed42b6582f8$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $a6818ed42b6582f8$export$306c0aa65ff9ec16, (v) => $a6818ed42b6582f8$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $a6818ed42b6582f8$export$7b286972b8d8ccbf, (v) => $a6818ed42b6582f8$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $a6818ed42b6582f8$export$83d89fbfd8236492, (v) => $a6818ed42b6582f8$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a6818ed42b6582f8$export$dca3b0875bd9a954;
var $a6818ed42b6582f8$export$16fa2f45be04daa8;
var $a6818ed42b6582f8$export$ffb0004e005737fa;
var $a6818ed42b6582f8$export$e2c29f18771995cb;
var $a6818ed42b6582f8$export$221d75b3f55bb0bd;
var $a6818ed42b6582f8$export$5f8d39834fd61797;
var $a6818ed42b6582f8$export$74bf444e3cd11ea5;
var $a6818ed42b6582f8$export$1ced07cd6b1985ce;
var $a6818ed42b6582f8$export$abd8e32b826d7ea7;
var $a6818ed42b6582f8$export$69a3209f1a06c04d;
var $a6818ed42b6582f8$export$e530037191fcd5d7;
var $a6818ed42b6582f8$export$fd42f52fd3ae1109;
var $a6818ed42b6582f8$export$c8a8987d4410bf2d;
var $a6818ed42b6582f8$export$7d1e3a5e95ceca43;
var $a6818ed42b6582f8$export$257a8862b851cb5b;
var $a6818ed42b6582f8$export$a8257692ac88316c;
var $a6818ed42b6582f8$export$488013bae63b21da;
var $a6818ed42b6582f8$export$7c73462e0d25e514;
var $a6818ed42b6582f8$export$7568632d0d33d16d;
var $a6818ed42b6582f8$export$f93f40ac0ca7e3a8;
var $a6818ed42b6582f8$export$1f96ae73734a86cc;
var $a6818ed42b6582f8$export$9a47ced3238df325;
var $a6818ed42b6582f8$export$35808ee640e87ca7;
var $a6818ed42b6582f8$export$fae74005e78b1a27;
var $a6818ed42b6582f8$export$dc8fbce3eb94dc1e;
var $a6818ed42b6582f8$export$6a7bc4e911dc01cf;
var $a6818ed42b6582f8$export$6d9c69b0de29b591;
var $a6818ed42b6582f8$export$f680877a34711e37;
var $a6818ed42b6582f8$export$d5a552a76deda3c2;
var $a6818ed42b6582f8$export$aaabe4eda9ed9969;
var $a6818ed42b6582f8$export$e5c5a5f917a5871c;
var $a6818ed42b6582f8$export$1538c33de8887b59;
var $a6818ed42b6582f8$export$fca7f784ae7a249a;
var $a6818ed42b6582f8$export$13e3392192263954;
var $a6818ed42b6582f8$export$b8f5890fc79d6aca;
var $a6818ed42b6582f8$export$60241385465d0a34;
var $a6818ed42b6582f8$export$306c0aa65ff9ec16;
var $a6818ed42b6582f8$export$7b286972b8d8ccbf;
var $a6818ed42b6582f8$export$83d89fbfd8236492;
"use strict";
var $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a6818ed42b6582f8$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a6818ed42b6582f8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a6818ed42b6582f8$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a6818ed42b6582f8$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a6818ed42b6582f8$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a6818ed42b6582f8$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a6818ed42b6582f8$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a6818ed42b6582f8$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a6818ed42b6582f8$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a6818ed42b6582f8$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a6818ed42b6582f8$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a6818ed42b6582f8$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $a6818ed42b6582f8$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a6818ed42b6582f8$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a6818ed42b6582f8$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a6818ed42b6582f8$var$assign = Object.assign, $a6818ed42b6582f8$var$emptyObject = {};
function $a6818ed42b6582f8$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a6818ed42b6582f8$var$emptyObject;
    this.updater = updater || $a6818ed42b6582f8$var$ReactNoopUpdateQueue;
}
$a6818ed42b6582f8$var$Component.prototype.isReactComponent = {};
$a6818ed42b6582f8$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$a6818ed42b6582f8$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $a6818ed42b6582f8$var$ComponentDummy() {}
$a6818ed42b6582f8$var$ComponentDummy.prototype = $a6818ed42b6582f8$var$Component.prototype;
function $a6818ed42b6582f8$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a6818ed42b6582f8$var$emptyObject;
    this.updater = updater || $a6818ed42b6582f8$var$ReactNoopUpdateQueue;
}
var $a6818ed42b6582f8$var$pureComponentPrototype = $a6818ed42b6582f8$var$PureComponent.prototype = new $a6818ed42b6582f8$var$ComponentDummy();
$a6818ed42b6582f8$var$pureComponentPrototype.constructor = $a6818ed42b6582f8$var$PureComponent;
$a6818ed42b6582f8$var$assign($a6818ed42b6582f8$var$pureComponentPrototype, $a6818ed42b6582f8$var$Component.prototype);
$a6818ed42b6582f8$var$pureComponentPrototype.isPureReactComponent = !0;
var $a6818ed42b6582f8$var$isArrayImpl = Array.isArray, $a6818ed42b6582f8$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $a6818ed42b6582f8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $a6818ed42b6582f8$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $a6818ed42b6582f8$var$cloneAndReplaceKey(oldElement, newKey) {
    return $a6818ed42b6582f8$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $a6818ed42b6582f8$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE;
}
function $a6818ed42b6582f8$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $a6818ed42b6582f8$var$userProvidedKeyEscapeRegex = /\/+/g;
function $a6818ed42b6582f8$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $a6818ed42b6582f8$var$escape("" + element.key) : index.toString(36);
}
function $a6818ed42b6582f8$var$noop$1() {}
function $a6818ed42b6582f8$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($a6818ed42b6582f8$var$noop$1, $a6818ed42b6582f8$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $a6818ed42b6582f8$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $a6818ed42b6582f8$var$REACT_ELEMENT_TYPE:
                case $a6818ed42b6582f8$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $a6818ed42b6582f8$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $a6818ed42b6582f8$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $a6818ed42b6582f8$var$getElementKey(children, 0) : nameSoFar, $a6818ed42b6582f8$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($a6818ed42b6582f8$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $a6818ed42b6582f8$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($a6818ed42b6582f8$var$isValidElement(callback) && (callback = $a6818ed42b6582f8$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($a6818ed42b6582f8$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($a6818ed42b6582f8$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $a6818ed42b6582f8$var$getElementKey(nameSoFar, i), invokeCallback += $a6818ed42b6582f8$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $a6818ed42b6582f8$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $a6818ed42b6582f8$var$getElementKey(nameSoFar, i++), invokeCallback += $a6818ed42b6582f8$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $a6818ed42b6582f8$var$mapIntoArray($a6818ed42b6582f8$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $a6818ed42b6582f8$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $a6818ed42b6582f8$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $a6818ed42b6582f8$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $a6818ed42b6582f8$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $a6818ed42b6582f8$var$noop() {}
$a6818ed42b6582f8$export$dca3b0875bd9a954 = {
    map: $a6818ed42b6582f8$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $a6818ed42b6582f8$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $a6818ed42b6582f8$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $a6818ed42b6582f8$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$a6818ed42b6582f8$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$a6818ed42b6582f8$export$16fa2f45be04daa8 = $a6818ed42b6582f8$var$Component;
$a6818ed42b6582f8$export$ffb0004e005737fa = $a6818ed42b6582f8$var$REACT_FRAGMENT_TYPE;
$a6818ed42b6582f8$export$e2c29f18771995cb = $a6818ed42b6582f8$var$REACT_PROFILER_TYPE;
$a6818ed42b6582f8$export$221d75b3f55bb0bd = $a6818ed42b6582f8$var$PureComponent;
$a6818ed42b6582f8$export$5f8d39834fd61797 = $a6818ed42b6582f8$var$REACT_STRICT_MODE_TYPE;
$a6818ed42b6582f8$export$74bf444e3cd11ea5 = $a6818ed42b6582f8$var$REACT_SUSPENSE_TYPE;
$a6818ed42b6582f8$export$1ced07cd6b1985ce = $a6818ed42b6582f8$var$ReactSharedInternals;
$a6818ed42b6582f8$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $a6818ed42b6582f8$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$a6818ed42b6582f8$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$a6818ed42b6582f8$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $a6818ed42b6582f8$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$a6818ed42b6582f8$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $a6818ed42b6582f8$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$a6818ed42b6582f8$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $a6818ed42b6582f8$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $a6818ed42b6582f8$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$a6818ed42b6582f8$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$a6818ed42b6582f8$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $a6818ed42b6582f8$var$ReactElement(type, key, void 0, void 0, null, props);
};
$a6818ed42b6582f8$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a6818ed42b6582f8$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$a6818ed42b6582f8$export$a8257692ac88316c = $a6818ed42b6582f8$var$isValidElement;
$a6818ed42b6582f8$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $a6818ed42b6582f8$var$lazyInitializer
    };
};
$a6818ed42b6582f8$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $a6818ed42b6582f8$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$a6818ed42b6582f8$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $a6818ed42b6582f8$var$ReactSharedInternals.T, currentTransition = {};
    $a6818ed42b6582f8$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $a6818ed42b6582f8$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($a6818ed42b6582f8$var$noop, $a6818ed42b6582f8$var$reportGlobalError);
    } catch (error) {
        $a6818ed42b6582f8$var$reportGlobalError(error);
    } finally{
        $a6818ed42b6582f8$var$ReactSharedInternals.T = prevTransition;
    }
};
$a6818ed42b6582f8$export$f93f40ac0ca7e3a8 = function() {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useCacheRefresh();
};
$a6818ed42b6582f8$export$1f96ae73734a86cc = function(usable) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.use(usable);
};
$a6818ed42b6582f8$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$a6818ed42b6582f8$export$35808ee640e87ca7 = function(callback, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$a6818ed42b6582f8$export$fae74005e78b1a27 = function(Context) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useContext(Context);
};
$a6818ed42b6582f8$export$dc8fbce3eb94dc1e = function() {};
$a6818ed42b6582f8$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$a6818ed42b6582f8$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $a6818ed42b6582f8$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$a6818ed42b6582f8$export$f680877a34711e37 = function() {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useId();
};
$a6818ed42b6582f8$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$a6818ed42b6582f8$export$aaabe4eda9ed9969 = function(create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$a6818ed42b6582f8$export$e5c5a5f917a5871c = function(create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$a6818ed42b6582f8$export$1538c33de8887b59 = function(create, deps) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useMemo(create, deps);
};
$a6818ed42b6582f8$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$a6818ed42b6582f8$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$a6818ed42b6582f8$export$b8f5890fc79d6aca = function(initialValue) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useRef(initialValue);
};
$a6818ed42b6582f8$export$60241385465d0a34 = function(initialState) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useState(initialState);
};
$a6818ed42b6582f8$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$a6818ed42b6582f8$export$7b286972b8d8ccbf = function() {
    return $a6818ed42b6582f8$var$ReactSharedInternals.H.useTransition();
};
$a6818ed42b6582f8$export$83d89fbfd8236492 = "19.1.0";

});

parcelRegister("5xaMB", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $407866112e362b76$export$882461b6382ed46c, (v) => $407866112e362b76$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $407866112e362b76$export$757ceba2d55c277e, (v) => $407866112e362b76$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $407866112e362b76$export$83d89fbfd8236492, (v) => $407866112e362b76$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $407866112e362b76$export$882461b6382ed46c;
var $407866112e362b76$export$757ceba2d55c277e;
var $407866112e362b76$export$83d89fbfd8236492;
"use strict";

var $hNfVH = parcelRequire("hNfVH");

var $8vqx4 = parcelRequire("8vqx4");

var $hiyfL = parcelRequire("hiyfL");
function $407866112e362b76$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $407866112e362b76$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $407866112e362b76$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $407866112e362b76$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $407866112e362b76$var$assertIsMounted(fiber) {
    if ($407866112e362b76$var$getNearestMountedFiber(fiber) !== fiber) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
}
function $407866112e362b76$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $407866112e362b76$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $407866112e362b76$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $407866112e362b76$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($407866112e362b76$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($407866112e362b76$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($407866112e362b76$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $407866112e362b76$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $407866112e362b76$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $407866112e362b76$var$assign = Object.assign, $407866112e362b76$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $407866112e362b76$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $407866112e362b76$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $407866112e362b76$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $407866112e362b76$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $407866112e362b76$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $407866112e362b76$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $407866112e362b76$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $407866112e362b76$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $407866112e362b76$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $407866112e362b76$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $407866112e362b76$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $407866112e362b76$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $407866112e362b76$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $407866112e362b76$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $407866112e362b76$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $407866112e362b76$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $407866112e362b76$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$407866112e362b76$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $407866112e362b76$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $407866112e362b76$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $407866112e362b76$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $407866112e362b76$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $407866112e362b76$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $407866112e362b76$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $407866112e362b76$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $407866112e362b76$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $407866112e362b76$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $407866112e362b76$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $407866112e362b76$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $407866112e362b76$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $407866112e362b76$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $407866112e362b76$var$getComponentNameFromType(type.type) || "Memo";
        case $407866112e362b76$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $407866112e362b76$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $407866112e362b76$var$isArrayImpl = Array.isArray, $407866112e362b76$var$ReactSharedInternals = $8vqx4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $407866112e362b76$var$ReactDOMSharedInternals = $hiyfL.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $407866112e362b76$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $407866112e362b76$var$valueStack = [], $407866112e362b76$var$index = -1;
function $407866112e362b76$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $407866112e362b76$var$pop(cursor) {
    0 > $407866112e362b76$var$index || (cursor.current = $407866112e362b76$var$valueStack[$407866112e362b76$var$index], $407866112e362b76$var$valueStack[$407866112e362b76$var$index] = null, $407866112e362b76$var$index--);
}
function $407866112e362b76$var$push(cursor, value) {
    $407866112e362b76$var$index++;
    $407866112e362b76$var$valueStack[$407866112e362b76$var$index] = cursor.current;
    cursor.current = value;
}
var $407866112e362b76$var$contextStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$contextFiberStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$rootInstanceStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$hostTransitionProviderCursor = $407866112e362b76$var$createCursor(null);
function $407866112e362b76$var$pushHostContainer(fiber, nextRootInstance) {
    $407866112e362b76$var$push($407866112e362b76$var$rootInstanceStackCursor, nextRootInstance);
    $407866112e362b76$var$push($407866112e362b76$var$contextFiberStackCursor, fiber);
    $407866112e362b76$var$push($407866112e362b76$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $407866112e362b76$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $407866112e362b76$var$getOwnHostContext(nextRootInstance), fiber = $407866112e362b76$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $407866112e362b76$var$pop($407866112e362b76$var$contextStackCursor);
    $407866112e362b76$var$push($407866112e362b76$var$contextStackCursor, fiber);
}
function $407866112e362b76$var$popHostContainer() {
    $407866112e362b76$var$pop($407866112e362b76$var$contextStackCursor);
    $407866112e362b76$var$pop($407866112e362b76$var$contextFiberStackCursor);
    $407866112e362b76$var$pop($407866112e362b76$var$rootInstanceStackCursor);
}
function $407866112e362b76$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $407866112e362b76$var$push($407866112e362b76$var$hostTransitionProviderCursor, fiber);
    var context = $407866112e362b76$var$contextStackCursor.current;
    var JSCompiler_inline_result = $407866112e362b76$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($407866112e362b76$var$push($407866112e362b76$var$contextFiberStackCursor, fiber), $407866112e362b76$var$push($407866112e362b76$var$contextStackCursor, JSCompiler_inline_result));
}
function $407866112e362b76$var$popHostContext(fiber) {
    $407866112e362b76$var$contextFiberStackCursor.current === fiber && ($407866112e362b76$var$pop($407866112e362b76$var$contextStackCursor), $407866112e362b76$var$pop($407866112e362b76$var$contextFiberStackCursor));
    $407866112e362b76$var$hostTransitionProviderCursor.current === fiber && ($407866112e362b76$var$pop($407866112e362b76$var$hostTransitionProviderCursor), $407866112e362b76$var$HostTransitionContext._currentValue = $407866112e362b76$var$sharedNotPendingObject);
}
var $407866112e362b76$var$hasOwnProperty = Object.prototype.hasOwnProperty, $407866112e362b76$var$scheduleCallback$3 = $hNfVH.unstable_scheduleCallback, $407866112e362b76$var$cancelCallback$1 = $hNfVH.unstable_cancelCallback, $407866112e362b76$var$shouldYield = $hNfVH.unstable_shouldYield, $407866112e362b76$var$requestPaint = $hNfVH.unstable_requestPaint, $407866112e362b76$var$now = $hNfVH.unstable_now, $407866112e362b76$var$getCurrentPriorityLevel = $hNfVH.unstable_getCurrentPriorityLevel, $407866112e362b76$var$ImmediatePriority = $hNfVH.unstable_ImmediatePriority, $407866112e362b76$var$UserBlockingPriority = $hNfVH.unstable_UserBlockingPriority, $407866112e362b76$var$NormalPriority$1 = $hNfVH.unstable_NormalPriority, $407866112e362b76$var$LowPriority = $hNfVH.unstable_LowPriority, $407866112e362b76$var$IdlePriority = $hNfVH.unstable_IdlePriority, $407866112e362b76$var$log$1 = $hNfVH.log, $407866112e362b76$var$unstable_setDisableYieldValue = $hNfVH.unstable_setDisableYieldValue, $407866112e362b76$var$rendererID = null, $407866112e362b76$var$injectedHook = null;
function $407866112e362b76$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $407866112e362b76$var$log$1 && $407866112e362b76$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.setStrictMode) try {
        $407866112e362b76$var$injectedHook.setStrictMode($407866112e362b76$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $407866112e362b76$var$clz32 = Math.clz32 ? Math.clz32 : $407866112e362b76$var$clz32Fallback, $407866112e362b76$var$log = Math.log, $407866112e362b76$var$LN2 = Math.LN2;
function $407866112e362b76$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($407866112e362b76$var$log(x) / $407866112e362b76$var$LN2 | 0) | 0;
}
var $407866112e362b76$var$nextTransitionLane = 256, $407866112e362b76$var$nextRetryLane = 4194304;
function $407866112e362b76$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $407866112e362b76$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $407866112e362b76$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $407866112e362b76$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $407866112e362b76$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $407866112e362b76$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $407866112e362b76$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $407866112e362b76$var$claimNextTransitionLane() {
    var lane = $407866112e362b76$var$nextTransitionLane;
    $407866112e362b76$var$nextTransitionLane <<= 1;
    0 === ($407866112e362b76$var$nextTransitionLane & 4194048) && ($407866112e362b76$var$nextTransitionLane = 256);
    return lane;
}
function $407866112e362b76$var$claimNextRetryLane() {
    var lane = $407866112e362b76$var$nextRetryLane;
    $407866112e362b76$var$nextRetryLane <<= 1;
    0 === ($407866112e362b76$var$nextRetryLane & 62914560) && ($407866112e362b76$var$nextRetryLane = 4194304);
    return lane;
}
function $407866112e362b76$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $407866112e362b76$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $407866112e362b76$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $407866112e362b76$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $407866112e362b76$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $407866112e362b76$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $407866112e362b76$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $407866112e362b76$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $407866112e362b76$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $407866112e362b76$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $407866112e362b76$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $407866112e362b76$var$resolveUpdatePriority() {
    var updatePriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $407866112e362b76$var$getEventPriority(updatePriority.type);
}
function $407866112e362b76$var$runWithPriority(priority, fn) {
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        return $407866112e362b76$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $407866112e362b76$var$randomKey = Math.random().toString(36).slice(2), $407866112e362b76$var$internalInstanceKey = "__reactFiber$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalPropsKey = "__reactProps$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalContainerInstanceKey = "__reactContainer$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalEventHandlersKey = "__reactEvents$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalEventHandlerListenersKey = "__reactListeners$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalEventHandlesSetKey = "__reactHandles$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalRootNodeResourcesKey = "__reactResources$" + $407866112e362b76$var$randomKey, $407866112e362b76$var$internalHoistableMarker = "__reactMarker$" + $407866112e362b76$var$randomKey;
function $407866112e362b76$var$detachDeletedInstance(node) {
    delete node[$407866112e362b76$var$internalInstanceKey];
    delete node[$407866112e362b76$var$internalPropsKey];
    delete node[$407866112e362b76$var$internalEventHandlersKey];
    delete node[$407866112e362b76$var$internalEventHandlerListenersKey];
    delete node[$407866112e362b76$var$internalEventHandlesSetKey];
}
function $407866112e362b76$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$407866112e362b76$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$407866112e362b76$var$internalContainerInstanceKey] || parentNode[$407866112e362b76$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $407866112e362b76$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$407866112e362b76$var$internalInstanceKey]) return parentNode;
                targetNode = $407866112e362b76$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $407866112e362b76$var$getInstanceFromNode(node) {
    if (node = node[$407866112e362b76$var$internalInstanceKey] || node[$407866112e362b76$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $407866112e362b76$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($407866112e362b76$var$formatProdErrorMessage(33));
}
function $407866112e362b76$var$getResourcesFromRoot(root) {
    var resources = root[$407866112e362b76$var$internalRootNodeResourcesKey];
    resources || (resources = root[$407866112e362b76$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $407866112e362b76$var$markNodeAsHoistable(node) {
    node[$407866112e362b76$var$internalHoistableMarker] = !0;
}
var $407866112e362b76$var$allNativeEvents = new Set(), $407866112e362b76$var$registrationNameDependencies = {};
function $407866112e362b76$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $407866112e362b76$var$registerDirectEvent(registrationName, dependencies);
    $407866112e362b76$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $407866112e362b76$var$registerDirectEvent(registrationName, dependencies) {
    $407866112e362b76$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$407866112e362b76$var$allNativeEvents.add(dependencies[registrationName]);
}
var $407866112e362b76$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $407866112e362b76$var$illegalAttributeNameCache = {}, $407866112e362b76$var$validatedAttributeNameCache = {};
function $407866112e362b76$var$isAttributeNameSafe(attributeName) {
    if ($407866112e362b76$var$hasOwnProperty.call($407866112e362b76$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($407866112e362b76$var$hasOwnProperty.call($407866112e362b76$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($407866112e362b76$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $407866112e362b76$var$validatedAttributeNameCache[attributeName] = !0;
    $407866112e362b76$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $407866112e362b76$var$setValueForAttribute(node, name, value) {
    if ($407866112e362b76$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $407866112e362b76$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $407866112e362b76$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $407866112e362b76$var$prefix, $407866112e362b76$var$suffix;
function $407866112e362b76$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $407866112e362b76$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $407866112e362b76$var$prefix = match && match[1] || "";
        $407866112e362b76$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $407866112e362b76$var$prefix + name + $407866112e362b76$var$suffix;
}
var $407866112e362b76$var$reentry = !1;
function $407866112e362b76$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $407866112e362b76$var$reentry) return "";
    $407866112e362b76$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $407866112e362b76$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $407866112e362b76$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $407866112e362b76$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $407866112e362b76$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $407866112e362b76$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $407866112e362b76$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $407866112e362b76$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $407866112e362b76$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $407866112e362b76$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $407866112e362b76$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $407866112e362b76$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $407866112e362b76$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $407866112e362b76$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $407866112e362b76$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $407866112e362b76$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $407866112e362b76$var$trackValueOnNode(node) {
    var valueField = $407866112e362b76$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $407866112e362b76$var$track(node) {
    node._valueTracker || (node._valueTracker = $407866112e362b76$var$trackValueOnNode(node));
}
function $407866112e362b76$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $407866112e362b76$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $407866112e362b76$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $407866112e362b76$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $407866112e362b76$var$getToStringValue(value);
        } else element.value !== "" + $407866112e362b76$var$getToStringValue(value) && (element.value = "" + $407866112e362b76$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $407866112e362b76$var$setDefaultValue(element, type, $407866112e362b76$var$getToStringValue(value)) : null != defaultValue ? $407866112e362b76$var$setDefaultValue(element, type, $407866112e362b76$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $407866112e362b76$var$getToStringValue(name) : element.removeAttribute("name");
}
function $407866112e362b76$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $407866112e362b76$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $407866112e362b76$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $407866112e362b76$var$setDefaultValue(node, type, value) {
    "number" === type && $407866112e362b76$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $407866112e362b76$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $407866112e362b76$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $407866112e362b76$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $407866112e362b76$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $407866112e362b76$var$getToStringValue(defaultValue) : "";
}
function $407866112e362b76$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($407866112e362b76$var$formatProdErrorMessage(92));
            if ($407866112e362b76$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($407866112e362b76$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $407866112e362b76$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $407866112e362b76$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $407866112e362b76$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $407866112e362b76$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $407866112e362b76$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $407866112e362b76$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($407866112e362b76$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $407866112e362b76$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $407866112e362b76$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $407866112e362b76$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $407866112e362b76$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $407866112e362b76$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $407866112e362b76$var$sanitizeURL(url) {
    return $407866112e362b76$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $407866112e362b76$var$currentReplayingEvent = null;
function $407866112e362b76$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $407866112e362b76$var$restoreTarget = null, $407866112e362b76$var$restoreQueue = null;
function $407866112e362b76$var$restoreStateOfTarget(target) {
    var internalInstance = $407866112e362b76$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$407866112e362b76$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $407866112e362b76$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$407866112e362b76$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($407866112e362b76$var$formatProdErrorMessage(90));
                            $407866112e362b76$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $407866112e362b76$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $407866112e362b76$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $407866112e362b76$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $407866112e362b76$var$isInsideEventHandler = !1;
function $407866112e362b76$var$batchedUpdates$1(fn, a, b) {
    if ($407866112e362b76$var$isInsideEventHandler) return fn(a, b);
    $407866112e362b76$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($407866112e362b76$var$isInsideEventHandler = !1, null !== $407866112e362b76$var$restoreTarget || null !== $407866112e362b76$var$restoreQueue) {
            if ($407866112e362b76$var$flushSyncWork$1(), $407866112e362b76$var$restoreTarget && (a = $407866112e362b76$var$restoreTarget, fn = $407866112e362b76$var$restoreQueue, $407866112e362b76$var$restoreQueue = $407866112e362b76$var$restoreTarget = null, $407866112e362b76$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$407866112e362b76$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $407866112e362b76$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$407866112e362b76$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $407866112e362b76$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $407866112e362b76$var$passiveBrowserEventsSupported = !1;
if ($407866112e362b76$var$canUseDOM) try {
    var $407866112e362b76$var$options = {};
    Object.defineProperty($407866112e362b76$var$options, "passive", {
        get: function() {
            $407866112e362b76$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $407866112e362b76$var$options, $407866112e362b76$var$options);
    window.removeEventListener("test", $407866112e362b76$var$options, $407866112e362b76$var$options);
} catch (e) {
    $407866112e362b76$var$passiveBrowserEventsSupported = !1;
}
var $407866112e362b76$var$root = null, $407866112e362b76$var$startText = null, $407866112e362b76$var$fallbackText = null;
function $407866112e362b76$var$getData() {
    if ($407866112e362b76$var$fallbackText) return $407866112e362b76$var$fallbackText;
    var start, startValue = $407866112e362b76$var$startText, startLength = startValue.length, end, endValue = "value" in $407866112e362b76$var$root ? $407866112e362b76$var$root.value : $407866112e362b76$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $407866112e362b76$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $407866112e362b76$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $407866112e362b76$var$functionThatReturnsTrue() {
    return !0;
}
function $407866112e362b76$var$functionThatReturnsFalse() {
    return !1;
}
function $407866112e362b76$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $407866112e362b76$var$functionThatReturnsTrue : $407866112e362b76$var$functionThatReturnsFalse;
        this.isPropagationStopped = $407866112e362b76$var$functionThatReturnsFalse;
        return this;
    }
    $407866112e362b76$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $407866112e362b76$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $407866112e362b76$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $407866112e362b76$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $407866112e362b76$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $407866112e362b76$var$SyntheticEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$EventInterface), $407866112e362b76$var$UIEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    view: 0,
    detail: 0
}), $407866112e362b76$var$SyntheticUIEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$UIEventInterface), $407866112e362b76$var$lastMovementX, $407866112e362b76$var$lastMovementY, $407866112e362b76$var$lastMouseEvent, $407866112e362b76$var$MouseEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $407866112e362b76$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $407866112e362b76$var$lastMouseEvent && ($407866112e362b76$var$lastMouseEvent && "mousemove" === event.type ? ($407866112e362b76$var$lastMovementX = event.screenX - $407866112e362b76$var$lastMouseEvent.screenX, $407866112e362b76$var$lastMovementY = event.screenY - $407866112e362b76$var$lastMouseEvent.screenY) : $407866112e362b76$var$lastMovementY = $407866112e362b76$var$lastMovementX = 0, $407866112e362b76$var$lastMouseEvent = event);
        return $407866112e362b76$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $407866112e362b76$var$lastMovementY;
    }
}), $407866112e362b76$var$SyntheticMouseEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$MouseEventInterface), $407866112e362b76$var$DragEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$MouseEventInterface, {
    dataTransfer: 0
}), $407866112e362b76$var$SyntheticDragEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$DragEventInterface), $407866112e362b76$var$FocusEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    relatedTarget: 0
}), $407866112e362b76$var$SyntheticFocusEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$FocusEventInterface), $407866112e362b76$var$AnimationEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $407866112e362b76$var$SyntheticAnimationEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$AnimationEventInterface), $407866112e362b76$var$ClipboardEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $407866112e362b76$var$SyntheticClipboardEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$ClipboardEventInterface), $407866112e362b76$var$CompositionEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    data: 0
}), $407866112e362b76$var$SyntheticCompositionEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$CompositionEventInterface), $407866112e362b76$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $407866112e362b76$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $407866112e362b76$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $407866112e362b76$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $407866112e362b76$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $407866112e362b76$var$getEventModifierState() {
    return $407866112e362b76$var$modifierStateGetter;
}
var $407866112e362b76$var$KeyboardEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $407866112e362b76$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $407866112e362b76$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $407866112e362b76$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $407866112e362b76$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $407866112e362b76$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $407866112e362b76$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $407866112e362b76$var$SyntheticKeyboardEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$KeyboardEventInterface), $407866112e362b76$var$PointerEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $407866112e362b76$var$SyntheticPointerEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$PointerEventInterface), $407866112e362b76$var$TouchEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $407866112e362b76$var$getEventModifierState
}), $407866112e362b76$var$SyntheticTouchEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$TouchEventInterface), $407866112e362b76$var$TransitionEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $407866112e362b76$var$SyntheticTransitionEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$TransitionEventInterface), $407866112e362b76$var$WheelEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $407866112e362b76$var$SyntheticWheelEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$WheelEventInterface), $407866112e362b76$var$ToggleEventInterface = $407866112e362b76$var$assign({}, $407866112e362b76$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $407866112e362b76$var$SyntheticToggleEvent = $407866112e362b76$var$createSyntheticEvent($407866112e362b76$var$ToggleEventInterface), $407866112e362b76$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $407866112e362b76$var$canUseCompositionEvent = $407866112e362b76$var$canUseDOM && "CompositionEvent" in window, $407866112e362b76$var$documentMode = null;
$407866112e362b76$var$canUseDOM && "documentMode" in document && ($407866112e362b76$var$documentMode = document.documentMode);
var $407866112e362b76$var$canUseTextInputEvent = $407866112e362b76$var$canUseDOM && "TextEvent" in window && !$407866112e362b76$var$documentMode, $407866112e362b76$var$useFallbackCompositionData = $407866112e362b76$var$canUseDOM && (!$407866112e362b76$var$canUseCompositionEvent || $407866112e362b76$var$documentMode && 8 < $407866112e362b76$var$documentMode && 11 >= $407866112e362b76$var$documentMode), $407866112e362b76$var$SPACEBAR_CHAR = String.fromCharCode(32), $407866112e362b76$var$hasSpaceKeypress = !1;
function $407866112e362b76$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $407866112e362b76$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $407866112e362b76$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $407866112e362b76$var$isComposing = !1;
function $407866112e362b76$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $407866112e362b76$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $407866112e362b76$var$hasSpaceKeypress = !0;
            return $407866112e362b76$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $407866112e362b76$var$SPACEBAR_CHAR && $407866112e362b76$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $407866112e362b76$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($407866112e362b76$var$isComposing) return "compositionend" === domEventName || !$407866112e362b76$var$canUseCompositionEvent && $407866112e362b76$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $407866112e362b76$var$getData(), $407866112e362b76$var$fallbackText = $407866112e362b76$var$startText = $407866112e362b76$var$root = null, $407866112e362b76$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $407866112e362b76$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $407866112e362b76$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $407866112e362b76$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$407866112e362b76$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $407866112e362b76$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $407866112e362b76$var$restoreTarget ? $407866112e362b76$var$restoreQueue ? $407866112e362b76$var$restoreQueue.push(target) : $407866112e362b76$var$restoreQueue = [
        target
    ] : $407866112e362b76$var$restoreTarget = target;
    inst = $407866112e362b76$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $407866112e362b76$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $407866112e362b76$var$activeElement$1 = null, $407866112e362b76$var$activeElementInst$1 = null;
function $407866112e362b76$var$runEventInBatch(dispatchQueue) {
    $407866112e362b76$var$processDispatchQueue(dispatchQueue, 0);
}
function $407866112e362b76$var$getInstIfValueChanged(targetInst) {
    var targetNode = $407866112e362b76$var$getNodeFromInstance(targetInst);
    if ($407866112e362b76$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $407866112e362b76$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $407866112e362b76$var$isInputEventSupported = !1;
if ($407866112e362b76$var$canUseDOM) {
    var $407866112e362b76$var$JSCompiler_inline_result$jscomp$282;
    if ($407866112e362b76$var$canUseDOM) {
        var $407866112e362b76$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$407866112e362b76$var$isSupported$jscomp$inline_417) {
            var $407866112e362b76$var$element$jscomp$inline_418 = document.createElement("div");
            $407866112e362b76$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $407866112e362b76$var$isSupported$jscomp$inline_417 = "function" === typeof $407866112e362b76$var$element$jscomp$inline_418.oninput;
        }
        $407866112e362b76$var$JSCompiler_inline_result$jscomp$282 = $407866112e362b76$var$isSupported$jscomp$inline_417;
    } else $407866112e362b76$var$JSCompiler_inline_result$jscomp$282 = !1;
    $407866112e362b76$var$isInputEventSupported = $407866112e362b76$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $407866112e362b76$var$stopWatchingForValueChange() {
    $407866112e362b76$var$activeElement$1 && ($407866112e362b76$var$activeElement$1.detachEvent("onpropertychange", $407866112e362b76$var$handlePropertyChange), $407866112e362b76$var$activeElementInst$1 = $407866112e362b76$var$activeElement$1 = null);
}
function $407866112e362b76$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $407866112e362b76$var$getInstIfValueChanged($407866112e362b76$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $407866112e362b76$var$createAndAccumulateChangeEvent(dispatchQueue, $407866112e362b76$var$activeElementInst$1, nativeEvent, $407866112e362b76$var$getEventTarget(nativeEvent));
        $407866112e362b76$var$batchedUpdates$1($407866112e362b76$var$runEventInBatch, dispatchQueue);
    }
}
function $407866112e362b76$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($407866112e362b76$var$stopWatchingForValueChange(), $407866112e362b76$var$activeElement$1 = target, $407866112e362b76$var$activeElementInst$1 = targetInst, $407866112e362b76$var$activeElement$1.attachEvent("onpropertychange", $407866112e362b76$var$handlePropertyChange)) : "focusout" === domEventName && $407866112e362b76$var$stopWatchingForValueChange();
}
function $407866112e362b76$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $407866112e362b76$var$getInstIfValueChanged($407866112e362b76$var$activeElementInst$1);
}
function $407866112e362b76$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $407866112e362b76$var$getInstIfValueChanged(targetInst);
}
function $407866112e362b76$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $407866112e362b76$var$getInstIfValueChanged(targetInst);
}
function $407866112e362b76$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $407866112e362b76$var$objectIs = "function" === typeof Object.is ? Object.is : $407866112e362b76$var$is;
function $407866112e362b76$var$shallowEqual(objA, objB) {
    if ($407866112e362b76$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$407866112e362b76$var$hasOwnProperty.call(objB, currentKey) || !$407866112e362b76$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $407866112e362b76$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $407866112e362b76$var$getNodeForCharacterOffset(root, offset) {
    var node = $407866112e362b76$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $407866112e362b76$var$getLeafNode(node);
    }
}
function $407866112e362b76$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $407866112e362b76$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $407866112e362b76$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $407866112e362b76$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $407866112e362b76$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $407866112e362b76$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $407866112e362b76$var$skipSelectionChangeEvent = $407866112e362b76$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $407866112e362b76$var$activeElement = null, $407866112e362b76$var$activeElementInst = null, $407866112e362b76$var$lastSelection = null, $407866112e362b76$var$mouseDown = !1;
function $407866112e362b76$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $407866112e362b76$var$mouseDown || null == $407866112e362b76$var$activeElement || $407866112e362b76$var$activeElement !== $407866112e362b76$var$getActiveElement(doc) || (doc = $407866112e362b76$var$activeElement, "selectionStart" in doc && $407866112e362b76$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $407866112e362b76$var$lastSelection && $407866112e362b76$var$shallowEqual($407866112e362b76$var$lastSelection, doc) || ($407866112e362b76$var$lastSelection = doc, doc = $407866112e362b76$var$accumulateTwoPhaseListeners($407866112e362b76$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $407866112e362b76$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $407866112e362b76$var$activeElement)));
}
function $407866112e362b76$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $407866112e362b76$var$vendorPrefixes = {
    animationend: $407866112e362b76$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $407866112e362b76$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $407866112e362b76$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $407866112e362b76$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $407866112e362b76$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $407866112e362b76$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $407866112e362b76$var$makePrefixMap("Transition", "TransitionEnd")
}, $407866112e362b76$var$prefixedEventNames = {}, $407866112e362b76$var$style = {};
$407866112e362b76$var$canUseDOM && ($407866112e362b76$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $407866112e362b76$var$vendorPrefixes.animationend.animation, delete $407866112e362b76$var$vendorPrefixes.animationiteration.animation, delete $407866112e362b76$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $407866112e362b76$var$vendorPrefixes.transitionend.transition);
function $407866112e362b76$var$getVendorPrefixedEventName(eventName) {
    if ($407866112e362b76$var$prefixedEventNames[eventName]) return $407866112e362b76$var$prefixedEventNames[eventName];
    if (!$407866112e362b76$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $407866112e362b76$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $407866112e362b76$var$style) return $407866112e362b76$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $407866112e362b76$var$ANIMATION_END = $407866112e362b76$var$getVendorPrefixedEventName("animationend"), $407866112e362b76$var$ANIMATION_ITERATION = $407866112e362b76$var$getVendorPrefixedEventName("animationiteration"), $407866112e362b76$var$ANIMATION_START = $407866112e362b76$var$getVendorPrefixedEventName("animationstart"), $407866112e362b76$var$TRANSITION_RUN = $407866112e362b76$var$getVendorPrefixedEventName("transitionrun"), $407866112e362b76$var$TRANSITION_START = $407866112e362b76$var$getVendorPrefixedEventName("transitionstart"), $407866112e362b76$var$TRANSITION_CANCEL = $407866112e362b76$var$getVendorPrefixedEventName("transitioncancel"), $407866112e362b76$var$TRANSITION_END = $407866112e362b76$var$getVendorPrefixedEventName("transitionend"), $407866112e362b76$var$topLevelEventsToReactNames = new Map(), $407866112e362b76$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$407866112e362b76$var$simpleEventPluginEvents.push("scrollEnd");
function $407866112e362b76$var$registerSimpleEvent(domEventName, reactName) {
    $407866112e362b76$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $407866112e362b76$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $407866112e362b76$var$CapturedStacks = new WeakMap();
function $407866112e362b76$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $407866112e362b76$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $407866112e362b76$var$getStackByFiberInDevAndProd(source)
        };
        $407866112e362b76$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $407866112e362b76$var$getStackByFiberInDevAndProd(source)
    };
}
var $407866112e362b76$var$concurrentQueues = [], $407866112e362b76$var$concurrentQueuesIndex = 0, $407866112e362b76$var$concurrentlyUpdatedLanes = 0;
function $407866112e362b76$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $407866112e362b76$var$concurrentQueuesIndex, i = $407866112e362b76$var$concurrentlyUpdatedLanes = $407866112e362b76$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        var queue = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        var update = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        var lane = $407866112e362b76$var$concurrentQueues[i];
        $407866112e362b76$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $407866112e362b76$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $407866112e362b76$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = fiber;
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = queue;
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = update;
    $407866112e362b76$var$concurrentQueues[$407866112e362b76$var$concurrentQueuesIndex++] = lane;
    $407866112e362b76$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $407866112e362b76$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $407866112e362b76$var$getRootForUpdatedFiber(fiber);
}
function $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $407866112e362b76$var$enqueueUpdate$1(fiber, null, null, lane);
    return $407866112e362b76$var$getRootForUpdatedFiber(fiber);
}
function $407866112e362b76$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $407866112e362b76$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $407866112e362b76$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $407866112e362b76$var$nestedUpdateCount) throw $407866112e362b76$var$nestedUpdateCount = 0, $407866112e362b76$var$rootWithNestedUpdates = null, Error($407866112e362b76$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $407866112e362b76$var$emptyContextObject = {};
function $407866112e362b76$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $407866112e362b76$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $407866112e362b76$var$FiberNode(tag, pendingProps, key, mode);
}
function $407866112e362b76$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $407866112e362b76$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $407866112e362b76$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $407866112e362b76$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $407866112e362b76$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $407866112e362b76$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $407866112e362b76$var$isHostHoistableType(type, pendingProps, $407866112e362b76$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $407866112e362b76$var$REACT_ACTIVITY_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $407866112e362b76$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $407866112e362b76$var$REACT_FRAGMENT_TYPE:
            return $407866112e362b76$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $407866112e362b76$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $407866112e362b76$var$REACT_PROFILER_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $407866112e362b76$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $407866112e362b76$var$REACT_SUSPENSE_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $407866112e362b76$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $407866112e362b76$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $407866112e362b76$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $407866112e362b76$var$REACT_PROVIDER_TYPE:
                case $407866112e362b76$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $407866112e362b76$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $407866112e362b76$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $407866112e362b76$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($407866112e362b76$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $407866112e362b76$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $407866112e362b76$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $407866112e362b76$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $407866112e362b76$var$createFiberFromText(content, mode, lanes) {
    content = $407866112e362b76$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $407866112e362b76$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $407866112e362b76$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $407866112e362b76$var$forkStack = [], $407866112e362b76$var$forkStackIndex = 0, $407866112e362b76$var$treeForkProvider = null, $407866112e362b76$var$treeForkCount = 0, $407866112e362b76$var$idStack = [], $407866112e362b76$var$idStackIndex = 0, $407866112e362b76$var$treeContextProvider = null, $407866112e362b76$var$treeContextId = 1, $407866112e362b76$var$treeContextOverflow = "";
function $407866112e362b76$var$pushTreeFork(workInProgress, totalChildren) {
    $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex++] = $407866112e362b76$var$treeForkCount;
    $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex++] = $407866112e362b76$var$treeForkProvider;
    $407866112e362b76$var$treeForkProvider = workInProgress;
    $407866112e362b76$var$treeForkCount = totalChildren;
}
function $407866112e362b76$var$pushTreeId(workInProgress, totalChildren, index) {
    $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextId;
    $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextOverflow;
    $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextProvider;
    $407866112e362b76$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $407866112e362b76$var$treeContextId;
    workInProgress = $407866112e362b76$var$treeContextOverflow;
    var baseLength = 32 - $407866112e362b76$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $407866112e362b76$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $407866112e362b76$var$treeContextId = 1 << 32 - $407866112e362b76$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $407866112e362b76$var$treeContextOverflow = length + workInProgress;
    } else $407866112e362b76$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $407866112e362b76$var$treeContextOverflow = workInProgress;
}
function $407866112e362b76$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($407866112e362b76$var$pushTreeFork(workInProgress, 1), $407866112e362b76$var$pushTreeId(workInProgress, 1, 0));
}
function $407866112e362b76$var$popTreeContext(workInProgress) {
    for(; workInProgress === $407866112e362b76$var$treeForkProvider;)$407866112e362b76$var$treeForkProvider = $407866112e362b76$var$forkStack[--$407866112e362b76$var$forkStackIndex], $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex] = null, $407866112e362b76$var$treeForkCount = $407866112e362b76$var$forkStack[--$407866112e362b76$var$forkStackIndex], $407866112e362b76$var$forkStack[$407866112e362b76$var$forkStackIndex] = null;
    for(; workInProgress === $407866112e362b76$var$treeContextProvider;)$407866112e362b76$var$treeContextProvider = $407866112e362b76$var$idStack[--$407866112e362b76$var$idStackIndex], $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex] = null, $407866112e362b76$var$treeContextOverflow = $407866112e362b76$var$idStack[--$407866112e362b76$var$idStackIndex], $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex] = null, $407866112e362b76$var$treeContextId = $407866112e362b76$var$idStack[--$407866112e362b76$var$idStackIndex], $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex] = null;
}
var $407866112e362b76$var$hydrationParentFiber = null, $407866112e362b76$var$nextHydratableInstance = null, $407866112e362b76$var$isHydrating = !1, $407866112e362b76$var$hydrationErrors = null, $407866112e362b76$var$rootOrSingletonContext = !1, $407866112e362b76$var$HydrationMismatchException = Error($407866112e362b76$var$formatProdErrorMessage(519));
function $407866112e362b76$var$throwOnHydrationMismatch(fiber) {
    var error = Error($407866112e362b76$var$formatProdErrorMessage(418, ""));
    $407866112e362b76$var$queueHydrationError($407866112e362b76$var$createCapturedValueAtFiber(error, fiber));
    throw $407866112e362b76$var$HydrationMismatchException;
}
function $407866112e362b76$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$407866112e362b76$var$internalInstanceKey] = fiber;
    instance[$407866112e362b76$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $407866112e362b76$var$listenToNonDelegatedEvent("cancel", instance);
            $407866112e362b76$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $407866112e362b76$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $407866112e362b76$var$mediaEventTypes.length; type++)$407866112e362b76$var$listenToNonDelegatedEvent($407866112e362b76$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", instance);
            $407866112e362b76$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", instance);
            $407866112e362b76$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $407866112e362b76$var$track(instance);
            break;
        case "select":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", instance), $407866112e362b76$var$initTextarea(instance, props.value, props.defaultValue, props.children), $407866112e362b76$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $407866112e362b76$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($407866112e362b76$var$listenToNonDelegatedEvent("beforetoggle", instance), $407866112e362b76$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $407866112e362b76$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $407866112e362b76$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $407866112e362b76$var$noop$1), instance = !0) : instance = !1;
    instance || $407866112e362b76$var$throwOnHydrationMismatch(fiber);
}
function $407866112e362b76$var$popToNextHostParent(fiber) {
    for($407866112e362b76$var$hydrationParentFiber = fiber.return; $407866112e362b76$var$hydrationParentFiber;)switch($407866112e362b76$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $407866112e362b76$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $407866112e362b76$var$rootOrSingletonContext = !0;
            return;
        default:
            $407866112e362b76$var$hydrationParentFiber = $407866112e362b76$var$hydrationParentFiber.return;
    }
}
function $407866112e362b76$var$popHydrationState(fiber) {
    if (fiber !== $407866112e362b76$var$hydrationParentFiber) return !1;
    if (!$407866112e362b76$var$isHydrating) return $407866112e362b76$var$popToNextHostParent(fiber), $407866112e362b76$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $407866112e362b76$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $407866112e362b76$var$nextHydratableInstance && $407866112e362b76$var$throwOnHydrationMismatch(fiber);
    $407866112e362b76$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($407866112e362b76$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $407866112e362b76$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $407866112e362b76$var$nextHydratableInstance, $407866112e362b76$var$isSingletonScope(fiber.type) ? (fiber = $407866112e362b76$var$previousHydratableOnEnteringScopedSingleton, $407866112e362b76$var$previousHydratableOnEnteringScopedSingleton = null, $407866112e362b76$var$nextHydratableInstance = fiber) : $407866112e362b76$var$nextHydratableInstance = tag) : $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$hydrationParentFiber ? $407866112e362b76$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $407866112e362b76$var$resetHydrationState() {
    $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$hydrationParentFiber = null;
    $407866112e362b76$var$isHydrating = !1;
}
function $407866112e362b76$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $407866112e362b76$var$hydrationErrors;
    null !== queuedErrors && (null === $407866112e362b76$var$workInProgressRootRecoverableErrors ? $407866112e362b76$var$workInProgressRootRecoverableErrors = queuedErrors : $407866112e362b76$var$workInProgressRootRecoverableErrors.push.apply($407866112e362b76$var$workInProgressRootRecoverableErrors, queuedErrors), $407866112e362b76$var$hydrationErrors = null);
    return queuedErrors;
}
function $407866112e362b76$var$queueHydrationError(error) {
    null === $407866112e362b76$var$hydrationErrors ? $407866112e362b76$var$hydrationErrors = [
        error
    ] : $407866112e362b76$var$hydrationErrors.push(error);
}
var $407866112e362b76$var$valueCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$currentlyRenderingFiber$1 = null, $407866112e362b76$var$lastContextDependency = null;
function $407866112e362b76$var$pushProvider(providerFiber, context, nextValue) {
    $407866112e362b76$var$push($407866112e362b76$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $407866112e362b76$var$popProvider(context) {
    context._currentValue = $407866112e362b76$var$valueCursor.current;
    $407866112e362b76$var$pop($407866112e362b76$var$valueCursor);
}
function $407866112e362b76$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $407866112e362b76$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $407866112e362b76$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($407866112e362b76$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $407866112e362b76$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($407866112e362b76$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $407866112e362b76$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $407866112e362b76$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($407866112e362b76$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($407866112e362b76$var$HostTransitionContext) : current = [
                $407866112e362b76$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $407866112e362b76$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $407866112e362b76$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$407866112e362b76$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $407866112e362b76$var$prepareToReadContext(workInProgress) {
    $407866112e362b76$var$currentlyRenderingFiber$1 = workInProgress;
    $407866112e362b76$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $407866112e362b76$var$readContext(context) {
    return $407866112e362b76$var$readContextForConsumer($407866112e362b76$var$currentlyRenderingFiber$1, context);
}
function $407866112e362b76$var$readContextDuringReconciliation(consumer, context) {
    null === $407866112e362b76$var$currentlyRenderingFiber$1 && $407866112e362b76$var$prepareToReadContext(consumer);
    return $407866112e362b76$var$readContextForConsumer(consumer, context);
}
function $407866112e362b76$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $407866112e362b76$var$lastContextDependency) {
        if (null === consumer) throw Error($407866112e362b76$var$formatProdErrorMessage(308));
        $407866112e362b76$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$lastContextDependency.next = context;
    return value;
}
var $407866112e362b76$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $407866112e362b76$var$scheduleCallback$2 = $hNfVH.unstable_scheduleCallback, $407866112e362b76$var$NormalPriority = $hNfVH.unstable_NormalPriority, $407866112e362b76$var$CacheContext = {
    $$typeof: $407866112e362b76$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $407866112e362b76$var$createCache() {
    return {
        controller: new $407866112e362b76$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $407866112e362b76$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $407866112e362b76$var$scheduleCallback$2($407866112e362b76$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $407866112e362b76$var$currentEntangledListeners = null, $407866112e362b76$var$currentEntangledPendingCount = 0, $407866112e362b76$var$currentEntangledLane = 0, $407866112e362b76$var$currentEntangledActionThenable = null;
function $407866112e362b76$var$entangleAsyncAction(transition, thenable) {
    if (null === $407866112e362b76$var$currentEntangledListeners) {
        var entangledListeners = $407866112e362b76$var$currentEntangledListeners = [];
        $407866112e362b76$var$currentEntangledPendingCount = 0;
        $407866112e362b76$var$currentEntangledLane = $407866112e362b76$var$requestTransitionLane();
        $407866112e362b76$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $407866112e362b76$var$currentEntangledPendingCount++;
    thenable.then($407866112e362b76$var$pingEngtangledActionScope, $407866112e362b76$var$pingEngtangledActionScope);
    return thenable;
}
function $407866112e362b76$var$pingEngtangledActionScope() {
    if (0 === --$407866112e362b76$var$currentEntangledPendingCount && null !== $407866112e362b76$var$currentEntangledListeners) {
        null !== $407866112e362b76$var$currentEntangledActionThenable && ($407866112e362b76$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $407866112e362b76$var$currentEntangledListeners;
        $407866112e362b76$var$currentEntangledListeners = null;
        $407866112e362b76$var$currentEntangledLane = 0;
        $407866112e362b76$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $407866112e362b76$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $407866112e362b76$var$prevOnStartTransitionFinish = $407866112e362b76$var$ReactSharedInternals.S;
$407866112e362b76$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $407866112e362b76$var$entangleAsyncAction(transition, returnValue);
    null !== $407866112e362b76$var$prevOnStartTransitionFinish && $407866112e362b76$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $407866112e362b76$var$resumedCache = $407866112e362b76$var$createCursor(null);
function $407866112e362b76$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $407866112e362b76$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $407866112e362b76$var$workInProgressRoot.pooledCache;
}
function $407866112e362b76$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $407866112e362b76$var$push($407866112e362b76$var$resumedCache, $407866112e362b76$var$resumedCache.current) : $407866112e362b76$var$push($407866112e362b76$var$resumedCache, prevCachePool.pool);
}
function $407866112e362b76$var$getSuspendedCache() {
    var cacheFromPool = $407866112e362b76$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $407866112e362b76$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $407866112e362b76$var$SuspenseException = Error($407866112e362b76$var$formatProdErrorMessage(460)), $407866112e362b76$var$SuspenseyCommitException = Error($407866112e362b76$var$formatProdErrorMessage(474)), $407866112e362b76$var$SuspenseActionException = Error($407866112e362b76$var$formatProdErrorMessage(542)), $407866112e362b76$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $407866112e362b76$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $407866112e362b76$var$noop$3() {}
function $407866112e362b76$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($407866112e362b76$var$noop$3, $407866112e362b76$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $407866112e362b76$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($407866112e362b76$var$noop$3, $407866112e362b76$var$noop$3);
            else {
                thenableState = $407866112e362b76$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($407866112e362b76$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $407866112e362b76$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $407866112e362b76$var$suspendedThenable = thenable;
            throw $407866112e362b76$var$SuspenseException;
    }
}
var $407866112e362b76$var$suspendedThenable = null;
function $407866112e362b76$var$getSuspendedThenable() {
    if (null === $407866112e362b76$var$suspendedThenable) throw Error($407866112e362b76$var$formatProdErrorMessage(459));
    var thenable = $407866112e362b76$var$suspendedThenable;
    $407866112e362b76$var$suspendedThenable = null;
    return thenable;
}
function $407866112e362b76$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $407866112e362b76$var$SuspenseException || rejectedReason === $407866112e362b76$var$SuspenseActionException) throw Error($407866112e362b76$var$formatProdErrorMessage(483));
}
var $407866112e362b76$var$hasForceUpdate = !1;
function $407866112e362b76$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $407866112e362b76$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $407866112e362b76$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $407866112e362b76$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($407866112e362b76$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $407866112e362b76$var$getRootForUpdatedFiber(fiber);
        $407866112e362b76$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $407866112e362b76$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $407866112e362b76$var$getRootForUpdatedFiber(fiber);
}
function $407866112e362b76$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $407866112e362b76$var$markRootEntangled(root, lane);
    }
}
function $407866112e362b76$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $407866112e362b76$var$didReadFromEntangledAsyncAction = !1;
function $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($407866112e362b76$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $407866112e362b76$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $407866112e362b76$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $407866112e362b76$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $407866112e362b76$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($407866112e362b76$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $407866112e362b76$var$currentEntangledLane && ($407866112e362b76$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $407866112e362b76$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $407866112e362b76$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $407866112e362b76$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $407866112e362b76$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($407866112e362b76$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $407866112e362b76$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$407866112e362b76$var$callCallback(callbacks[updateQueue], context);
}
var $407866112e362b76$var$currentTreeHiddenStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$prevEntangledRenderLanesCursor = $407866112e362b76$var$createCursor(0);
function $407866112e362b76$var$pushHiddenContext(fiber, context) {
    fiber = $407866112e362b76$var$entangledRenderLanes;
    $407866112e362b76$var$push($407866112e362b76$var$prevEntangledRenderLanesCursor, fiber);
    $407866112e362b76$var$push($407866112e362b76$var$currentTreeHiddenStackCursor, context);
    $407866112e362b76$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $407866112e362b76$var$reuseHiddenContextOnStack() {
    $407866112e362b76$var$push($407866112e362b76$var$prevEntangledRenderLanesCursor, $407866112e362b76$var$entangledRenderLanes);
    $407866112e362b76$var$push($407866112e362b76$var$currentTreeHiddenStackCursor, $407866112e362b76$var$currentTreeHiddenStackCursor.current);
}
function $407866112e362b76$var$popHiddenContext() {
    $407866112e362b76$var$entangledRenderLanes = $407866112e362b76$var$prevEntangledRenderLanesCursor.current;
    $407866112e362b76$var$pop($407866112e362b76$var$currentTreeHiddenStackCursor);
    $407866112e362b76$var$pop($407866112e362b76$var$prevEntangledRenderLanesCursor);
}
var $407866112e362b76$var$renderLanes = 0, $407866112e362b76$var$currentlyRenderingFiber = null, $407866112e362b76$var$currentHook = null, $407866112e362b76$var$workInProgressHook = null, $407866112e362b76$var$didScheduleRenderPhaseUpdate = !1, $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $407866112e362b76$var$localIdCounter = 0, $407866112e362b76$var$thenableIndexCounter$1 = 0, $407866112e362b76$var$thenableState$1 = null, $407866112e362b76$var$globalClientIdCounter = 0;
function $407866112e362b76$var$throwInvalidHookError() {
    throw Error($407866112e362b76$var$formatProdErrorMessage(321));
}
function $407866112e362b76$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$407866112e362b76$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $407866112e362b76$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $407866112e362b76$var$renderLanes = nextRenderLanes;
    $407866112e362b76$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $407866112e362b76$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $407866112e362b76$var$HooksDispatcherOnMount : $407866112e362b76$var$HooksDispatcherOnUpdate;
    $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $407866112e362b76$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $407866112e362b76$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $407866112e362b76$var$finishRenderingHooks(current) {
    $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $407866112e362b76$var$currentHook && null !== $407866112e362b76$var$currentHook.next;
    $407866112e362b76$var$renderLanes = 0;
    $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$currentHook = $407866112e362b76$var$currentlyRenderingFiber = null;
    $407866112e362b76$var$didScheduleRenderPhaseUpdate = !1;
    $407866112e362b76$var$thenableIndexCounter$1 = 0;
    $407866112e362b76$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($407866112e362b76$var$formatProdErrorMessage(300));
    null === current || $407866112e362b76$var$didReceiveUpdate || (current = current.dependencies, null !== current && $407866112e362b76$var$checkIfContextChanged(current) && ($407866112e362b76$var$didReceiveUpdate = !0));
}
function $407866112e362b76$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $407866112e362b76$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass && ($407866112e362b76$var$thenableState$1 = null);
        $407866112e362b76$var$thenableIndexCounter$1 = 0;
        $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($407866112e362b76$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $407866112e362b76$var$TransitionAwareHostComponent() {
    var dispatcher = $407866112e362b76$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $407866112e362b76$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $407866112e362b76$var$currentHook ? $407866112e362b76$var$currentHook.memoizedState : null) !== dispatcher && ($407866112e362b76$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $407866112e362b76$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $407866112e362b76$var$localIdCounter;
    $407866112e362b76$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $407866112e362b76$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $407866112e362b76$var$resetHooksOnUnwind(workInProgress) {
    if ($407866112e362b76$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $407866112e362b76$var$didScheduleRenderPhaseUpdate = !1;
    }
    $407866112e362b76$var$renderLanes = 0;
    $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$currentHook = $407866112e362b76$var$currentlyRenderingFiber = null;
    $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $407866112e362b76$var$thenableIndexCounter$1 = $407866112e362b76$var$localIdCounter = 0;
    $407866112e362b76$var$thenableState$1 = null;
}
function $407866112e362b76$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $407866112e362b76$var$workInProgressHook ? $407866112e362b76$var$currentlyRenderingFiber.memoizedState = $407866112e362b76$var$workInProgressHook = hook : $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$workInProgressHook.next = hook;
    return $407866112e362b76$var$workInProgressHook;
}
function $407866112e362b76$var$updateWorkInProgressHook() {
    if (null === $407866112e362b76$var$currentHook) {
        var nextCurrentHook = $407866112e362b76$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $407866112e362b76$var$currentHook.next;
    var nextWorkInProgressHook = null === $407866112e362b76$var$workInProgressHook ? $407866112e362b76$var$currentlyRenderingFiber.memoizedState : $407866112e362b76$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $407866112e362b76$var$workInProgressHook = nextWorkInProgressHook, $407866112e362b76$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $407866112e362b76$var$currentlyRenderingFiber.alternate) throw Error($407866112e362b76$var$formatProdErrorMessage(467));
            throw Error($407866112e362b76$var$formatProdErrorMessage(310));
        }
        $407866112e362b76$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $407866112e362b76$var$currentHook.memoizedState,
            baseState: $407866112e362b76$var$currentHook.baseState,
            baseQueue: $407866112e362b76$var$currentHook.baseQueue,
            queue: $407866112e362b76$var$currentHook.queue,
            next: null
        };
        null === $407866112e362b76$var$workInProgressHook ? $407866112e362b76$var$currentlyRenderingFiber.memoizedState = $407866112e362b76$var$workInProgressHook = nextCurrentHook : $407866112e362b76$var$workInProgressHook = $407866112e362b76$var$workInProgressHook.next = nextCurrentHook;
    }
    return $407866112e362b76$var$workInProgressHook;
}
function $407866112e362b76$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $407866112e362b76$var$useThenable(thenable) {
    var index = $407866112e362b76$var$thenableIndexCounter$1;
    $407866112e362b76$var$thenableIndexCounter$1 += 1;
    null === $407866112e362b76$var$thenableState$1 && ($407866112e362b76$var$thenableState$1 = []);
    thenable = $407866112e362b76$var$trackUsedThenable($407866112e362b76$var$thenableState$1, thenable, index);
    index = $407866112e362b76$var$currentlyRenderingFiber;
    null === (null === $407866112e362b76$var$workInProgressHook ? index.memoizedState : $407866112e362b76$var$workInProgressHook.next) && (index = index.alternate, $407866112e362b76$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $407866112e362b76$var$HooksDispatcherOnMount : $407866112e362b76$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $407866112e362b76$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $407866112e362b76$var$useThenable(usable);
        if (usable.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return $407866112e362b76$var$readContext(usable);
    }
    throw Error($407866112e362b76$var$formatProdErrorMessage(438, String(usable)));
}
function $407866112e362b76$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $407866112e362b76$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $407866112e362b76$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $407866112e362b76$var$createFunctionComponentUpdateQueue(), $407866112e362b76$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $407866112e362b76$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $407866112e362b76$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $407866112e362b76$var$updateReducer(reducer) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    return $407866112e362b76$var$updateReducerImpl(hook, $407866112e362b76$var$currentHook, reducer);
}
function $407866112e362b76$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($407866112e362b76$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($407866112e362b76$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($407866112e362b76$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $407866112e362b76$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($407866112e362b76$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $407866112e362b76$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $407866112e362b76$var$currentlyRenderingFiber.lanes |= revertLane, $407866112e362b76$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $407866112e362b76$var$currentlyRenderingFiber.lanes |= updateLane, $407866112e362b76$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$407866112e362b76$var$objectIs(pendingQueue, hook.memoizedState) && ($407866112e362b76$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $407866112e362b76$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $407866112e362b76$var$rerenderReducer(reducer) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($407866112e362b76$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $407866112e362b76$var$objectIs(newState, hook.memoizedState) || ($407866112e362b76$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $407866112e362b76$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $407866112e362b76$var$currentlyRenderingFiber, hook = $407866112e362b76$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $407866112e362b76$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($407866112e362b76$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$407866112e362b76$var$objectIs(($407866112e362b76$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $407866112e362b76$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $407866112e362b76$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $407866112e362b76$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $407866112e362b76$var$workInProgressHook && $407866112e362b76$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $407866112e362b76$var$pushSimpleEffect(9, $407866112e362b76$var$createEffectInstance(), $407866112e362b76$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $407866112e362b76$var$workInProgressRoot) throw Error($407866112e362b76$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($407866112e362b76$var$renderLanes & 124) || $407866112e362b76$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $407866112e362b76$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $407866112e362b76$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $407866112e362b76$var$createFunctionComponentUpdateQueue(), $407866112e362b76$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $407866112e362b76$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $407866112e362b76$var$checkIfSnapshotChanged(inst) && $407866112e362b76$var$forceStoreRerender(fiber);
}
function $407866112e362b76$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $407866112e362b76$var$checkIfSnapshotChanged(inst) && $407866112e362b76$var$forceStoreRerender(fiber);
    });
}
function $407866112e362b76$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$407866112e362b76$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $407866112e362b76$var$forceStoreRerender(fiber) {
    var root = $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $407866112e362b76$var$mountStateImpl(initialState) {
    var hook = $407866112e362b76$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $407866112e362b76$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $407866112e362b76$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $407866112e362b76$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $407866112e362b76$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $407866112e362b76$var$updateReducerImpl(hook, $407866112e362b76$var$currentHook, "function" === typeof reducer ? reducer : $407866112e362b76$var$basicStateReducer);
}
function $407866112e362b76$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($407866112e362b76$var$isRenderPhaseUpdate(fiber)) throw Error($407866112e362b76$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $407866112e362b76$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $407866112e362b76$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $407866112e362b76$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $407866112e362b76$var$ReactSharedInternals.T, currentTransition = {};
        $407866112e362b76$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $407866112e362b76$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $407866112e362b76$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $407866112e362b76$var$onActionError(actionQueue, node, error);
        } finally{
            $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $407866112e362b76$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $407866112e362b76$var$onActionError(actionQueue, node, error$38);
    }
}
function $407866112e362b76$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $407866112e362b76$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $407866112e362b76$var$onActionError(actionQueue, node, error);
    }) : $407866112e362b76$var$onActionSuccess(actionQueue, node, returnValue);
}
function $407866112e362b76$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $407866112e362b76$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $407866112e362b76$var$runActionStateAction(actionQueue, nextState)));
}
function $407866112e362b76$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $407866112e362b76$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $407866112e362b76$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $407866112e362b76$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $407866112e362b76$var$mountActionState(action, initialStateProp) {
    if ($407866112e362b76$var$isHydrating) {
        var ssrFormState = $407866112e362b76$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $407866112e362b76$var$currentlyRenderingFiber;
                if ($407866112e362b76$var$isHydrating) {
                    if ($407866112e362b76$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $407866112e362b76$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $407866112e362b76$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $407866112e362b76$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $407866112e362b76$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $407866112e362b76$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $407866112e362b76$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $407866112e362b76$var$dispatchSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $407866112e362b76$var$mountStateImpl(!1);
    inRootOrSingleton = $407866112e362b76$var$dispatchOptimisticSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $407866112e362b76$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $407866112e362b76$var$dispatchActionState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $407866112e362b76$var$updateActionState(action) {
    var stateHook = $407866112e362b76$var$updateWorkInProgressHook();
    return $407866112e362b76$var$updateActionStateImpl(stateHook, $407866112e362b76$var$currentHook, action);
}
function $407866112e362b76$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $407866112e362b76$var$updateReducerImpl(stateHook, currentStateHook, $407866112e362b76$var$actionStateReducer)[0];
    stateHook = $407866112e362b76$var$updateReducer($407866112e362b76$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $407866112e362b76$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $407866112e362b76$var$SuspenseException) throw $407866112e362b76$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $407866112e362b76$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($407866112e362b76$var$currentlyRenderingFiber.flags |= 2048, $407866112e362b76$var$pushSimpleEffect(9, $407866112e362b76$var$createEffectInstance(), $407866112e362b76$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $407866112e362b76$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $407866112e362b76$var$rerenderActionState(action) {
    var stateHook = $407866112e362b76$var$updateWorkInProgressHook(), currentStateHook = $407866112e362b76$var$currentHook;
    if (null !== currentStateHook) return $407866112e362b76$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $407866112e362b76$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $407866112e362b76$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $407866112e362b76$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $407866112e362b76$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $407866112e362b76$var$createFunctionComponentUpdateQueue(), $407866112e362b76$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $407866112e362b76$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $407866112e362b76$var$updateRef() {
    return $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
}
function $407866112e362b76$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $407866112e362b76$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $407866112e362b76$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $407866112e362b76$var$pushSimpleEffect(1 | hookFlags, $407866112e362b76$var$createEffectInstance(), create, createDeps);
}
function $407866112e362b76$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $407866112e362b76$var$currentHook && null !== deps && $407866112e362b76$var$areHookInputsEqual(deps, $407866112e362b76$var$currentHook.memoizedState.deps) ? hook.memoizedState = $407866112e362b76$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($407866112e362b76$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $407866112e362b76$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $407866112e362b76$var$mountEffect(create, createDeps) {
    $407866112e362b76$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $407866112e362b76$var$updateEffect(create, createDeps) {
    $407866112e362b76$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $407866112e362b76$var$updateInsertionEffect(create, deps) {
    return $407866112e362b76$var$updateEffectImpl(4, 2, create, deps);
}
function $407866112e362b76$var$updateLayoutEffect(create, deps) {
    return $407866112e362b76$var$updateEffectImpl(4, 4, create, deps);
}
function $407866112e362b76$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $407866112e362b76$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $407866112e362b76$var$updateEffectImpl(4, 4, $407866112e362b76$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $407866112e362b76$var$mountDebugValue() {}
function $407866112e362b76$var$updateCallback(callback, deps) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $407866112e362b76$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $407866112e362b76$var$updateMemo(nextCreate, deps) {
    var hook = $407866112e362b76$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $407866112e362b76$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $407866112e362b76$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $407866112e362b76$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($407866112e362b76$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $407866112e362b76$var$requestDeferredLane();
    $407866112e362b76$var$currentlyRenderingFiber.lanes |= hook;
    $407866112e362b76$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $407866112e362b76$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($407866112e362b76$var$objectIs(value, prevValue)) return value;
    if (null !== $407866112e362b76$var$currentTreeHiddenStackCursor.current) return hook = $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue), $407866112e362b76$var$objectIs(hook, prevValue) || ($407866112e362b76$var$didReceiveUpdate = !0), hook;
    if (0 === ($407866112e362b76$var$renderLanes & 42)) return $407866112e362b76$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $407866112e362b76$var$requestDeferredLane();
    $407866112e362b76$var$currentlyRenderingFiber.lanes |= hook;
    $407866112e362b76$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $407866112e362b76$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    $407866112e362b76$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $407866112e362b76$var$ReactSharedInternals.T, currentTransition = {};
    $407866112e362b76$var$ReactSharedInternals.T = currentTransition;
    $407866112e362b76$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $407866112e362b76$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $407866112e362b76$var$chainThenableValue(returnValue, finishedState);
            $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $407866112e362b76$var$requestUpdateLane(fiber));
        } else $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, finishedState, $407866112e362b76$var$requestUpdateLane(fiber));
    } catch (error) {
        $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $407866112e362b76$var$requestUpdateLane());
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
    }
}
function $407866112e362b76$var$noop$2() {}
function $407866112e362b76$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($407866112e362b76$var$formatProdErrorMessage(476));
    var queue = $407866112e362b76$var$ensureFormComponentIsStateful(formFiber).queue;
    $407866112e362b76$var$startTransition(formFiber, queue, pendingState, $407866112e362b76$var$sharedNotPendingObject, null === action ? $407866112e362b76$var$noop$2 : function() {
        $407866112e362b76$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $407866112e362b76$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $407866112e362b76$var$sharedNotPendingObject,
        baseState: $407866112e362b76$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $407866112e362b76$var$basicStateReducer,
            lastRenderedState: $407866112e362b76$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $407866112e362b76$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $407866112e362b76$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $407866112e362b76$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $407866112e362b76$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $407866112e362b76$var$requestUpdateLane());
}
function $407866112e362b76$var$useHostTransitionStatus() {
    return $407866112e362b76$var$readContext($407866112e362b76$var$HostTransitionContext);
}
function $407866112e362b76$var$updateId() {
    return $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
}
function $407866112e362b76$var$updateRefresh() {
    return $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
}
function $407866112e362b76$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $407866112e362b76$var$requestUpdateLane();
                fiber = $407866112e362b76$var$createUpdate(lane);
                var root$41 = $407866112e362b76$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($407866112e362b76$var$scheduleUpdateOnFiber(root$41, provider, lane), $407866112e362b76$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $407866112e362b76$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $407866112e362b76$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $407866112e362b76$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $407866112e362b76$var$isRenderPhaseUpdate(fiber) ? $407866112e362b76$var$enqueueRenderPhaseUpdate(queue, action) : (action = $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($407866112e362b76$var$scheduleUpdateOnFiber(action, fiber, lane), $407866112e362b76$var$entangleTransitionUpdate(action, queue, lane)));
}
function $407866112e362b76$var$dispatchSetState(fiber, queue, action) {
    var lane = $407866112e362b76$var$requestUpdateLane();
    $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $407866112e362b76$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($407866112e362b76$var$isRenderPhaseUpdate(fiber)) $407866112e362b76$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($407866112e362b76$var$objectIs(eagerState, currentState)) return $407866112e362b76$var$enqueueUpdate$1(fiber, queue, update, 0), null === $407866112e362b76$var$workInProgressRoot && $407866112e362b76$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $407866112e362b76$var$scheduleUpdateOnFiber(action, fiber, lane), $407866112e362b76$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $407866112e362b76$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $407866112e362b76$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($407866112e362b76$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($407866112e362b76$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $407866112e362b76$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $407866112e362b76$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $407866112e362b76$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $407866112e362b76$var$currentlyRenderingFiber || null !== alternate && alternate === $407866112e362b76$var$currentlyRenderingFiber;
}
function $407866112e362b76$var$enqueueRenderPhaseUpdate(queue, update) {
    $407866112e362b76$var$didScheduleRenderPhaseUpdateDuringThisPass = $407866112e362b76$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $407866112e362b76$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $407866112e362b76$var$markRootEntangled(root, lane);
    }
}
var $407866112e362b76$var$ContextOnlyDispatcher = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: $407866112e362b76$var$throwInvalidHookError,
    useContext: $407866112e362b76$var$throwInvalidHookError,
    useEffect: $407866112e362b76$var$throwInvalidHookError,
    useImperativeHandle: $407866112e362b76$var$throwInvalidHookError,
    useLayoutEffect: $407866112e362b76$var$throwInvalidHookError,
    useInsertionEffect: $407866112e362b76$var$throwInvalidHookError,
    useMemo: $407866112e362b76$var$throwInvalidHookError,
    useReducer: $407866112e362b76$var$throwInvalidHookError,
    useRef: $407866112e362b76$var$throwInvalidHookError,
    useState: $407866112e362b76$var$throwInvalidHookError,
    useDebugValue: $407866112e362b76$var$throwInvalidHookError,
    useDeferredValue: $407866112e362b76$var$throwInvalidHookError,
    useTransition: $407866112e362b76$var$throwInvalidHookError,
    useSyncExternalStore: $407866112e362b76$var$throwInvalidHookError,
    useId: $407866112e362b76$var$throwInvalidHookError,
    useHostTransitionStatus: $407866112e362b76$var$throwInvalidHookError,
    useFormState: $407866112e362b76$var$throwInvalidHookError,
    useActionState: $407866112e362b76$var$throwInvalidHookError,
    useOptimistic: $407866112e362b76$var$throwInvalidHookError,
    useMemoCache: $407866112e362b76$var$throwInvalidHookError,
    useCacheRefresh: $407866112e362b76$var$throwInvalidHookError
}, $407866112e362b76$var$HooksDispatcherOnMount = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: function(callback, deps) {
        $407866112e362b76$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $407866112e362b76$var$readContext,
    useEffect: $407866112e362b76$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $407866112e362b76$var$mountEffectImpl(4194308, 4, $407866112e362b76$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $407866112e362b76$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $407866112e362b76$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $407866112e362b76$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $407866112e362b76$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($407866112e362b76$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $407866112e362b76$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $407866112e362b76$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $407866112e362b76$var$dispatchReducerAction.bind(null, $407866112e362b76$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $407866112e362b76$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $407866112e362b76$var$dispatchSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $407866112e362b76$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        return $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $407866112e362b76$var$mountStateImpl(!1);
        stateHook = $407866112e362b76$var$startTransition.bind(null, $407866112e362b76$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $407866112e362b76$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $407866112e362b76$var$currentlyRenderingFiber, hook = $407866112e362b76$var$mountWorkInProgressHook();
        if ($407866112e362b76$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($407866112e362b76$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $407866112e362b76$var$workInProgressRoot) throw Error($407866112e362b76$var$formatProdErrorMessage(349));
            0 !== ($407866112e362b76$var$workInProgressRootRenderLanes & 124) || $407866112e362b76$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $407866112e362b76$var$mountEffect($407866112e362b76$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $407866112e362b76$var$pushSimpleEffect(9, $407866112e362b76$var$createEffectInstance(), $407866112e362b76$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $407866112e362b76$var$mountWorkInProgressHook(), identifierPrefix = $407866112e362b76$var$workInProgressRoot.identifierPrefix;
        if ($407866112e362b76$var$isHydrating) {
            var JSCompiler_inline_result = $407866112e362b76$var$treeContextOverflow;
            var idWithLeadingBit = $407866112e362b76$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $407866112e362b76$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $407866112e362b76$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $407866112e362b76$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $407866112e362b76$var$useHostTransitionStatus,
    useFormState: $407866112e362b76$var$mountActionState,
    useActionState: $407866112e362b76$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $407866112e362b76$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $407866112e362b76$var$dispatchOptimisticSetState.bind(null, $407866112e362b76$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $407866112e362b76$var$useMemoCache,
    useCacheRefresh: function() {
        return $407866112e362b76$var$mountWorkInProgressHook().memoizedState = $407866112e362b76$var$refreshCache.bind(null, $407866112e362b76$var$currentlyRenderingFiber);
    }
}, $407866112e362b76$var$HooksDispatcherOnUpdate = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: $407866112e362b76$var$updateCallback,
    useContext: $407866112e362b76$var$readContext,
    useEffect: $407866112e362b76$var$updateEffect,
    useImperativeHandle: $407866112e362b76$var$updateImperativeHandle,
    useInsertionEffect: $407866112e362b76$var$updateInsertionEffect,
    useLayoutEffect: $407866112e362b76$var$updateLayoutEffect,
    useMemo: $407866112e362b76$var$updateMemo,
    useReducer: $407866112e362b76$var$updateReducer,
    useRef: $407866112e362b76$var$updateRef,
    useState: function() {
        return $407866112e362b76$var$updateReducer($407866112e362b76$var$basicStateReducer);
    },
    useDebugValue: $407866112e362b76$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        return $407866112e362b76$var$updateDeferredValueImpl(hook, $407866112e362b76$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $407866112e362b76$var$updateReducer($407866112e362b76$var$basicStateReducer)[0], start = $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $407866112e362b76$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $407866112e362b76$var$updateSyncExternalStore,
    useId: $407866112e362b76$var$updateId,
    useHostTransitionStatus: $407866112e362b76$var$useHostTransitionStatus,
    useFormState: $407866112e362b76$var$updateActionState,
    useActionState: $407866112e362b76$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        return $407866112e362b76$var$updateOptimisticImpl(hook, $407866112e362b76$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $407866112e362b76$var$useMemoCache,
    useCacheRefresh: $407866112e362b76$var$updateRefresh
}, $407866112e362b76$var$HooksDispatcherOnRerender = {
    readContext: $407866112e362b76$var$readContext,
    use: $407866112e362b76$var$use,
    useCallback: $407866112e362b76$var$updateCallback,
    useContext: $407866112e362b76$var$readContext,
    useEffect: $407866112e362b76$var$updateEffect,
    useImperativeHandle: $407866112e362b76$var$updateImperativeHandle,
    useInsertionEffect: $407866112e362b76$var$updateInsertionEffect,
    useLayoutEffect: $407866112e362b76$var$updateLayoutEffect,
    useMemo: $407866112e362b76$var$updateMemo,
    useReducer: $407866112e362b76$var$rerenderReducer,
    useRef: $407866112e362b76$var$updateRef,
    useState: function() {
        return $407866112e362b76$var$rerenderReducer($407866112e362b76$var$basicStateReducer);
    },
    useDebugValue: $407866112e362b76$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        return null === $407866112e362b76$var$currentHook ? $407866112e362b76$var$mountDeferredValueImpl(hook, value, initialValue) : $407866112e362b76$var$updateDeferredValueImpl(hook, $407866112e362b76$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $407866112e362b76$var$rerenderReducer($407866112e362b76$var$basicStateReducer)[0], start = $407866112e362b76$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $407866112e362b76$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $407866112e362b76$var$updateSyncExternalStore,
    useId: $407866112e362b76$var$updateId,
    useHostTransitionStatus: $407866112e362b76$var$useHostTransitionStatus,
    useFormState: $407866112e362b76$var$rerenderActionState,
    useActionState: $407866112e362b76$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $407866112e362b76$var$updateWorkInProgressHook();
        if (null !== $407866112e362b76$var$currentHook) return $407866112e362b76$var$updateOptimisticImpl(hook, $407866112e362b76$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $407866112e362b76$var$useMemoCache,
    useCacheRefresh: $407866112e362b76$var$updateRefresh
}, $407866112e362b76$var$thenableState = null, $407866112e362b76$var$thenableIndexCounter = 0;
function $407866112e362b76$var$unwrapThenable(thenable) {
    var index = $407866112e362b76$var$thenableIndexCounter;
    $407866112e362b76$var$thenableIndexCounter += 1;
    null === $407866112e362b76$var$thenableState && ($407866112e362b76$var$thenableState = []);
    return $407866112e362b76$var$trackUsedThenable($407866112e362b76$var$thenableState, thenable, index);
}
function $407866112e362b76$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $407866112e362b76$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($407866112e362b76$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($407866112e362b76$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $407866112e362b76$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $407866112e362b76$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $407866112e362b76$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $407866112e362b76$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $407866112e362b76$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $407866112e362b76$var$REACT_LAZY_TYPE && $407866112e362b76$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $407866112e362b76$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $407866112e362b76$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $407866112e362b76$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $407866112e362b76$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $407866112e362b76$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $407866112e362b76$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    return lanes = $407866112e362b76$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $407866112e362b76$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    return newChild = $407866112e362b76$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild) || $407866112e362b76$var$getIteratorFn(newChild)) return newChild = $407866112e362b76$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild) || $407866112e362b76$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild) || $407866112e362b76$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($407866112e362b76$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $407866112e362b76$var$isHydrating && $407866112e362b76$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $407866112e362b76$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $407866112e362b76$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $407866112e362b76$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $407866112e362b76$var$REACT_LAZY_TYPE && $407866112e362b76$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $407866112e362b76$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $407866112e362b76$var$REACT_FRAGMENT_TYPE ? (lanes = $407866112e362b76$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $407866112e362b76$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $407866112e362b76$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $407866112e362b76$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $407866112e362b76$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $407866112e362b76$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($407866112e362b76$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($407866112e362b76$var$getIteratorFn(newChild)) {
                key = $407866112e362b76$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($407866112e362b76$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $407866112e362b76$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $407866112e362b76$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $407866112e362b76$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $407866112e362b76$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $407866112e362b76$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $407866112e362b76$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $407866112e362b76$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $407866112e362b76$var$SuspenseException || x === $407866112e362b76$var$SuspenseActionException) throw x;
            var fiber = $407866112e362b76$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $407866112e362b76$var$reconcileChildFibers = $407866112e362b76$var$createChildReconciler(!0), $407866112e362b76$var$mountChildFibers = $407866112e362b76$var$createChildReconciler(!1), $407866112e362b76$var$suspenseHandlerStackCursor = $407866112e362b76$var$createCursor(null), $407866112e362b76$var$shellBoundary = null;
function $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current & 1);
    $407866112e362b76$var$push($407866112e362b76$var$suspenseHandlerStackCursor, handler);
    null === $407866112e362b76$var$shellBoundary && (null === current || null !== $407866112e362b76$var$currentTreeHiddenStackCursor.current ? $407866112e362b76$var$shellBoundary = handler : null !== current.memoizedState && ($407866112e362b76$var$shellBoundary = handler));
}
function $407866112e362b76$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current), $407866112e362b76$var$push($407866112e362b76$var$suspenseHandlerStackCursor, fiber), null === $407866112e362b76$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($407866112e362b76$var$shellBoundary = fiber);
        }
    } else $407866112e362b76$var$reuseSuspenseHandlerOnStack(fiber);
}
function $407866112e362b76$var$reuseSuspenseHandlerOnStack() {
    $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current);
    $407866112e362b76$var$push($407866112e362b76$var$suspenseHandlerStackCursor, $407866112e362b76$var$suspenseHandlerStackCursor.current);
}
function $407866112e362b76$var$popSuspenseHandler(fiber) {
    $407866112e362b76$var$pop($407866112e362b76$var$suspenseHandlerStackCursor);
    $407866112e362b76$var$shellBoundary === fiber && ($407866112e362b76$var$shellBoundary = null);
    $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor);
}
var $407866112e362b76$var$suspenseStackCursor = $407866112e362b76$var$createCursor(0);
function $407866112e362b76$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $407866112e362b76$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $407866112e362b76$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $407866112e362b76$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $407866112e362b76$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $407866112e362b76$var$requestUpdateLane(), update = $407866112e362b76$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $407866112e362b76$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($407866112e362b76$var$scheduleUpdateOnFiber(payload, inst, lane), $407866112e362b76$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $407866112e362b76$var$requestUpdateLane(), update = $407866112e362b76$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $407866112e362b76$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($407866112e362b76$var$scheduleUpdateOnFiber(payload, inst, lane), $407866112e362b76$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $407866112e362b76$var$requestUpdateLane(), update = $407866112e362b76$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $407866112e362b76$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($407866112e362b76$var$scheduleUpdateOnFiber(callback, inst, lane), $407866112e362b76$var$entangleTransitions(callback, inst, lane));
    }
};
function $407866112e362b76$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$407866112e362b76$var$shallowEqual(oldProps, newProps) || !$407866112e362b76$var$shallowEqual(oldState, newState) : !0;
}
function $407866112e362b76$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $407866112e362b76$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $407866112e362b76$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $407866112e362b76$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $407866112e362b76$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $407866112e362b76$var$defaultOnUncaughtError(error) {
    $407866112e362b76$var$reportGlobalError(error);
}
function $407866112e362b76$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $407866112e362b76$var$defaultOnRecoverableError(error) {
    $407866112e362b76$var$reportGlobalError(error);
}
function $407866112e362b76$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $407866112e362b76$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $407866112e362b76$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $407866112e362b76$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $407866112e362b76$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $407866112e362b76$var$createClassErrorUpdate(lane) {
    lane = $407866112e362b76$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $407866112e362b76$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $407866112e362b76$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $407866112e362b76$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed ? $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $407866112e362b76$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $407866112e362b76$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $407866112e362b76$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $407866112e362b76$var$shellBoundary ? $407866112e362b76$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $407866112e362b76$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $407866112e362b76$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $407866112e362b76$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $407866112e362b76$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($407866112e362b76$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $407866112e362b76$var$attachPingListener(root, value, rootRenderLanes);
        $407866112e362b76$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($407866112e362b76$var$isHydrating) return returnFiber = $407866112e362b76$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $407866112e362b76$var$HydrationMismatchException && (root = Error($407866112e362b76$var$formatProdErrorMessage(422), {
        cause: value
    }), $407866112e362b76$var$queueHydrationError($407866112e362b76$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $407866112e362b76$var$HydrationMismatchException && (returnFiber = Error($407866112e362b76$var$formatProdErrorMessage(423), {
        cause: value
    }), $407866112e362b76$var$queueHydrationError($407866112e362b76$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $407866112e362b76$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $407866112e362b76$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $407866112e362b76$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($407866112e362b76$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $407866112e362b76$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $407866112e362b76$var$workInProgressRootConcurrentErrors ? $407866112e362b76$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $407866112e362b76$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $407866112e362b76$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $407866112e362b76$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $407866112e362b76$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed || !$407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $407866112e362b76$var$createClassErrorUpdate(rootRenderLanes), $407866112e362b76$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $407866112e362b76$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $407866112e362b76$var$SelectiveHydrationException = Error($407866112e362b76$var$formatProdErrorMessage(461)), $407866112e362b76$var$didReceiveUpdate = !1;
function $407866112e362b76$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $407866112e362b76$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $407866112e362b76$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    nextProps = $407866112e362b76$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $407866112e362b76$var$checkDidRenderIdHook();
    if (null !== current && !$407866112e362b76$var$didReceiveUpdate) return $407866112e362b76$var$bailoutHooks(current, workInProgress, renderLanes), $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $407866112e362b76$var$isHydrating && key && $407866112e362b76$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$407866112e362b76$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $407866112e362b76$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $407866112e362b76$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $407866112e362b76$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $407866112e362b76$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $407866112e362b76$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($407866112e362b76$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($407866112e362b76$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($407866112e362b76$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $407866112e362b76$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $407866112e362b76$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $407866112e362b76$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $407866112e362b76$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $407866112e362b76$var$pushHiddenContext(workInProgress, prevState) : $407866112e362b76$var$reuseHiddenContextOnStack(), $407866112e362b76$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $407866112e362b76$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($407866112e362b76$var$pushTransition(workInProgress, prevState.cachePool), $407866112e362b76$var$pushHiddenContext(workInProgress, prevState), $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $407866112e362b76$var$pushTransition(workInProgress, null), $407866112e362b76$var$reuseHiddenContextOnStack(), $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress));
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $407866112e362b76$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $407866112e362b76$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $407866112e362b76$var$pushTransition(workInProgress, null);
    $407866112e362b76$var$reuseHiddenContextOnStack();
    $407866112e362b76$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $407866112e362b76$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($407866112e362b76$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $407866112e362b76$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    Component = $407866112e362b76$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $407866112e362b76$var$checkDidRenderIdHook();
    if (null !== current && !$407866112e362b76$var$didReceiveUpdate) return $407866112e362b76$var$bailoutHooks(current, workInProgress, renderLanes), $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $407866112e362b76$var$isHydrating && nextProps && $407866112e362b76$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $407866112e362b76$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $407866112e362b76$var$finishRenderingHooks(current);
    Component = $407866112e362b76$var$checkDidRenderIdHook();
    if (null !== current && !$407866112e362b76$var$didReceiveUpdate) return $407866112e362b76$var$bailoutHooks(current, workInProgress, renderLanes), $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $407866112e362b76$var$isHydrating && Component && $407866112e362b76$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $407866112e362b76$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $407866112e362b76$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $407866112e362b76$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $407866112e362b76$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $407866112e362b76$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $407866112e362b76$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $407866112e362b76$var$readContext(contextType) : $407866112e362b76$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($407866112e362b76$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $407866112e362b76$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $407866112e362b76$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $407866112e362b76$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $407866112e362b76$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $407866112e362b76$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $407866112e362b76$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $407866112e362b76$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $407866112e362b76$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $407866112e362b76$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($407866112e362b76$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $407866112e362b76$var$hasForceUpdate || $407866112e362b76$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $407866112e362b76$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $407866112e362b76$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $407866112e362b76$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $407866112e362b76$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $407866112e362b76$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $407866112e362b76$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $407866112e362b76$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $407866112e362b76$var$hasForceUpdate || null !== current && null !== current.dependencies && $407866112e362b76$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($407866112e362b76$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $407866112e362b76$var$hasForceUpdate || $407866112e362b76$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $407866112e362b76$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $407866112e362b76$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $407866112e362b76$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $407866112e362b76$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $407866112e362b76$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $407866112e362b76$var$resetHydrationState();
    workInProgress.flags |= 256;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $407866112e362b76$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $407866112e362b76$var$getSuspendedCache()
    };
}
function $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $407866112e362b76$var$workInProgressDeferredLane);
    return current;
}
function $407866112e362b76$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($407866112e362b76$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($407866112e362b76$var$isHydrating) {
            showFallback ? $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($407866112e362b76$var$isHydrating) {
                var nextInstance = $407866112e362b76$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $407866112e362b76$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $407866112e362b76$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $407866112e362b76$var$treeContextProvider ? {
                            id: $407866112e362b76$var$treeContextId,
                            overflow: $407866112e362b76$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $407866112e362b76$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $407866112e362b76$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $407866112e362b76$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $407866112e362b76$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $407866112e362b76$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $407866112e362b76$var$SUSPENDED_MARKER, nextProps;
        $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $407866112e362b76$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $407866112e362b76$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $407866112e362b76$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress), $407866112e362b76$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($407866112e362b76$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $407866112e362b76$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($407866112e362b76$var$didReceiveUpdate || $407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $407866112e362b76$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $407866112e362b76$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $407866112e362b76$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $407866112e362b76$var$enqueueConcurrentRenderForLane(current, nextProps), $407866112e362b76$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $407866112e362b76$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $407866112e362b76$var$renderDidSuspendDelayIfPossible();
            workInProgress = $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(nextInstance.nextSibling), $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$isHydrating = !0, $407866112e362b76$var$hydrationErrors = null, $407866112e362b76$var$rootOrSingletonContext = !1, null !== current && ($407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextId, $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextOverflow, $407866112e362b76$var$idStack[$407866112e362b76$var$idStackIndex++] = $407866112e362b76$var$treeContextProvider, $407866112e362b76$var$treeContextId = current.id, $407866112e362b76$var$treeContextOverflow = current.overflow, $407866112e362b76$var$treeContextProvider = workInProgress), workInProgress = $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $407866112e362b76$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $407866112e362b76$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $407866112e362b76$var$createWorkInProgress(digest, showFallback) : (showFallback = $407866112e362b76$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $407866112e362b76$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $407866112e362b76$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $407866112e362b76$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $407866112e362b76$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $407866112e362b76$var$SUSPENDED_MARKER, nextProps;
    $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $407866112e362b76$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $407866112e362b76$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $407866112e362b76$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $407866112e362b76$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $407866112e362b76$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $407866112e362b76$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $407866112e362b76$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $407866112e362b76$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $407866112e362b76$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $407866112e362b76$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $407866112e362b76$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $407866112e362b76$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $407866112e362b76$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $407866112e362b76$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $407866112e362b76$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $407866112e362b76$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $407866112e362b76$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $407866112e362b76$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $407866112e362b76$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $407866112e362b76$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $407866112e362b76$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($407866112e362b76$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $407866112e362b76$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $407866112e362b76$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $407866112e362b76$var$checkIfContextChanged(current) ? !0 : !1;
}
function $407866112e362b76$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, current.memoizedState.cache);
            $407866112e362b76$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $407866112e362b76$var$pushHostContext(workInProgress);
            break;
        case 4:
            $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $407866112e362b76$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $407866112e362b76$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $407866112e362b76$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($407866112e362b76$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $407866112e362b76$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $407866112e362b76$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, current.memoizedState.cache);
    }
    return $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $407866112e362b76$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $407866112e362b76$var$didReceiveUpdate = !0;
        else {
            if (!$407866112e362b76$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $407866112e362b76$var$didReceiveUpdate = !1, $407866112e362b76$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $407866112e362b76$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $407866112e362b76$var$didReceiveUpdate = !1, $407866112e362b76$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $407866112e362b76$var$pushTreeId(workInProgress, $407866112e362b76$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $407866112e362b76$var$shouldConstruct(lazyComponent) ? (current = $407866112e362b76$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $407866112e362b76$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $407866112e362b76$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $407866112e362b76$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $407866112e362b76$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $407866112e362b76$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $407866112e362b76$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $407866112e362b76$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($407866112e362b76$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $407866112e362b76$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $407866112e362b76$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $407866112e362b76$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($407866112e362b76$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $407866112e362b76$var$cloneUpdateQueue(current, workInProgress);
                $407866112e362b76$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $407866112e362b76$var$propagateContextChanges(workInProgress, [
                    $407866112e362b76$var$CacheContext
                ], renderLanes, !0);
                $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $407866112e362b76$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $407866112e362b76$var$createCapturedValueAtFiber(Error($407866112e362b76$var$formatProdErrorMessage(424)), workInProgress);
                        $407866112e362b76$var$queueHydrationError(init);
                        workInProgress = $407866112e362b76$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(current.firstChild);
                        $407866112e362b76$var$hydrationParentFiber = workInProgress;
                        $407866112e362b76$var$isHydrating = !0;
                        $407866112e362b76$var$hydrationErrors = null;
                        $407866112e362b76$var$rootOrSingletonContext = !0;
                        renderLanes = $407866112e362b76$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $407866112e362b76$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $407866112e362b76$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $407866112e362b76$var$markRef(current, workInProgress), null === current ? (renderLanes = $407866112e362b76$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $407866112e362b76$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $407866112e362b76$var$getOwnerDocumentFromRootContainer($407866112e362b76$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$407866112e362b76$var$internalInstanceKey] = workInProgress, lazyComponent[$407866112e362b76$var$internalPropsKey] = current, $407866112e362b76$var$setInitialProperties(lazyComponent, renderLanes, current), $407866112e362b76$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $407866112e362b76$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $407866112e362b76$var$pushHostContext(workInProgress), null === current && $407866112e362b76$var$isHydrating && (lazyComponent = workInProgress.stateNode = $407866112e362b76$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $407866112e362b76$var$rootInstanceStackCursor.current), $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$rootOrSingletonContext = !0, init = $407866112e362b76$var$nextHydratableInstance, $407866112e362b76$var$isSingletonScope(workInProgress.type) ? ($407866112e362b76$var$previousHydratableOnEnteringScopedSingleton = init, $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(lazyComponent.firstChild)) : $407866112e362b76$var$nextHydratableInstance = init), $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $407866112e362b76$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $407866112e362b76$var$isHydrating) {
                if (init = lazyComponent = $407866112e362b76$var$nextHydratableInstance) lazyComponent = $407866112e362b76$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $407866112e362b76$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$nextHydratableInstance = $407866112e362b76$var$getNextHydratable(lazyComponent.firstChild), $407866112e362b76$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
            }
            $407866112e362b76$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $407866112e362b76$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $407866112e362b76$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $407866112e362b76$var$renderWithHooks(current, workInProgress, $407866112e362b76$var$TransitionAwareHostComponent, null, null, renderLanes), $407866112e362b76$var$HostTransitionContext._currentValue = init);
            $407866112e362b76$var$markRef(current, workInProgress);
            $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $407866112e362b76$var$isHydrating) {
                if (current = renderLanes = $407866112e362b76$var$nextHydratableInstance) renderLanes = $407866112e362b76$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $407866112e362b76$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $407866112e362b76$var$hydrationParentFiber = workInProgress, $407866112e362b76$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $407866112e362b76$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $407866112e362b76$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $407866112e362b76$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $407866112e362b76$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $407866112e362b76$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $407866112e362b76$var$prepareToReadContext(workInProgress), init = $407866112e362b76$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $407866112e362b76$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $407866112e362b76$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $407866112e362b76$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $407866112e362b76$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $407866112e362b76$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $407866112e362b76$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $407866112e362b76$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $407866112e362b76$var$prepareToReadContext(workInProgress), lazyComponent = $407866112e362b76$var$readContext($407866112e362b76$var$CacheContext), null === current ? (init = $407866112e362b76$var$peekCacheFromPool(), null === init && (init = $407866112e362b76$var$workInProgressRoot, prevState = $407866112e362b76$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $407866112e362b76$var$initializeUpdateQueue(workInProgress), $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($407866112e362b76$var$cloneUpdateQueue(current, workInProgress), $407866112e362b76$var$processUpdateQueue(workInProgress, null, null, renderLanes), $407866112e362b76$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $407866112e362b76$var$pushProvider(workInProgress, $407866112e362b76$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $407866112e362b76$var$propagateContextChanges(workInProgress, [
                $407866112e362b76$var$CacheContext
            ], renderLanes, !0))), $407866112e362b76$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($407866112e362b76$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $407866112e362b76$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $407866112e362b76$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$407866112e362b76$var$preloadResource(resource)) {
        resource = $407866112e362b76$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($407866112e362b76$var$workInProgressRootRenderLanes & 4194048) === $407866112e362b76$var$workInProgressRootRenderLanes ? null !== $407866112e362b76$var$shellBoundary : ($407866112e362b76$var$workInProgressRootRenderLanes & 62914560) !== $407866112e362b76$var$workInProgressRootRenderLanes && 0 === ($407866112e362b76$var$workInProgressRootRenderLanes & 536870912) || resource !== $407866112e362b76$var$shellBoundary)) throw $407866112e362b76$var$suspendedThenable = $407866112e362b76$var$noopSuspenseyCommitThenable, $407866112e362b76$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $407866112e362b76$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $407866112e362b76$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $407866112e362b76$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $407866112e362b76$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$407866112e362b76$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $407866112e362b76$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $407866112e362b76$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $407866112e362b76$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 1:
            return $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext);
            $407866112e362b76$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $407866112e362b76$var$popHydrationState(workInProgress) ? $407866112e362b76$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $407866112e362b76$var$upgradeHydrationErrorsToRecoverable());
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($407866112e362b76$var$markUpdate(workInProgress), null !== renderLanes ? ($407866112e362b76$var$bubbleProperties(workInProgress), $407866112e362b76$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($407866112e362b76$var$markUpdate(workInProgress), $407866112e362b76$var$bubbleProperties(workInProgress), $407866112e362b76$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress), $407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $407866112e362b76$var$popHostContext(workInProgress);
            renderLanes = $407866112e362b76$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(166));
                    $407866112e362b76$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $407866112e362b76$var$contextStackCursor.current;
                $407866112e362b76$var$popHydrationState(workInProgress) ? $407866112e362b76$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $407866112e362b76$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $407866112e362b76$var$markUpdate(workInProgress));
            }
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $407866112e362b76$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(166));
                    $407866112e362b76$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $407866112e362b76$var$contextStackCursor.current;
                if ($407866112e362b76$var$popHydrationState(workInProgress)) $407866112e362b76$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $407866112e362b76$var$getOwnerDocumentFromRootContainer($407866112e362b76$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$407866112e362b76$var$internalInstanceKey] = workInProgress;
                    current[$407866112e362b76$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($407866112e362b76$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $407866112e362b76$var$markUpdate(workInProgress);
                }
            }
            $407866112e362b76$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $407866112e362b76$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(166));
                current = $407866112e362b76$var$rootInstanceStackCursor.current;
                if ($407866112e362b76$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $407866112e362b76$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$407866112e362b76$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $407866112e362b76$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $407866112e362b76$var$throwOnHydrationMismatch(workInProgress);
                } else current = $407866112e362b76$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$407866112e362b76$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $407866112e362b76$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(317));
                        type[$407866112e362b76$var$internalInstanceKey] = workInProgress;
                    } else $407866112e362b76$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $407866112e362b76$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $407866112e362b76$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $407866112e362b76$var$popSuspenseHandler(workInProgress), workInProgress;
                    $407866112e362b76$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $407866112e362b76$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $407866112e362b76$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $407866112e362b76$var$popHostContainer(), null === current && $407866112e362b76$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 10:
            return $407866112e362b76$var$popProvider(workInProgress.type), $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 19:
            $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $407866112e362b76$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $407866112e362b76$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $407866112e362b76$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $407866112e362b76$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $407866112e362b76$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $407866112e362b76$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$407866112e362b76$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, $407866112e362b76$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $407866112e362b76$var$now() > $407866112e362b76$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $407866112e362b76$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $407866112e362b76$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $407866112e362b76$var$scheduleRetryEffect(workInProgress, current), $407866112e362b76$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$407866112e362b76$var$isHydrating) return $407866112e362b76$var$bubbleProperties(workInProgress), null;
                    } else 2 * $407866112e362b76$var$now() - type.renderingStartTime > $407866112e362b76$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $407866112e362b76$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $407866112e362b76$var$now(), workInProgress.sibling = null, current = $407866112e362b76$var$suspenseStackCursor.current, $407866112e362b76$var$push($407866112e362b76$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $407866112e362b76$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $407866112e362b76$var$popSuspenseHandler(workInProgress), $407866112e362b76$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($407866112e362b76$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $407866112e362b76$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $407866112e362b76$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $407866112e362b76$var$pop($407866112e362b76$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext), $407866112e362b76$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($407866112e362b76$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $407866112e362b76$var$unwindWork(current, workInProgress) {
    $407866112e362b76$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext), $407866112e362b76$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $407866112e362b76$var$popHostContext(workInProgress), null;
        case 13:
            $407866112e362b76$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($407866112e362b76$var$formatProdErrorMessage(340));
                $407866112e362b76$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor), null;
        case 4:
            return $407866112e362b76$var$popHostContainer(), null;
        case 10:
            return $407866112e362b76$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $407866112e362b76$var$popSuspenseHandler(workInProgress), $407866112e362b76$var$popHiddenContext(), null !== current && $407866112e362b76$var$pop($407866112e362b76$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $407866112e362b76$var$unwindInterruptedWork(current, interruptedWork) {
    $407866112e362b76$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext);
            $407866112e362b76$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $407866112e362b76$var$popHostContext(interruptedWork);
            break;
        case 4:
            $407866112e362b76$var$popHostContainer();
            break;
        case 13:
            $407866112e362b76$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $407866112e362b76$var$pop($407866112e362b76$var$suspenseStackCursor);
            break;
        case 10:
            $407866112e362b76$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $407866112e362b76$var$popSuspenseHandler(interruptedWork);
            $407866112e362b76$var$popHiddenContext();
            null !== current && $407866112e362b76$var$pop($407866112e362b76$var$resumedCache);
            break;
        case 24:
            $407866112e362b76$var$popProvider($407866112e362b76$var$CacheContext);
    }
}
function $407866112e362b76$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $407866112e362b76$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $407866112e362b76$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $407866112e362b76$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $407866112e362b76$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $407866112e362b76$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $407866112e362b76$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $407866112e362b76$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $407866112e362b76$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $407866112e362b76$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$407866112e362b76$var$internalPropsKey] = newProps;
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $407866112e362b76$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $407866112e362b76$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $407866112e362b76$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $407866112e362b76$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $407866112e362b76$var$noop$1));
    else if (4 !== tag && (27 === tag && $407866112e362b76$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $407866112e362b76$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $407866112e362b76$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($407866112e362b76$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$407866112e362b76$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $407866112e362b76$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $407866112e362b76$var$setInitialProperties(singleton, type, props);
        singleton[$407866112e362b76$var$internalInstanceKey] = finishedWork;
        singleton[$407866112e362b76$var$internalPropsKey] = props;
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $407866112e362b76$var$offscreenSubtreeIsHidden = !1, $407866112e362b76$var$offscreenSubtreeWasHidden = !1, $407866112e362b76$var$needsFormReset = !1, $407866112e362b76$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $407866112e362b76$var$nextEffect = null;
function $407866112e362b76$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $407866112e362b76$var$eventsEnabled = $407866112e362b76$var$_enabled;
    root = $407866112e362b76$var$getActiveElementDeep(root);
    if ($407866112e362b76$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $407866112e362b76$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $407866112e362b76$var$_enabled = !1;
    for($407866112e362b76$var$nextEffect = firstChild; null !== $407866112e362b76$var$nextEffect;)if (firstChild = $407866112e362b76$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $407866112e362b76$var$nextEffect = root;
    else for(; null !== $407866112e362b76$var$nextEffect;){
        firstChild = $407866112e362b76$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $407866112e362b76$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $407866112e362b76$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $407866112e362b76$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $407866112e362b76$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($407866112e362b76$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $407866112e362b76$var$nextEffect = root;
            break;
        }
        $407866112e362b76$var$nextEffect = firstChild.return;
    }
}
function $407866112e362b76$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $407866112e362b76$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $407866112e362b76$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $407866112e362b76$var$commitClassCallbacks(finishedWork);
            flags & 512 && $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $407866112e362b76$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $407866112e362b76$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $407866112e362b76$var$commitHostMount(finishedWork);
            flags & 512 && $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $407866112e362b76$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $407866112e362b76$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $407866112e362b76$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $407866112e362b76$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $407866112e362b76$var$offscreenSubtreeWasHidden;
                prevProps = $407866112e362b76$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $407866112e362b76$var$offscreenSubtreeWasHidden;
                $407866112e362b76$var$offscreenSubtreeIsHidden = flags;
                ($407866112e362b76$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $407866112e362b76$var$offscreenSubtreeIsHidden = prevProps;
                $407866112e362b76$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $407866112e362b76$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $407866112e362b76$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $407866112e362b76$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $407866112e362b76$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $407866112e362b76$var$hostParent = null, $407866112e362b76$var$hostParentIsContainer = !1;
function $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$407866112e362b76$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $407866112e362b76$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.onCommitFiberUnmount) try {
        $407866112e362b76$var$injectedHook.onCommitFiberUnmount($407866112e362b76$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $407866112e362b76$var$hostParent, prevHostParentIsContainer = $407866112e362b76$var$hostParentIsContainer;
            $407866112e362b76$var$isSingletonScope(deletedFiber.type) && ($407866112e362b76$var$hostParent = deletedFiber.stateNode, $407866112e362b76$var$hostParentIsContainer = !1);
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$releaseSingletonInstance(deletedFiber.stateNode);
            $407866112e362b76$var$hostParent = prevHostParent;
            $407866112e362b76$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $407866112e362b76$var$hostParent;
            prevHostParentIsContainer = $407866112e362b76$var$hostParentIsContainer;
            $407866112e362b76$var$hostParent = null;
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$hostParent = prevHostParent;
            $407866112e362b76$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $407866112e362b76$var$hostParent) {
                if ($407866112e362b76$var$hostParentIsContainer) try {
                    (9 === $407866112e362b76$var$hostParent.nodeType ? $407866112e362b76$var$hostParent.body : "HTML" === $407866112e362b76$var$hostParent.nodeName ? $407866112e362b76$var$hostParent.ownerDocument.body : $407866112e362b76$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $407866112e362b76$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $407866112e362b76$var$hostParent && ($407866112e362b76$var$hostParentIsContainer ? (finishedRoot = $407866112e362b76$var$hostParent, $407866112e362b76$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $407866112e362b76$var$retryIfBlockedOn(finishedRoot)) : $407866112e362b76$var$clearSuspenseBoundary($407866112e362b76$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $407866112e362b76$var$hostParent;
            prevHostParentIsContainer = $407866112e362b76$var$hostParentIsContainer;
            $407866112e362b76$var$hostParent = deletedFiber.stateNode.containerInfo;
            $407866112e362b76$var$hostParentIsContainer = !0;
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$hostParent = prevHostParent;
            $407866112e362b76$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $407866112e362b76$var$offscreenSubtreeWasHidden || ($407866112e362b76$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $407866112e362b76$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $407866112e362b76$var$offscreenSubtreeWasHidden = (prevHostParent = $407866112e362b76$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $407866112e362b76$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $407866112e362b76$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $407866112e362b76$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $407866112e362b76$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $407866112e362b76$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $407866112e362b76$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $407866112e362b76$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $407866112e362b76$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $407866112e362b76$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $407866112e362b76$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($407866112e362b76$var$isSingletonScope(parent.type)) {
                        $407866112e362b76$var$hostParent = parent.stateNode;
                        $407866112e362b76$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $407866112e362b76$var$hostParent = parent.stateNode;
                    $407866112e362b76$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $407866112e362b76$var$hostParent = parent.stateNode.containerInfo;
                    $407866112e362b76$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $407866112e362b76$var$hostParent) throw Error($407866112e362b76$var$formatProdErrorMessage(160));
        $407866112e362b76$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $407866112e362b76$var$hostParent = null;
        $407866112e362b76$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $407866112e362b76$var$currentHoistableRoot = null;
function $407866112e362b76$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($407866112e362b76$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $407866112e362b76$var$commitHookEffectListMount(3, finishedWork), $407866112e362b76$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            flags & 64 && $407866112e362b76$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$407866112e362b76$var$internalHoistableMarker] || currentResource[$407866112e362b76$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $407866112e362b76$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$407866112e362b76$var$internalInstanceKey] = finishedWork;
                                        $407866112e362b76$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $407866112e362b76$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $407866112e362b76$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $407866112e362b76$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $407866112e362b76$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($407866112e362b76$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$407866112e362b76$var$internalInstanceKey] = finishedWork;
                                $407866112e362b76$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $407866112e362b76$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $407866112e362b76$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $407866112e362b76$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $407866112e362b76$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $407866112e362b76$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $407866112e362b76$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($407866112e362b76$var$offscreenSubtreeWasHidden || null === current || $407866112e362b76$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $407866112e362b76$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $407866112e362b76$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($407866112e362b76$var$needsFormReset = !0);
            break;
        case 6:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($407866112e362b76$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $407866112e362b76$var$tagCaches = null;
            hoistableRoot = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$currentHoistableRoot = $407866112e362b76$var$getHoistableRoot(root.containerInfo);
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$currentHoistableRoot = hoistableRoot;
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $407866112e362b76$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $407866112e362b76$var$needsFormReset && ($407866112e362b76$var$needsFormReset = !1, $407866112e362b76$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$currentHoistableRoot = $407866112e362b76$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            $407866112e362b76$var$currentHoistableRoot = flags;
            break;
        case 12:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($407866112e362b76$var$globalMostRecentFallbackTime = $407866112e362b76$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $407866112e362b76$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $407866112e362b76$var$offscreenSubtreeWasHidden;
            $407866112e362b76$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $407866112e362b76$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $407866112e362b76$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $407866112e362b76$var$offscreenSubtreeIsHidden || $407866112e362b76$var$offscreenSubtreeWasHidden || $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $407866112e362b76$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $407866112e362b76$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $407866112e362b76$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $407866112e362b76$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $407866112e362b76$var$recursivelyTraverseMutationEffects(root, finishedWork), $407866112e362b76$var$commitReconciliationEffects(finishedWork);
    }
}
function $407866112e362b76$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($407866112e362b76$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($407866112e362b76$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $407866112e362b76$var$getHostSibling(finishedWork);
                    $407866112e362b76$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($407866112e362b76$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $407866112e362b76$var$getHostSibling(finishedWork);
                    $407866112e362b76$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $407866112e362b76$var$getHostSibling(finishedWork);
                    $407866112e362b76$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($407866112e362b76$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $407866112e362b76$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $407866112e362b76$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $407866112e362b76$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $407866112e362b76$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $407866112e362b76$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $407866112e362b76$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $407866112e362b76$var$safelyDetachRef(finishedWork, finishedWork.return);
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $407866112e362b76$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$407866112e362b76$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $407866112e362b76$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $407866112e362b76$var$commitClassCallbacks(finishedWork);
                $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $407866112e362b76$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $407866112e362b76$var$commitHostMount(finishedWork);
                $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $407866112e362b76$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $407866112e362b76$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $407866112e362b76$var$releaseCache(previousCache));
}
function $407866112e362b76$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $407866112e362b76$var$releaseCache(current));
}
function $407866112e362b76$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $407866112e362b76$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $407866112e362b76$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $407866112e362b76$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $407866112e362b76$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $407866112e362b76$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $407866112e362b76$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $407866112e362b76$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $407866112e362b76$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $407866112e362b76$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $407866112e362b76$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $407866112e362b76$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $407866112e362b76$var$suspenseyCommitFlag = 8192;
function $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $407866112e362b76$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $407866112e362b76$var$suspenseyCommitFlag && null !== fiber.memoizedState && $407866112e362b76$var$suspendResource($407866112e362b76$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $407866112e362b76$var$currentHoistableRoot;
            $407866112e362b76$var$currentHoistableRoot = $407866112e362b76$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $407866112e362b76$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $407866112e362b76$var$suspenseyCommitFlag, $407866112e362b76$var$suspenseyCommitFlag = 16777216, $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber), $407866112e362b76$var$suspenseyCommitFlag = previousHoistableRoot) : $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $407866112e362b76$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $407866112e362b76$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $407866112e362b76$var$nextEffect = childToDelete;
            $407866112e362b76$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $407866112e362b76$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$407866112e362b76$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $407866112e362b76$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $407866112e362b76$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $407866112e362b76$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $407866112e362b76$var$nextEffect = childToDelete;
            $407866112e362b76$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $407866112e362b76$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $407866112e362b76$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $407866112e362b76$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $407866112e362b76$var$nextEffect;){
        var fiber = $407866112e362b76$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $407866112e362b76$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $407866112e362b76$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $407866112e362b76$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $407866112e362b76$var$nextEffect;){
            cache = $407866112e362b76$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $407866112e362b76$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $407866112e362b76$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $407866112e362b76$var$nextEffect = sibling;
                break a;
            }
            $407866112e362b76$var$nextEffect = returnFiber;
        }
    }
}
var $407866112e362b76$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $407866112e362b76$var$readContext($407866112e362b76$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $407866112e362b76$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $407866112e362b76$var$executionContext = 0, $407866112e362b76$var$workInProgressRoot = null, $407866112e362b76$var$workInProgress = null, $407866112e362b76$var$workInProgressRootRenderLanes = 0, $407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings = !1, $407866112e362b76$var$workInProgressRootIsPrerendering = !1, $407866112e362b76$var$workInProgressRootDidAttachPingListener = !1, $407866112e362b76$var$entangledRenderLanes = 0, $407866112e362b76$var$workInProgressRootExitStatus = 0, $407866112e362b76$var$workInProgressRootSkippedLanes = 0, $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes = 0, $407866112e362b76$var$workInProgressRootPingedLanes = 0, $407866112e362b76$var$workInProgressDeferredLane = 0, $407866112e362b76$var$workInProgressSuspendedRetryLanes = 0, $407866112e362b76$var$workInProgressRootConcurrentErrors = null, $407866112e362b76$var$workInProgressRootRecoverableErrors = null, $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $407866112e362b76$var$globalMostRecentFallbackTime = 0, $407866112e362b76$var$workInProgressRootRenderTargetTime = Infinity, $407866112e362b76$var$workInProgressTransitions = null, $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed = null, $407866112e362b76$var$pendingEffectsStatus = 0, $407866112e362b76$var$pendingEffectsRoot = null, $407866112e362b76$var$pendingFinishedWork = null, $407866112e362b76$var$pendingEffectsLanes = 0, $407866112e362b76$var$pendingEffectsRemainingLanes = 0, $407866112e362b76$var$pendingPassiveTransitions = null, $407866112e362b76$var$pendingRecoverableErrors = null, $407866112e362b76$var$nestedUpdateCount = 0, $407866112e362b76$var$rootWithNestedUpdates = null;
function $407866112e362b76$var$requestUpdateLane() {
    if (0 !== ($407866112e362b76$var$executionContext & 2) && 0 !== $407866112e362b76$var$workInProgressRootRenderLanes) return $407866112e362b76$var$workInProgressRootRenderLanes & -$407866112e362b76$var$workInProgressRootRenderLanes;
    if (null !== $407866112e362b76$var$ReactSharedInternals.T) {
        var actionScopeLane = $407866112e362b76$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $407866112e362b76$var$requestTransitionLane();
    }
    return $407866112e362b76$var$resolveUpdatePriority();
}
function $407866112e362b76$var$requestDeferredLane() {
    0 === $407866112e362b76$var$workInProgressDeferredLane && ($407866112e362b76$var$workInProgressDeferredLane = 0 === ($407866112e362b76$var$workInProgressRootRenderLanes & 536870912) || $407866112e362b76$var$isHydrating ? $407866112e362b76$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $407866112e362b76$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $407866112e362b76$var$workInProgressDeferredLane;
}
function $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $407866112e362b76$var$workInProgressRoot && (2 === $407866112e362b76$var$workInProgressSuspendedReason || 9 === $407866112e362b76$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $407866112e362b76$var$prepareFreshStack(root, 0), $407866112e362b76$var$markRootSuspended(root, $407866112e362b76$var$workInProgressRootRenderLanes, $407866112e362b76$var$workInProgressDeferredLane, !1);
    $407866112e362b76$var$markRootUpdated$1(root, lane);
    if (0 === ($407866112e362b76$var$executionContext & 2) || root !== $407866112e362b76$var$workInProgressRoot) root === $407866112e362b76$var$workInProgressRoot && (0 === ($407866112e362b76$var$executionContext & 2) && ($407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $407866112e362b76$var$workInProgressRootExitStatus && $407866112e362b76$var$markRootSuspended(root, $407866112e362b76$var$workInProgressRootRenderLanes, $407866112e362b76$var$workInProgressDeferredLane, !1)), $407866112e362b76$var$ensureRootIsScheduled(root);
}
function $407866112e362b76$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($407866112e362b76$var$executionContext & 6)) throw Error($407866112e362b76$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $407866112e362b76$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $407866112e362b76$var$renderRootConcurrent(root$jscomp$0, lanes) : $407866112e362b76$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $407866112e362b76$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $407866112e362b76$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$407866112e362b76$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $407866112e362b76$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $407866112e362b76$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($407866112e362b76$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $407866112e362b76$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($407866112e362b76$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $407866112e362b76$var$workInProgressRootRecoverableErrors;
                            $407866112e362b76$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $407866112e362b76$var$workInProgressRootRecoverableErrors ? $407866112e362b76$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $407866112e362b76$var$workInProgressRootRecoverableErrors.push.apply($407866112e362b76$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $407866112e362b76$var$prepareFreshStack(root$jscomp$0, 0);
                $407866112e362b76$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($407866112e362b76$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $407866112e362b76$var$markRootSuspended(shouldTimeSlice, lanes, $407866112e362b76$var$workInProgressDeferredLane, !$407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $407866112e362b76$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($407866112e362b76$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $407866112e362b76$var$globalMostRecentFallbackTime + 300 - $407866112e362b76$var$now(), 10 < exitStatus)) {
                    $407866112e362b76$var$markRootSuspended(shouldTimeSlice, lanes, $407866112e362b76$var$workInProgressDeferredLane, !$407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $407866112e362b76$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $407866112e362b76$var$scheduleTimeout($407866112e362b76$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $407866112e362b76$var$workInProgressRootRecoverableErrors, $407866112e362b76$var$workInProgressTransitions, $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $407866112e362b76$var$workInProgressDeferredLane, $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes, $407866112e362b76$var$workInProgressSuspendedRetryLanes, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $407866112e362b76$var$commitRootWhenReady(shouldTimeSlice, forceSync, $407866112e362b76$var$workInProgressRootRecoverableErrors, $407866112e362b76$var$workInProgressTransitions, $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $407866112e362b76$var$workInProgressDeferredLane, $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes, $407866112e362b76$var$workInProgressSuspendedRetryLanes, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $407866112e362b76$var$ensureRootIsScheduled(root$jscomp$0);
}
function $407866112e362b76$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($407866112e362b76$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $407866112e362b76$var$noop
        }, $407866112e362b76$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $407866112e362b76$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($407866112e362b76$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $407866112e362b76$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $407866112e362b76$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $407866112e362b76$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$407866112e362b76$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $407866112e362b76$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$407866112e362b76$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $407866112e362b76$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $407866112e362b76$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $407866112e362b76$var$flushSyncWork$1() {
    return 0 === ($407866112e362b76$var$executionContext & 6) ? ($407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $407866112e362b76$var$resetWorkInProgressStack() {
    if (null !== $407866112e362b76$var$workInProgress) {
        if (0 === $407866112e362b76$var$workInProgressSuspendedReason) var interruptedWork = $407866112e362b76$var$workInProgress.return;
        else interruptedWork = $407866112e362b76$var$workInProgress, $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null, $407866112e362b76$var$resetHooksOnUnwind(interruptedWork), $407866112e362b76$var$thenableState = null, $407866112e362b76$var$thenableIndexCounter = 0, interruptedWork = $407866112e362b76$var$workInProgress;
        for(; null !== interruptedWork;)$407866112e362b76$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $407866112e362b76$var$workInProgress = null;
    }
}
function $407866112e362b76$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $407866112e362b76$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $407866112e362b76$var$resetWorkInProgressStack();
    $407866112e362b76$var$workInProgressRoot = root;
    $407866112e362b76$var$workInProgress = timeoutHandle = $407866112e362b76$var$createWorkInProgress(root.current, null);
    $407866112e362b76$var$workInProgressRootRenderLanes = lanes;
    $407866112e362b76$var$workInProgressSuspendedReason = 0;
    $407866112e362b76$var$workInProgressThrownValue = null;
    $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $407866112e362b76$var$workInProgressRootIsPrerendering = $407866112e362b76$var$checkIfRootIsPrerendering(root, lanes);
    $407866112e362b76$var$workInProgressRootDidAttachPingListener = !1;
    $407866112e362b76$var$workInProgressSuspendedRetryLanes = $407866112e362b76$var$workInProgressDeferredLane = $407866112e362b76$var$workInProgressRootPingedLanes = $407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes = $407866112e362b76$var$workInProgressRootSkippedLanes = $407866112e362b76$var$workInProgressRootExitStatus = 0;
    $407866112e362b76$var$workInProgressRootRecoverableErrors = $407866112e362b76$var$workInProgressRootConcurrentErrors = null;
    $407866112e362b76$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $407866112e362b76$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $407866112e362b76$var$entangledRenderLanes = lanes;
    $407866112e362b76$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $407866112e362b76$var$handleThrow(root, thrownValue) {
    $407866112e362b76$var$currentlyRenderingFiber = null;
    $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$ContextOnlyDispatcher;
    thrownValue === $407866112e362b76$var$SuspenseException || thrownValue === $407866112e362b76$var$SuspenseActionException ? (thrownValue = $407866112e362b76$var$getSuspendedThenable(), $407866112e362b76$var$workInProgressSuspendedReason = 3) : thrownValue === $407866112e362b76$var$SuspenseyCommitException ? (thrownValue = $407866112e362b76$var$getSuspendedThenable(), $407866112e362b76$var$workInProgressSuspendedReason = 4) : $407866112e362b76$var$workInProgressSuspendedReason = thrownValue === $407866112e362b76$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $407866112e362b76$var$workInProgressThrownValue = thrownValue;
    null === $407866112e362b76$var$workInProgress && ($407866112e362b76$var$workInProgressRootExitStatus = 1, $407866112e362b76$var$logUncaughtError(root, $407866112e362b76$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $407866112e362b76$var$pushDispatcher() {
    var prevDispatcher = $407866112e362b76$var$ReactSharedInternals.H;
    $407866112e362b76$var$ReactSharedInternals.H = $407866112e362b76$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $407866112e362b76$var$ContextOnlyDispatcher : prevDispatcher;
}
function $407866112e362b76$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $407866112e362b76$var$ReactSharedInternals.A;
    $407866112e362b76$var$ReactSharedInternals.A = $407866112e362b76$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $407866112e362b76$var$renderDidSuspendDelayIfPossible() {
    $407866112e362b76$var$workInProgressRootExitStatus = 4;
    $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings || ($407866112e362b76$var$workInProgressRootRenderLanes & 4194048) !== $407866112e362b76$var$workInProgressRootRenderLanes && null !== $407866112e362b76$var$suspenseHandlerStackCursor.current || ($407866112e362b76$var$workInProgressRootIsPrerendering = !0);
    0 === ($407866112e362b76$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($407866112e362b76$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $407866112e362b76$var$workInProgressRoot || $407866112e362b76$var$markRootSuspended($407866112e362b76$var$workInProgressRoot, $407866112e362b76$var$workInProgressRootRenderLanes, $407866112e362b76$var$workInProgressDeferredLane, !1);
}
function $407866112e362b76$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $407866112e362b76$var$executionContext;
    $407866112e362b76$var$executionContext |= 2;
    var prevDispatcher = $407866112e362b76$var$pushDispatcher(), prevAsyncDispatcher = $407866112e362b76$var$pushAsyncDispatcher();
    if ($407866112e362b76$var$workInProgressRoot !== root || $407866112e362b76$var$workInProgressRootRenderLanes !== lanes) $407866112e362b76$var$workInProgressTransitions = null, $407866112e362b76$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $407866112e362b76$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $407866112e362b76$var$workInProgressSuspendedReason && null !== $407866112e362b76$var$workInProgress) {
            var unitOfWork = $407866112e362b76$var$workInProgress, thrownValue = $407866112e362b76$var$workInProgressThrownValue;
            switch($407866112e362b76$var$workInProgressSuspendedReason){
                case 8:
                    $407866112e362b76$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $407866112e362b76$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $407866112e362b76$var$workInProgressSuspendedReason;
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $407866112e362b76$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $407866112e362b76$var$workInProgressSuspendedReason, $407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $407866112e362b76$var$workLoopSync();
        exitStatus = $407866112e362b76$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $407866112e362b76$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null;
    $407866112e362b76$var$executionContext = prevExecutionContext;
    $407866112e362b76$var$ReactSharedInternals.H = prevDispatcher;
    $407866112e362b76$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $407866112e362b76$var$workInProgress && ($407866112e362b76$var$workInProgressRoot = null, $407866112e362b76$var$workInProgressRootRenderLanes = 0, $407866112e362b76$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $407866112e362b76$var$workLoopSync() {
    for(; null !== $407866112e362b76$var$workInProgress;)$407866112e362b76$var$performUnitOfWork($407866112e362b76$var$workInProgress);
}
function $407866112e362b76$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $407866112e362b76$var$executionContext;
    $407866112e362b76$var$executionContext |= 2;
    var prevDispatcher = $407866112e362b76$var$pushDispatcher(), prevAsyncDispatcher = $407866112e362b76$var$pushAsyncDispatcher();
    $407866112e362b76$var$workInProgressRoot !== root || $407866112e362b76$var$workInProgressRootRenderLanes !== lanes ? ($407866112e362b76$var$workInProgressTransitions = null, $407866112e362b76$var$workInProgressRootRenderTargetTime = $407866112e362b76$var$now() + 500, $407866112e362b76$var$prepareFreshStack(root, lanes)) : $407866112e362b76$var$workInProgressRootIsPrerendering = $407866112e362b76$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $407866112e362b76$var$workInProgressSuspendedReason && null !== $407866112e362b76$var$workInProgress) {
            lanes = $407866112e362b76$var$workInProgress;
            var thrownValue = $407866112e362b76$var$workInProgressThrownValue;
            b: switch($407866112e362b76$var$workInProgressSuspendedReason){
                case 1:
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($407866112e362b76$var$isThenableResolved(thrownValue)) {
                        $407866112e362b76$var$workInProgressSuspendedReason = 0;
                        $407866112e362b76$var$workInProgressThrownValue = null;
                        $407866112e362b76$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $407866112e362b76$var$workInProgressSuspendedReason && 9 !== $407866112e362b76$var$workInProgressSuspendedReason || $407866112e362b76$var$workInProgressRoot !== root || ($407866112e362b76$var$workInProgressSuspendedReason = 7);
                        $407866112e362b76$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $407866112e362b76$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $407866112e362b76$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $407866112e362b76$var$isThenableResolved(thrownValue) ? ($407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$replaySuspendedUnitOfWork(lanes)) : ($407866112e362b76$var$workInProgressSuspendedReason = 0, $407866112e362b76$var$workInProgressThrownValue = null, $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($407866112e362b76$var$workInProgress.tag){
                        case 26:
                            resource = $407866112e362b76$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $407866112e362b76$var$workInProgress;
                            if (resource ? $407866112e362b76$var$preloadResource(resource) : 1) {
                                $407866112e362b76$var$workInProgressSuspendedReason = 0;
                                $407866112e362b76$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $407866112e362b76$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($407866112e362b76$var$workInProgress = returnFiber, $407866112e362b76$var$completeUnitOfWork(returnFiber)) : $407866112e362b76$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $407866112e362b76$var$workInProgressSuspendedReason = 0;
                    $407866112e362b76$var$workInProgressThrownValue = null;
                    $407866112e362b76$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $407866112e362b76$var$resetWorkInProgressStack();
                    $407866112e362b76$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($407866112e362b76$var$formatProdErrorMessage(462));
            }
        }
        $407866112e362b76$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $407866112e362b76$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null;
    $407866112e362b76$var$ReactSharedInternals.H = prevDispatcher;
    $407866112e362b76$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $407866112e362b76$var$executionContext = prevExecutionContext;
    if (null !== $407866112e362b76$var$workInProgress) return 0;
    $407866112e362b76$var$workInProgressRoot = null;
    $407866112e362b76$var$workInProgressRootRenderLanes = 0;
    $407866112e362b76$var$finishQueueingConcurrentUpdates();
    return $407866112e362b76$var$workInProgressRootExitStatus;
}
function $407866112e362b76$var$workLoopConcurrentByScheduler() {
    for(; null !== $407866112e362b76$var$workInProgress && !$407866112e362b76$var$shouldYield();)$407866112e362b76$var$performUnitOfWork($407866112e362b76$var$workInProgress);
}
function $407866112e362b76$var$performUnitOfWork(unitOfWork) {
    var next = $407866112e362b76$var$beginWork(unitOfWork.alternate, unitOfWork, $407866112e362b76$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $407866112e362b76$var$completeUnitOfWork(unitOfWork) : $407866112e362b76$var$workInProgress = next;
}
function $407866112e362b76$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $407866112e362b76$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $407866112e362b76$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $407866112e362b76$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $407866112e362b76$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $407866112e362b76$var$resetHooksOnUnwind(next);
        default:
            $407866112e362b76$var$unwindInterruptedWork(current, next), next = $407866112e362b76$var$workInProgress = $407866112e362b76$var$resetWorkInProgress(next, $407866112e362b76$var$entangledRenderLanes), next = $407866112e362b76$var$beginWork(current, next, $407866112e362b76$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $407866112e362b76$var$completeUnitOfWork(unitOfWork) : $407866112e362b76$var$workInProgress = next;
}
function $407866112e362b76$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $407866112e362b76$var$lastContextDependency = $407866112e362b76$var$currentlyRenderingFiber$1 = null;
    $407866112e362b76$var$resetHooksOnUnwind(unitOfWork);
    $407866112e362b76$var$thenableState = null;
    $407866112e362b76$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($407866112e362b76$var$throwException(root, returnFiber, unitOfWork, thrownValue, $407866112e362b76$var$workInProgressRootRenderLanes)) {
            $407866112e362b76$var$workInProgressRootExitStatus = 1;
            $407866112e362b76$var$logUncaughtError(root, $407866112e362b76$var$createCapturedValueAtFiber(thrownValue, root.current));
            $407866112e362b76$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $407866112e362b76$var$workInProgress = returnFiber, error;
        $407866112e362b76$var$workInProgressRootExitStatus = 1;
        $407866112e362b76$var$logUncaughtError(root, $407866112e362b76$var$createCapturedValueAtFiber(thrownValue, root.current));
        $407866112e362b76$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($407866112e362b76$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($407866112e362b76$var$workInProgressRootIsPrerendering || 0 !== ($407866112e362b76$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $407866112e362b76$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $407866112e362b76$var$unwindUnitOfWork(unitOfWork, root);
    } else $407866112e362b76$var$completeUnitOfWork(unitOfWork);
}
function $407866112e362b76$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $407866112e362b76$var$unwindUnitOfWork(completedWork, $407866112e362b76$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $407866112e362b76$var$completeWork(completedWork.alternate, completedWork, $407866112e362b76$var$entangledRenderLanes);
        if (null !== next) {
            $407866112e362b76$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $407866112e362b76$var$workInProgress = completedWork;
            return;
        }
        $407866112e362b76$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootExitStatus = 5);
}
function $407866112e362b76$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $407866112e362b76$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $407866112e362b76$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $407866112e362b76$var$workInProgress = unitOfWork;
            return;
        }
        $407866112e362b76$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $407866112e362b76$var$workInProgressRootExitStatus = 6;
    $407866112e362b76$var$workInProgress = null;
}
function $407866112e362b76$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $407866112e362b76$var$flushPendingEffects();
    while (0 !== $407866112e362b76$var$pendingEffectsStatus);
    if (0 !== ($407866112e362b76$var$executionContext & 6)) throw Error($407866112e362b76$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($407866112e362b76$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $407866112e362b76$var$concurrentlyUpdatedLanes;
        $407866112e362b76$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $407866112e362b76$var$workInProgressRoot && ($407866112e362b76$var$workInProgress = $407866112e362b76$var$workInProgressRoot = null, $407866112e362b76$var$workInProgressRootRenderLanes = 0);
        $407866112e362b76$var$pendingFinishedWork = finishedWork;
        $407866112e362b76$var$pendingEffectsRoot = root;
        $407866112e362b76$var$pendingEffectsLanes = lanes;
        $407866112e362b76$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $407866112e362b76$var$pendingPassiveTransitions = transitions;
        $407866112e362b76$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $407866112e362b76$var$scheduleCallback$1($407866112e362b76$var$NormalPriority$1, function() {
            $407866112e362b76$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $407866112e362b76$var$ReactSharedInternals.T;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            transitions = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $407866112e362b76$var$executionContext;
            $407866112e362b76$var$executionContext |= 4;
            try {
                $407866112e362b76$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $407866112e362b76$var$executionContext = spawnedLane, $407866112e362b76$var$ReactDOMSharedInternals.p = transitions, $407866112e362b76$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $407866112e362b76$var$pendingEffectsStatus = 1;
        $407866112e362b76$var$flushMutationEffects();
        $407866112e362b76$var$flushLayoutEffects();
        $407866112e362b76$var$flushSpawnedWork();
    }
}
function $407866112e362b76$var$flushMutationEffects() {
    if (1 === $407866112e362b76$var$pendingEffectsStatus) {
        $407866112e362b76$var$pendingEffectsStatus = 0;
        var root = $407866112e362b76$var$pendingEffectsRoot, finishedWork = $407866112e362b76$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $407866112e362b76$var$ReactSharedInternals.T;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $407866112e362b76$var$executionContext;
            $407866112e362b76$var$executionContext |= 4;
            try {
                $407866112e362b76$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $407866112e362b76$var$selectionInformation, curFocusedElem = $407866112e362b76$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $407866112e362b76$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $407866112e362b76$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $407866112e362b76$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $407866112e362b76$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $407866112e362b76$var$_enabled = !!$407866112e362b76$var$eventsEnabled;
                $407866112e362b76$var$selectionInformation = $407866112e362b76$var$eventsEnabled = null;
            } finally{
                $407866112e362b76$var$executionContext = prevExecutionContext, $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $407866112e362b76$var$pendingEffectsStatus = 2;
    }
}
function $407866112e362b76$var$flushLayoutEffects() {
    if (2 === $407866112e362b76$var$pendingEffectsStatus) {
        $407866112e362b76$var$pendingEffectsStatus = 0;
        var root = $407866112e362b76$var$pendingEffectsRoot, finishedWork = $407866112e362b76$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $407866112e362b76$var$ReactSharedInternals.T;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $407866112e362b76$var$executionContext;
            $407866112e362b76$var$executionContext |= 4;
            try {
                $407866112e362b76$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $407866112e362b76$var$executionContext = prevExecutionContext, $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $407866112e362b76$var$pendingEffectsStatus = 3;
    }
}
function $407866112e362b76$var$flushSpawnedWork() {
    if (4 === $407866112e362b76$var$pendingEffectsStatus || 3 === $407866112e362b76$var$pendingEffectsStatus) {
        $407866112e362b76$var$pendingEffectsStatus = 0;
        $407866112e362b76$var$requestPaint();
        var root = $407866112e362b76$var$pendingEffectsRoot, finishedWork = $407866112e362b76$var$pendingFinishedWork, lanes = $407866112e362b76$var$pendingEffectsLanes, recoverableErrors = $407866112e362b76$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $407866112e362b76$var$pendingEffectsStatus = 5 : ($407866112e362b76$var$pendingEffectsStatus = 0, $407866112e362b76$var$pendingFinishedWork = $407866112e362b76$var$pendingEffectsRoot = null, $407866112e362b76$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $407866112e362b76$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.onCommitFiberRoot) try {
            $407866112e362b76$var$injectedHook.onCommitFiberRoot($407866112e362b76$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $407866112e362b76$var$ReactSharedInternals.T;
            remainingLanes = $407866112e362b76$var$ReactDOMSharedInternals.p;
            $407866112e362b76$var$ReactDOMSharedInternals.p = 2;
            $407866112e362b76$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $407866112e362b76$var$ReactSharedInternals.T = finishedWork, $407866112e362b76$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($407866112e362b76$var$pendingEffectsLanes & 3) && $407866112e362b76$var$flushPendingEffects();
        $407866112e362b76$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $407866112e362b76$var$rootWithNestedUpdates ? $407866112e362b76$var$nestedUpdateCount++ : ($407866112e362b76$var$nestedUpdateCount = 0, $407866112e362b76$var$rootWithNestedUpdates = root) : $407866112e362b76$var$nestedUpdateCount = 0;
        $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $407866112e362b76$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $407866112e362b76$var$releaseCache(remainingLanes)));
}
function $407866112e362b76$var$flushPendingEffects(wasDelayedCommit) {
    $407866112e362b76$var$flushMutationEffects();
    $407866112e362b76$var$flushLayoutEffects();
    $407866112e362b76$var$flushSpawnedWork();
    return $407866112e362b76$var$flushPassiveEffects(wasDelayedCommit);
}
function $407866112e362b76$var$flushPassiveEffects() {
    if (5 !== $407866112e362b76$var$pendingEffectsStatus) return !1;
    var root = $407866112e362b76$var$pendingEffectsRoot, remainingLanes = $407866112e362b76$var$pendingEffectsRemainingLanes;
    $407866112e362b76$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $407866112e362b76$var$lanesToEventPriority($407866112e362b76$var$pendingEffectsLanes), prevTransition = $407866112e362b76$var$ReactSharedInternals.T, previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        $407866112e362b76$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $407866112e362b76$var$ReactSharedInternals.T = null;
        renderPriority = $407866112e362b76$var$pendingPassiveTransitions;
        $407866112e362b76$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $407866112e362b76$var$pendingEffectsRoot, lanes = $407866112e362b76$var$pendingEffectsLanes;
        $407866112e362b76$var$pendingEffectsStatus = 0;
        $407866112e362b76$var$pendingFinishedWork = $407866112e362b76$var$pendingEffectsRoot = null;
        $407866112e362b76$var$pendingEffectsLanes = 0;
        if (0 !== ($407866112e362b76$var$executionContext & 6)) throw Error($407866112e362b76$var$formatProdErrorMessage(331));
        var prevExecutionContext = $407866112e362b76$var$executionContext;
        $407866112e362b76$var$executionContext |= 4;
        $407866112e362b76$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $407866112e362b76$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $407866112e362b76$var$executionContext = prevExecutionContext;
        $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($407866112e362b76$var$injectedHook && "function" === typeof $407866112e362b76$var$injectedHook.onPostCommitFiberRoot) try {
            $407866112e362b76$var$injectedHook.onPostCommitFiberRoot($407866112e362b76$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition, $407866112e362b76$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $407866112e362b76$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $407866112e362b76$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $407866112e362b76$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $407866112e362b76$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($407866112e362b76$var$markRootUpdated$1(rootFiber, 2), $407866112e362b76$var$ensureRootIsScheduled(rootFiber));
}
function $407866112e362b76$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $407866112e362b76$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $407866112e362b76$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed || !$407866112e362b76$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $407866112e362b76$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $407866112e362b76$var$createClassErrorUpdate(2);
                instance = $407866112e362b76$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($407866112e362b76$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $407866112e362b76$var$markRootUpdated$1(instance, 2), $407866112e362b76$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $407866112e362b76$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $407866112e362b76$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($407866112e362b76$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $407866112e362b76$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $407866112e362b76$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $407866112e362b76$var$workInProgressRoot === root && ($407866112e362b76$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $407866112e362b76$var$workInProgressRootExitStatus || 3 === $407866112e362b76$var$workInProgressRootExitStatus && ($407866112e362b76$var$workInProgressRootRenderLanes & 62914560) === $407866112e362b76$var$workInProgressRootRenderLanes && 300 > $407866112e362b76$var$now() - $407866112e362b76$var$globalMostRecentFallbackTime ? 0 === ($407866112e362b76$var$executionContext & 2) && $407866112e362b76$var$prepareFreshStack(root, 0) : $407866112e362b76$var$workInProgressRootPingedLanes |= pingedLanes, $407866112e362b76$var$workInProgressSuspendedRetryLanes === $407866112e362b76$var$workInProgressRootRenderLanes && ($407866112e362b76$var$workInProgressSuspendedRetryLanes = 0));
    $407866112e362b76$var$ensureRootIsScheduled(root);
}
function $407866112e362b76$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $407866112e362b76$var$claimNextRetryLane());
    boundaryFiber = $407866112e362b76$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($407866112e362b76$var$markRootUpdated$1(boundaryFiber, retryLane), $407866112e362b76$var$ensureRootIsScheduled(boundaryFiber));
}
function $407866112e362b76$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $407866112e362b76$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $407866112e362b76$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $407866112e362b76$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $407866112e362b76$var$scheduleCallback$1(priorityLevel, callback) {
    return $407866112e362b76$var$scheduleCallback$3(priorityLevel, callback);
}
var $407866112e362b76$var$firstScheduledRoot = null, $407866112e362b76$var$lastScheduledRoot = null, $407866112e362b76$var$didScheduleMicrotask = !1, $407866112e362b76$var$mightHavePendingSyncWork = !1, $407866112e362b76$var$isFlushingWork = !1, $407866112e362b76$var$currentEventTransitionLane = 0;
function $407866112e362b76$var$ensureRootIsScheduled(root) {
    root !== $407866112e362b76$var$lastScheduledRoot && null === root.next && (null === $407866112e362b76$var$lastScheduledRoot ? $407866112e362b76$var$firstScheduledRoot = $407866112e362b76$var$lastScheduledRoot = root : $407866112e362b76$var$lastScheduledRoot = $407866112e362b76$var$lastScheduledRoot.next = root);
    $407866112e362b76$var$mightHavePendingSyncWork = !0;
    $407866112e362b76$var$didScheduleMicrotask || ($407866112e362b76$var$didScheduleMicrotask = !0, $407866112e362b76$var$scheduleImmediateRootScheduleTask());
}
function $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$407866112e362b76$var$isFlushingWork && $407866112e362b76$var$mightHavePendingSyncWork) {
        $407866112e362b76$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $407866112e362b76$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $407866112e362b76$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $407866112e362b76$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $407866112e362b76$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $407866112e362b76$var$getNextLanes(root$174, root$174 === $407866112e362b76$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $407866112e362b76$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $407866112e362b76$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $407866112e362b76$var$isFlushingWork = !1;
    }
}
function $407866112e362b76$var$processRootScheduleInImmediateTask() {
    $407866112e362b76$var$processRootScheduleInMicrotask();
}
function $407866112e362b76$var$processRootScheduleInMicrotask() {
    $407866112e362b76$var$mightHavePendingSyncWork = $407866112e362b76$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $407866112e362b76$var$currentEventTransitionLane && ($407866112e362b76$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $407866112e362b76$var$currentEventTransitionLane), $407866112e362b76$var$currentEventTransitionLane = 0);
    for(var currentTime = $407866112e362b76$var$now(), prev = null, root = $407866112e362b76$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $407866112e362b76$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $407866112e362b76$var$firstScheduledRoot = next : prev.next = next, null === next && ($407866112e362b76$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $407866112e362b76$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $407866112e362b76$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $407866112e362b76$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $407866112e362b76$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $407866112e362b76$var$workInProgressRoot;
    suspendedLanes = $407866112e362b76$var$workInProgressRootRenderLanes;
    suspendedLanes = $407866112e362b76$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $407866112e362b76$var$workInProgressSuspendedReason || 9 === $407866112e362b76$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $407866112e362b76$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $407866112e362b76$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $407866112e362b76$var$cancelCallback$1(pingedLanes);
        switch($407866112e362b76$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $407866112e362b76$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $407866112e362b76$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $407866112e362b76$var$IdlePriority;
                break;
            default:
                suspendedLanes = $407866112e362b76$var$NormalPriority$1;
        }
        pingedLanes = $407866112e362b76$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $407866112e362b76$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $407866112e362b76$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $407866112e362b76$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $407866112e362b76$var$pendingEffectsStatus && 5 !== $407866112e362b76$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($407866112e362b76$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $407866112e362b76$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $407866112e362b76$var$getNextLanes(root, root === $407866112e362b76$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $407866112e362b76$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $407866112e362b76$var$scheduleTaskForRootDuringMicrotask(root, $407866112e362b76$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $407866112e362b76$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $407866112e362b76$var$performSyncWorkOnRoot(root, lanes) {
    if ($407866112e362b76$var$flushPendingEffects()) return null;
    $407866112e362b76$var$performWorkOnRoot(root, lanes, !0);
}
function $407866112e362b76$var$scheduleImmediateRootScheduleTask() {
    $407866112e362b76$var$scheduleMicrotask(function() {
        0 !== ($407866112e362b76$var$executionContext & 6) ? $407866112e362b76$var$scheduleCallback$3($407866112e362b76$var$ImmediatePriority, $407866112e362b76$var$processRootScheduleInImmediateTask) : $407866112e362b76$var$processRootScheduleInMicrotask();
    });
}
function $407866112e362b76$var$requestTransitionLane() {
    0 === $407866112e362b76$var$currentEventTransitionLane && ($407866112e362b76$var$currentEventTransitionLane = $407866112e362b76$var$claimNextTransitionLane());
    return $407866112e362b76$var$currentEventTransitionLane;
}
function $407866112e362b76$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $407866112e362b76$var$sanitizeURL("" + actionProp);
}
function $407866112e362b76$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $407866112e362b76$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $407866112e362b76$var$coerceFormActionProp((nativeEventTarget[$407866112e362b76$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$407866112e362b76$var$internalPropsKey] || null) ? $407866112e362b76$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $407866112e362b76$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $407866112e362b76$var$currentEventTransitionLane) {
                                var formData = submitter ? $407866112e362b76$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $407866112e362b76$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $407866112e362b76$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $407866112e362b76$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $407866112e362b76$var$i$jscomp$inline_1528 = 0; $407866112e362b76$var$i$jscomp$inline_1528 < $407866112e362b76$var$simpleEventPluginEvents.length; $407866112e362b76$var$i$jscomp$inline_1528++){
    var $407866112e362b76$var$eventName$jscomp$inline_1529 = $407866112e362b76$var$simpleEventPluginEvents[$407866112e362b76$var$i$jscomp$inline_1528], $407866112e362b76$var$domEventName$jscomp$inline_1530 = $407866112e362b76$var$eventName$jscomp$inline_1529.toLowerCase(), $407866112e362b76$var$capitalizedEvent$jscomp$inline_1531 = $407866112e362b76$var$eventName$jscomp$inline_1529[0].toUpperCase() + $407866112e362b76$var$eventName$jscomp$inline_1529.slice(1);
    $407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$domEventName$jscomp$inline_1530, "on" + $407866112e362b76$var$capitalizedEvent$jscomp$inline_1531);
}
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$ANIMATION_END, "onAnimationEnd");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$ANIMATION_ITERATION, "onAnimationIteration");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$ANIMATION_START, "onAnimationStart");
$407866112e362b76$var$registerSimpleEvent("dblclick", "onDoubleClick");
$407866112e362b76$var$registerSimpleEvent("focusin", "onFocus");
$407866112e362b76$var$registerSimpleEvent("focusout", "onBlur");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_RUN, "onTransitionRun");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_START, "onTransitionStart");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_CANCEL, "onTransitionCancel");
$407866112e362b76$var$registerSimpleEvent($407866112e362b76$var$TRANSITION_END, "onTransitionEnd");
$407866112e362b76$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$407866112e362b76$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$407866112e362b76$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$407866112e362b76$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$407866112e362b76$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$407866112e362b76$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$407866112e362b76$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $407866112e362b76$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $407866112e362b76$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($407866112e362b76$var$mediaEventTypes));
function $407866112e362b76$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $407866112e362b76$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $407866112e362b76$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $407866112e362b76$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$407866112e362b76$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$407866112e362b76$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($407866112e362b76$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $407866112e362b76$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $407866112e362b76$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $407866112e362b76$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $407866112e362b76$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$407866112e362b76$var$listeningMarker]) {
        rootContainerElement[$407866112e362b76$var$listeningMarker] = !0;
        $407866112e362b76$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($407866112e362b76$var$nonDelegatedEvents.has(domEventName) || $407866112e362b76$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $407866112e362b76$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$407866112e362b76$var$listeningMarker] || (ownerDocument[$407866112e362b76$var$listeningMarker] = !0, $407866112e362b76$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $407866112e362b76$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($407866112e362b76$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $407866112e362b76$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $407866112e362b76$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $407866112e362b76$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$407866112e362b76$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $407866112e362b76$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $407866112e362b76$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $407866112e362b76$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $407866112e362b76$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $407866112e362b76$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $407866112e362b76$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticTouchEvent;
                        break;
                    case $407866112e362b76$var$ANIMATION_END:
                    case $407866112e362b76$var$ANIMATION_ITERATION:
                    case $407866112e362b76$var$ANIMATION_START:
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticAnimationEvent;
                        break;
                    case $407866112e362b76$var$TRANSITION_END:
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $407866112e362b76$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $407866112e362b76$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($407866112e362b76$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $407866112e362b76$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($407866112e362b76$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$407866112e362b76$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $407866112e362b76$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $407866112e362b76$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $407866112e362b76$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $407866112e362b76$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $407866112e362b76$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $407866112e362b76$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $407866112e362b76$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $407866112e362b76$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $407866112e362b76$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $407866112e362b76$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $407866112e362b76$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $407866112e362b76$var$getParent(inCapturePhase);
                                reactEventName = $407866112e362b76$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $407866112e362b76$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $407866112e362b76$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $407866112e362b76$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $407866112e362b76$var$getTargetInstForChangeEvent;
                else if ($407866112e362b76$var$isTextInputElement(reactName)) {
                    if ($407866112e362b76$var$isInputEventSupported) getTargetInstFunc = $407866112e362b76$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $407866112e362b76$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $407866112e362b76$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $407866112e362b76$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $407866112e362b76$var$getTargetInstForChangeEvent) : getTargetInstFunc = $407866112e362b76$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $407866112e362b76$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $407866112e362b76$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $407866112e362b76$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($407866112e362b76$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $407866112e362b76$var$activeElement = handleEventFunc, $407866112e362b76$var$activeElementInst = targetInst, $407866112e362b76$var$lastSelection = null;
                    break;
                case "focusout":
                    $407866112e362b76$var$lastSelection = $407866112e362b76$var$activeElementInst = $407866112e362b76$var$activeElement = null;
                    break;
                case "mousedown":
                    $407866112e362b76$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $407866112e362b76$var$mouseDown = !1;
                    $407866112e362b76$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($407866112e362b76$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $407866112e362b76$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($407866112e362b76$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $407866112e362b76$var$isComposing ? $407866112e362b76$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($407866112e362b76$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($407866112e362b76$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $407866112e362b76$var$isComposing && (fallbackData = $407866112e362b76$var$getData()) : ($407866112e362b76$var$root = nativeEventTarget, $407866112e362b76$var$startText = "value" in $407866112e362b76$var$root ? $407866112e362b76$var$root.value : $407866112e362b76$var$root.textContent, $407866112e362b76$var$isComposing = !0)), handleEventFunc = $407866112e362b76$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $407866112e362b76$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $407866112e362b76$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $407866112e362b76$var$canUseTextInputEvent ? $407866112e362b76$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $407866112e362b76$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $407866112e362b76$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $407866112e362b76$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $407866112e362b76$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $407866112e362b76$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $407866112e362b76$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $407866112e362b76$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $407866112e362b76$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($407866112e362b76$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $407866112e362b76$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($407866112e362b76$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $407866112e362b76$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $407866112e362b76$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $407866112e362b76$var$getListener(target, registrationName), null != stateNode && listeners.unshift($407866112e362b76$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $407866112e362b76$var$getListener(target, registrationName), null != stateNode && listeners.push($407866112e362b76$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $407866112e362b76$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $407866112e362b76$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $407866112e362b76$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($407866112e362b76$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($407866112e362b76$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $407866112e362b76$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $407866112e362b76$var$normalizeMarkupForTextOrAttribute(clientText);
    return $407866112e362b76$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $407866112e362b76$var$noop$1() {}
function $407866112e362b76$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $407866112e362b76$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $407866112e362b76$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $407866112e362b76$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $407866112e362b76$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $407866112e362b76$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $407866112e362b76$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $407866112e362b76$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $407866112e362b76$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $407866112e362b76$var$setProp(domElement, tag, "name", props.name, props, null), $407866112e362b76$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $407866112e362b76$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $407866112e362b76$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($407866112e362b76$var$setProp(domElement, tag, "encType", props.encType, props, null), $407866112e362b76$var$setProp(domElement, tag, "method", props.method, props, null), $407866112e362b76$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $407866112e362b76$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $407866112e362b76$var$noop$1);
            break;
        case "onScroll":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($407866112e362b76$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($407866112e362b76$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $407866112e362b76$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $407866112e362b76$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", domElement);
            $407866112e362b76$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $407866112e362b76$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $407866112e362b76$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $407866112e362b76$var$aliases.get(key) || key, $407866112e362b76$var$setValueForAttribute(domElement, key, value);
    }
}
function $407866112e362b76$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $407866112e362b76$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($407866112e362b76$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($407866112e362b76$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $407866112e362b76$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $407866112e362b76$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $407866112e362b76$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $407866112e362b76$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$407866112e362b76$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$407866112e362b76$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $407866112e362b76$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $407866112e362b76$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                    default:
                        $407866112e362b76$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $407866112e362b76$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $407866112e362b76$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $407866112e362b76$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $407866112e362b76$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $407866112e362b76$var$track(domElement);
            return;
        case "select":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $407866112e362b76$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $407866112e362b76$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $407866112e362b76$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($407866112e362b76$var$formatProdErrorMessage(91));
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $407866112e362b76$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $407866112e362b76$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $407866112e362b76$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("cancel", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $407866112e362b76$var$mediaEventTypes.length; hasSrc++)$407866112e362b76$var$listenToNonDelegatedEvent($407866112e362b76$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", domElement);
            $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $407866112e362b76$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $407866112e362b76$var$listenToNonDelegatedEvent("error", domElement), $407866112e362b76$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                default:
                    $407866112e362b76$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($407866112e362b76$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $407866112e362b76$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $407866112e362b76$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $407866112e362b76$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $407866112e362b76$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $407866112e362b76$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $407866112e362b76$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $407866112e362b76$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $407866112e362b76$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $407866112e362b76$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $407866112e362b76$var$updateOptions(domElement, !!lastProps, tag, !0) : $407866112e362b76$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($407866112e362b76$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $407866112e362b76$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $407866112e362b76$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $407866112e362b76$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($407866112e362b76$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $407866112e362b76$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($407866112e362b76$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $407866112e362b76$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $407866112e362b76$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $407866112e362b76$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $407866112e362b76$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $407866112e362b76$var$eventsEnabled = null, $407866112e362b76$var$selectionInformation = null;
function $407866112e362b76$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $407866112e362b76$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $407866112e362b76$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $407866112e362b76$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $407866112e362b76$var$currentPopstateTransitionEvent = null;
function $407866112e362b76$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $407866112e362b76$var$currentPopstateTransitionEvent) return !1;
        $407866112e362b76$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $407866112e362b76$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $407866112e362b76$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $407866112e362b76$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $407866112e362b76$var$localPromise = "function" === typeof Promise ? Promise : void 0, $407866112e362b76$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $407866112e362b76$var$localPromise ? function(callback) {
    return $407866112e362b76$var$localPromise.resolve(null).then(callback).catch($407866112e362b76$var$handleErrorInNextTick);
} : $407866112e362b76$var$scheduleTimeout;
function $407866112e362b76$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $407866112e362b76$var$isSingletonScope(type) {
    return "head" === type;
}
function $407866112e362b76$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $407866112e362b76$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $407866112e362b76$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $407866112e362b76$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$407866112e362b76$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $407866112e362b76$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $407866112e362b76$var$retryIfBlockedOn(suspenseInstance);
}
function $407866112e362b76$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $407866112e362b76$var$clearContainerSparingly(node);
                $407866112e362b76$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $407866112e362b76$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$407866112e362b76$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $407866112e362b76$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $407866112e362b76$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $407866112e362b76$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $407866112e362b76$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $407866112e362b76$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $407866112e362b76$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $407866112e362b76$var$previousHydratableOnEnteringScopedSingleton = null;
function $407866112e362b76$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $407866112e362b76$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $407866112e362b76$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($407866112e362b76$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(451));
    }
}
function $407866112e362b76$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $407866112e362b76$var$detachDeletedInstance(instance);
}
var $407866112e362b76$var$preloadPropsMap = new Map(), $407866112e362b76$var$preconnectsSet = new Set();
function $407866112e362b76$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $407866112e362b76$var$previousDispatcher = $407866112e362b76$var$ReactDOMSharedInternals.d;
$407866112e362b76$var$ReactDOMSharedInternals.d = {
    f: $407866112e362b76$var$flushSyncWork,
    r: $407866112e362b76$var$requestFormReset,
    D: $407866112e362b76$var$prefetchDNS,
    C: $407866112e362b76$var$preconnect,
    L: $407866112e362b76$var$preload,
    m: $407866112e362b76$var$preloadModule,
    X: $407866112e362b76$var$preinitScript,
    S: $407866112e362b76$var$preinitStyle,
    M: $407866112e362b76$var$preinitModuleScript
};
function $407866112e362b76$var$flushSyncWork() {
    var previousWasRendering = $407866112e362b76$var$previousDispatcher.f(), wasRendering = $407866112e362b76$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $407866112e362b76$var$requestFormReset(form) {
    var formInst = $407866112e362b76$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $407866112e362b76$var$requestFormReset$1(formInst) : $407866112e362b76$var$previousDispatcher.r(form);
}
var $407866112e362b76$var$globalDocument = "undefined" === typeof document ? null : document;
function $407866112e362b76$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $407866112e362b76$var$preconnectsSet.has(limitedEscapedHref) || ($407866112e362b76$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $407866112e362b76$var$setInitialProperties(href, "link", rel), $407866112e362b76$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $407866112e362b76$var$prefetchDNS(href) {
    $407866112e362b76$var$previousDispatcher.D(href);
    $407866112e362b76$var$preconnectAs("dns-prefetch", href, null);
}
function $407866112e362b76$var$preconnect(href, crossOrigin) {
    $407866112e362b76$var$previousDispatcher.C(href, crossOrigin);
    $407866112e362b76$var$preconnectAs("preconnect", href, crossOrigin);
}
function $407866112e362b76$var$preload(href, as, options) {
    $407866112e362b76$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $407866112e362b76$var$getStyleKey(href);
                break;
            case "script":
                key = $407866112e362b76$var$getScriptKey(href);
        }
        $407866112e362b76$var$preloadPropsMap.has(key) || (href = $407866112e362b76$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $407866112e362b76$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $407866112e362b76$var$setInitialProperties(as, "link", href), $407866112e362b76$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $407866112e362b76$var$preloadModule(href, options) {
    $407866112e362b76$var$previousDispatcher.m(href, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $407866112e362b76$var$getScriptKey(href);
        }
        if (!$407866112e362b76$var$preloadPropsMap.has(key) && (href = $407866112e362b76$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $407866112e362b76$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $407866112e362b76$var$setInitialProperties(as, "link", href);
            $407866112e362b76$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $407866112e362b76$var$preinitStyle(href, precedence, options) {
    $407866112e362b76$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $407866112e362b76$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $407866112e362b76$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $407866112e362b76$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $407866112e362b76$var$markNodeAsHoistable(link);
                $407866112e362b76$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $407866112e362b76$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $407866112e362b76$var$preinitScript(src, options) {
    $407866112e362b76$var$previousDispatcher.X(src, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $407866112e362b76$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $407866112e362b76$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key)), resource || (src = $407866112e362b76$var$assign({
            src: src,
            async: !0
        }, options), (options = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $407866112e362b76$var$markNodeAsHoistable(resource), $407866112e362b76$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $407866112e362b76$var$preinitModuleScript(src, options) {
    $407866112e362b76$var$previousDispatcher.M(src, options);
    var ownerDocument = $407866112e362b76$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $407866112e362b76$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $407866112e362b76$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($407866112e362b76$var$getScriptSelectorFromKey(key)), resource || (src = $407866112e362b76$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $407866112e362b76$var$markNodeAsHoistable(resource), $407866112e362b76$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $407866112e362b76$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $407866112e362b76$var$rootInstanceStackCursor.current) ? $407866112e362b76$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($407866112e362b76$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $407866112e362b76$var$getStyleKey(pendingProps.href), pendingProps = $407866112e362b76$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $407866112e362b76$var$getStyleKey(pendingProps.href);
                var styles$244 = $407866112e362b76$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $407866112e362b76$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $407866112e362b76$var$preloadPropsMap.set(type, pendingProps), styles$244 || $407866112e362b76$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($407866112e362b76$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($407866112e362b76$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $407866112e362b76$var$getScriptKey(pendingProps), pendingProps = $407866112e362b76$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(444, type));
    }
}
function $407866112e362b76$var$getStyleKey(href) {
    return 'href="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $407866112e362b76$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $407866112e362b76$var$stylesheetPropsFromRawProps(rawProps) {
    return $407866112e362b76$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $407866112e362b76$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $407866112e362b76$var$setInitialProperties(key, "link", preloadProps), $407866112e362b76$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $407866112e362b76$var$getScriptKey(src) {
    return '[src="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $407866112e362b76$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $407866112e362b76$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $407866112e362b76$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $407866112e362b76$var$markNodeAsHoistable(instance), instance;
            var styleProps = $407866112e362b76$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $407866112e362b76$var$markNodeAsHoistable(instance);
            $407866112e362b76$var$setInitialProperties(instance, "style", styleProps);
            $407866112e362b76$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $407866112e362b76$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $407866112e362b76$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $407866112e362b76$var$stylesheetPropsFromRawProps(props);
            (styleProps = $407866112e362b76$var$preloadPropsMap.get(styleProps)) && $407866112e362b76$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $407866112e362b76$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $407866112e362b76$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $407866112e362b76$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $407866112e362b76$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($407866112e362b76$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $407866112e362b76$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $407866112e362b76$var$preloadPropsMap.get(instance$250)) instance = $407866112e362b76$var$assign({}, props), $407866112e362b76$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $407866112e362b76$var$markNodeAsHoistable(styleProps);
            $407866112e362b76$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($407866112e362b76$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $407866112e362b76$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $407866112e362b76$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $407866112e362b76$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $407866112e362b76$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $407866112e362b76$var$tagCaches = null;
function $407866112e362b76$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $407866112e362b76$var$tagCaches) {
        var cache = new Map();
        var caches = $407866112e362b76$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $407866112e362b76$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$407866112e362b76$var$internalHoistableMarker] || node[$407866112e362b76$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $407866112e362b76$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $407866112e362b76$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $407866112e362b76$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $407866112e362b76$var$suspendedState = null;
function $407866112e362b76$var$noop() {}
function $407866112e362b76$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $407866112e362b76$var$suspendedState) throw Error($407866112e362b76$var$formatProdErrorMessage(475));
    var state = $407866112e362b76$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $407866112e362b76$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($407866112e362b76$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $407866112e362b76$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $407866112e362b76$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $407866112e362b76$var$stylesheetPropsFromRawProps(props);
            (key = $407866112e362b76$var$preloadPropsMap.get(key)) && $407866112e362b76$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $407866112e362b76$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $407866112e362b76$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $407866112e362b76$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $407866112e362b76$var$waitForCommitToBeReady() {
    if (null === $407866112e362b76$var$suspendedState) throw Error($407866112e362b76$var$formatProdErrorMessage(475));
    var state = $407866112e362b76$var$suspendedState;
    state.stylesheets && 0 === state.count && $407866112e362b76$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $407866112e362b76$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $407866112e362b76$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $407866112e362b76$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $407866112e362b76$var$precedencesByRoot = null;
function $407866112e362b76$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $407866112e362b76$var$precedencesByRoot = new Map(), resources.forEach($407866112e362b76$var$insertStylesheetIntoRoot, state), $407866112e362b76$var$precedencesByRoot = null, $407866112e362b76$var$onUnsuspend.call(state));
}
function $407866112e362b76$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $407866112e362b76$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $407866112e362b76$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $407866112e362b76$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $407866112e362b76$var$HostTransitionContext = {
    $$typeof: $407866112e362b76$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $407866112e362b76$var$sharedNotPendingObject,
    _currentValue2: $407866112e362b76$var$sharedNotPendingObject,
    _threadCount: 0
};
function $407866112e362b76$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $407866112e362b76$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $407866112e362b76$var$createLaneMap(0);
    this.hiddenUpdates = $407866112e362b76$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $407866112e362b76$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $407866112e362b76$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $407866112e362b76$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $407866112e362b76$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $407866112e362b76$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $407866112e362b76$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $407866112e362b76$var$emptyContextObject;
    parentComponent = $407866112e362b76$var$emptyContextObject;
    return parentComponent;
}
function $407866112e362b76$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $407866112e362b76$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $407866112e362b76$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $407866112e362b76$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($407866112e362b76$var$scheduleUpdateOnFiber(element, rootFiber, lane), $407866112e362b76$var$entangleTransitions(element, rootFiber, lane));
}
function $407866112e362b76$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $407866112e362b76$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $407866112e362b76$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $407866112e362b76$var$markRetryLaneImpl(fiber, retryLane);
}
function $407866112e362b76$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $407866112e362b76$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $407866112e362b76$var$_enabled = !0;
function $407866112e362b76$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $407866112e362b76$var$ReactSharedInternals.T;
    $407866112e362b76$var$ReactSharedInternals.T = null;
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        $407866112e362b76$var$ReactDOMSharedInternals.p = 2, $407866112e362b76$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
    }
}
function $407866112e362b76$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $407866112e362b76$var$ReactSharedInternals.T;
    $407866112e362b76$var$ReactSharedInternals.T = null;
    var previousPriority = $407866112e362b76$var$ReactDOMSharedInternals.p;
    try {
        $407866112e362b76$var$ReactDOMSharedInternals.p = 8, $407866112e362b76$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $407866112e362b76$var$ReactDOMSharedInternals.p = previousPriority, $407866112e362b76$var$ReactSharedInternals.T = prevTransition;
    }
}
function $407866112e362b76$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($407866112e362b76$var$_enabled) {
        var blockedOn = $407866112e362b76$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $407866112e362b76$var$return_targetInst, targetContainer), $407866112e362b76$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($407866112e362b76$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($407866112e362b76$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $407866112e362b76$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $407866112e362b76$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $407866112e362b76$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $407866112e362b76$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $407866112e362b76$var$ensureRootIsScheduled(fiber);
                                0 === ($407866112e362b76$var$executionContext & 6) && ($407866112e362b76$var$workInProgressRootRenderTargetTime = $407866112e362b76$var$now() + 500, $407866112e362b76$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $407866112e362b76$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, fiber, 2), $407866112e362b76$var$flushSyncWork$1(), $407866112e362b76$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $407866112e362b76$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $407866112e362b76$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $407866112e362b76$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $407866112e362b76$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $407866112e362b76$var$getEventTarget(nativeEvent);
    return $407866112e362b76$var$findInstanceBlockingTarget(nativeEvent);
}
var $407866112e362b76$var$return_targetInst = null;
function $407866112e362b76$var$findInstanceBlockingTarget(targetNode) {
    $407866112e362b76$var$return_targetInst = null;
    targetNode = $407866112e362b76$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $407866112e362b76$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $407866112e362b76$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $407866112e362b76$var$return_targetInst = targetNode;
    return null;
}
function $407866112e362b76$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($407866112e362b76$var$getCurrentPriorityLevel()){
                case $407866112e362b76$var$ImmediatePriority:
                    return 2;
                case $407866112e362b76$var$UserBlockingPriority:
                    return 8;
                case $407866112e362b76$var$NormalPriority$1:
                case $407866112e362b76$var$LowPriority:
                    return 32;
                case $407866112e362b76$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $407866112e362b76$var$hasScheduledReplayAttempt = !1, $407866112e362b76$var$queuedFocus = null, $407866112e362b76$var$queuedDrag = null, $407866112e362b76$var$queuedMouse = null, $407866112e362b76$var$queuedPointers = new Map(), $407866112e362b76$var$queuedPointerCaptures = new Map(), $407866112e362b76$var$queuedExplicitHydrationTargets = [], $407866112e362b76$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $407866112e362b76$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $407866112e362b76$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $407866112e362b76$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $407866112e362b76$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $407866112e362b76$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $407866112e362b76$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $407866112e362b76$var$getInstanceFromNode(blockedOn), null !== blockedOn && $407866112e362b76$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $407866112e362b76$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $407866112e362b76$var$queuedFocus = $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $407866112e362b76$var$queuedDrag = $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $407866112e362b76$var$queuedMouse = $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $407866112e362b76$var$queuedPointers.set(pointerId, $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $407866112e362b76$var$queuedPointerCaptures.set(pointerId, $407866112e362b76$var$accumulateOrCreateContinuousQueuedReplayableEvent($407866112e362b76$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $407866112e362b76$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $407866112e362b76$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $407866112e362b76$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $407866112e362b76$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $407866112e362b76$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $407866112e362b76$var$requestUpdateLane();
                            lane = $407866112e362b76$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $407866112e362b76$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $407866112e362b76$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $407866112e362b76$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $407866112e362b76$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $407866112e362b76$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $407866112e362b76$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $407866112e362b76$var$currentReplayingEvent = null;
        } else return targetContainers = $407866112e362b76$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $407866112e362b76$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $407866112e362b76$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $407866112e362b76$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $407866112e362b76$var$replayUnblockedEvents() {
    $407866112e362b76$var$hasScheduledReplayAttempt = !1;
    null !== $407866112e362b76$var$queuedFocus && $407866112e362b76$var$attemptReplayContinuousQueuedEvent($407866112e362b76$var$queuedFocus) && ($407866112e362b76$var$queuedFocus = null);
    null !== $407866112e362b76$var$queuedDrag && $407866112e362b76$var$attemptReplayContinuousQueuedEvent($407866112e362b76$var$queuedDrag) && ($407866112e362b76$var$queuedDrag = null);
    null !== $407866112e362b76$var$queuedMouse && $407866112e362b76$var$attemptReplayContinuousQueuedEvent($407866112e362b76$var$queuedMouse) && ($407866112e362b76$var$queuedMouse = null);
    $407866112e362b76$var$queuedPointers.forEach($407866112e362b76$var$attemptReplayContinuousQueuedEventInMap);
    $407866112e362b76$var$queuedPointerCaptures.forEach($407866112e362b76$var$attemptReplayContinuousQueuedEventInMap);
}
function $407866112e362b76$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $407866112e362b76$var$hasScheduledReplayAttempt || ($407866112e362b76$var$hasScheduledReplayAttempt = !0, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, $407866112e362b76$var$replayUnblockedEvents)));
}
var $407866112e362b76$var$lastScheduledReplayQueue = null;
function $407866112e362b76$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $407866112e362b76$var$lastScheduledReplayQueue !== formReplayingQueue && ($407866112e362b76$var$lastScheduledReplayQueue = formReplayingQueue, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, function() {
        $407866112e362b76$var$lastScheduledReplayQueue === formReplayingQueue && ($407866112e362b76$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $407866112e362b76$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $407866112e362b76$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $407866112e362b76$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $407866112e362b76$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $407866112e362b76$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $407866112e362b76$var$queuedFocus && $407866112e362b76$var$scheduleCallbackIfUnblocked($407866112e362b76$var$queuedFocus, unblocked);
    null !== $407866112e362b76$var$queuedDrag && $407866112e362b76$var$scheduleCallbackIfUnblocked($407866112e362b76$var$queuedDrag, unblocked);
    null !== $407866112e362b76$var$queuedMouse && $407866112e362b76$var$scheduleCallbackIfUnblocked($407866112e362b76$var$queuedMouse, unblocked);
    $407866112e362b76$var$queuedPointers.forEach(unblock);
    $407866112e362b76$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $407866112e362b76$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $407866112e362b76$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $407866112e362b76$var$queuedExplicitHydrationTargets.length && (i = $407866112e362b76$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$407866112e362b76$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $407866112e362b76$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$407866112e362b76$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $407866112e362b76$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$407866112e362b76$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $407866112e362b76$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $407866112e362b76$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $407866112e362b76$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$407866112e362b76$var$ReactDOMHydrationRoot.prototype.render = $407866112e362b76$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($407866112e362b76$var$formatProdErrorMessage(409));
    var current = root.current, lane = $407866112e362b76$var$requestUpdateLane();
    $407866112e362b76$var$updateContainerImpl(current, lane, children, root, null, null);
};
$407866112e362b76$var$ReactDOMHydrationRoot.prototype.unmount = $407866112e362b76$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $407866112e362b76$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $407866112e362b76$var$flushSyncWork$1();
        container[$407866112e362b76$var$internalContainerInstanceKey] = null;
    }
};
function $407866112e362b76$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$407866112e362b76$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $407866112e362b76$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $407866112e362b76$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $407866112e362b76$var$queuedExplicitHydrationTargets[i].priority; i++);
        $407866112e362b76$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $407866112e362b76$var$attemptExplicitHydrationTarget(target);
    }
};
var $407866112e362b76$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $8vqx4.version;
if ("19.1.0" !== $407866112e362b76$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($407866112e362b76$var$formatProdErrorMessage(527, $407866112e362b76$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$407866112e362b76$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($407866112e362b76$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($407866112e362b76$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $407866112e362b76$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $407866112e362b76$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $407866112e362b76$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $407866112e362b76$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $407866112e362b76$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$407866112e362b76$var$hook$jscomp$inline_2257.isDisabled && $407866112e362b76$var$hook$jscomp$inline_2257.supportsFiber) try {
        $407866112e362b76$var$rendererID = $407866112e362b76$var$hook$jscomp$inline_2257.inject($407866112e362b76$var$internals$jscomp$inline_2256), $407866112e362b76$var$injectedHook = $407866112e362b76$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$407866112e362b76$export$882461b6382ed46c = function(container, options) {
    if (!$407866112e362b76$var$isValidContainer(container)) throw Error($407866112e362b76$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $407866112e362b76$var$defaultOnUncaughtError, onCaughtError = $407866112e362b76$var$defaultOnCaughtError, onRecoverableError = $407866112e362b76$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $407866112e362b76$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$407866112e362b76$var$internalContainerInstanceKey] = options.current;
    $407866112e362b76$var$listenToAllSupportedEvents(container);
    return new $407866112e362b76$var$ReactDOMRoot(options);
};
$407866112e362b76$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$407866112e362b76$var$isValidContainer(container)) throw Error($407866112e362b76$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $407866112e362b76$var$defaultOnUncaughtError, onCaughtError = $407866112e362b76$var$defaultOnCaughtError, onRecoverableError = $407866112e362b76$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $407866112e362b76$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $407866112e362b76$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $407866112e362b76$var$requestUpdateLane();
    isStrictMode = $407866112e362b76$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $407866112e362b76$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $407866112e362b76$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $407866112e362b76$var$markRootUpdated$1(initialChildren, options);
    $407866112e362b76$var$ensureRootIsScheduled(initialChildren);
    container[$407866112e362b76$var$internalContainerInstanceKey] = initialChildren.current;
    $407866112e362b76$var$listenToAllSupportedEvents(container);
    return new $407866112e362b76$var$ReactDOMHydrationRoot(initialChildren);
};
$407866112e362b76$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("hNfVH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k8s7f"));

});
parcelRegister("k8s7f", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $ea8a5d3bfd1fa17f$export$c4744153514ff05d, (v) => $ea8a5d3bfd1fa17f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7, (v) => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875, (v) => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1, (v) => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4, (v) => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $ea8a5d3bfd1fa17f$export$c27134553091fb3a, (v) => $ea8a5d3bfd1fa17f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2, (v) => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2, (v) => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b, (v) => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555, (v) => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b, (v) => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1, (v) => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0, (v) => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f, (v) => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed, (v) => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a, (v) => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea8a5d3bfd1fa17f$export$c4744153514ff05d;
var $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7;
var $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875;
var $ea8a5d3bfd1fa17f$export$502329bbf4b505b1;
var $ea8a5d3bfd1fa17f$export$6e3807111c4874c4;
var $ea8a5d3bfd1fa17f$export$c27134553091fb3a;
var $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2;
var $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2;
var $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b;
var $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555;
var $ea8a5d3bfd1fa17f$export$72fdf0e06517287b;
var $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1;
var $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0;
var $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f;
var $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed;
var $ea8a5d3bfd1fa17f$export$cf845f2c119da08a;
"use strict";
function $ea8a5d3bfd1fa17f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $ea8a5d3bfd1fa17f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $ea8a5d3bfd1fa17f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $ea8a5d3bfd1fa17f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $ea8a5d3bfd1fa17f$var$compare(left, last)) rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $ea8a5d3bfd1fa17f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$ea8a5d3bfd1fa17f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ea8a5d3bfd1fa17f$var$localPerformance = performance;
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localPerformance.now();
    };
} else {
    var $ea8a5d3bfd1fa17f$var$localDate = Date, $ea8a5d3bfd1fa17f$var$initialTime = $ea8a5d3bfd1fa17f$var$localDate.now();
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localDate.now() - $ea8a5d3bfd1fa17f$var$initialTime;
    };
}
var $ea8a5d3bfd1fa17f$var$taskQueue = [], $ea8a5d3bfd1fa17f$var$timerQueue = [], $ea8a5d3bfd1fa17f$var$taskIdCounter = 1, $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = 3, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1, $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1, $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$needsPaint = !1, $ea8a5d3bfd1fa17f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $ea8a5d3bfd1fa17f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $ea8a5d3bfd1fa17f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime) {
    for(var timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue);
        else if (timer.startTime <= currentTime) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue), timer.sortIndex = timer.expirationTime, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, timer);
        else break;
        timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
    }
}
function $ea8a5d3bfd1fa17f$var$handleTimeout(currentTime) {
    $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1;
    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
    if (!$ea8a5d3bfd1fa17f$var$isHostCallbackScheduled) {
        if (null !== $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue)) $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1, $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1, $ea8a5d3bfd1fa17f$var$frameInterval = 5, $ea8a5d3bfd1fa17f$var$startTime = -1;
function $ea8a5d3bfd1fa17f$var$shouldYieldToHost() {
    return $ea8a5d3bfd1fa17f$var$needsPaint ? !0 : $ea8a5d3bfd1fa17f$export$c4744153514ff05d() - $ea8a5d3bfd1fa17f$var$startTime < $ea8a5d3bfd1fa17f$var$frameInterval ? !1 : !0;
}
function $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !1;
    if ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning) {
        var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
        $ea8a5d3bfd1fa17f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1;
                $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1);
                $ea8a5d3bfd1fa17f$var$isPerformingWork = !0;
                var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
                try {
                    b: {
                        $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                        for($ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue); null !== $ea8a5d3bfd1fa17f$var$currentTask && !($ea8a5d3bfd1fa17f$var$currentTask.expirationTime > currentTime && $ea8a5d3bfd1fa17f$var$shouldYieldToHost());){
                            var callback = $ea8a5d3bfd1fa17f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $ea8a5d3bfd1fa17f$var$currentTask.callback = null;
                                $ea8a5d3bfd1fa17f$var$currentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($ea8a5d3bfd1fa17f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $ea8a5d3bfd1fa17f$var$currentTask.callback = continuationCallback;
                                    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $ea8a5d3bfd1fa17f$var$currentTask === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                                $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                            } else $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                            $ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue);
                        }
                        if (null !== $ea8a5d3bfd1fa17f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
                            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline() : $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1;
        }
    }
}
var $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $ea8a5d3bfd1fa17f$var$localSetImmediate) $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetImmediate($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ea8a5d3bfd1fa17f$var$channel = new MessageChannel(), $ea8a5d3bfd1fa17f$var$port = $ea8a5d3bfd1fa17f$var$channel.port2;
    $ea8a5d3bfd1fa17f$var$channel.port1.onmessage = $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline;
    $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
        $ea8a5d3bfd1fa17f$var$port.postMessage(null);
    };
} else $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetTimeout($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline, 0);
};
function $ea8a5d3bfd1fa17f$var$requestHostTimeout(callback, ms) {
    $ea8a5d3bfd1fa17f$var$taskTimeoutID = $ea8a5d3bfd1fa17f$var$localSetTimeout(function() {
        callback($ea8a5d3bfd1fa17f$export$c4744153514ff05d());
    }, ms);
}
$ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = 5;
$ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = 1;
$ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = 4;
$ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = 3;
$ea8a5d3bfd1fa17f$export$c27134553091fb3a = null;
$ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = 2;
$ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ea8a5d3bfd1fa17f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = function() {
    return $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
};
$ea8a5d3bfd1fa17f$export$72fdf0e06517287b = function(eventHandler) {
    switch($ea8a5d3bfd1fa17f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = function() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !0;
};
$ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $ea8a5d3bfd1fa17f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$timerQueue, priorityLevel), null === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && priorityLevel === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue) && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled ? ($ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1) : $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !0, $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, priorityLevel), $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled || $ea8a5d3bfd1fa17f$var$isPerformingWork || ($ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = $ea8a5d3bfd1fa17f$var$shouldYieldToHost;
$ea8a5d3bfd1fa17f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8vqx4", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eij5T"));

});

parcelRegister("hiyfL", function(module, exports) {
'use strict';
function $c97eb012c82a0807$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c97eb012c82a0807$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c97eb012c82a0807$var$checkDCE();

module.exports = (parcelRequire("dDCtE"));

});
parcelRegister("dDCtE", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $028ff2a3c3210a6f$export$69ce8ef3fe5cead0, (v) => $028ff2a3c3210a6f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $028ff2a3c3210a6f$export$d39a5bbd09211389, (v) => $028ff2a3c3210a6f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $028ff2a3c3210a6f$export$cd75ccfd720a3cd4, (v) => $028ff2a3c3210a6f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $028ff2a3c3210a6f$export$a0816fa17a9e79be, (v) => $028ff2a3c3210a6f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $028ff2a3c3210a6f$export$7292efcadded39f3, (v) => $028ff2a3c3210a6f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $028ff2a3c3210a6f$export$da407abadb9b8f86, (v) => $028ff2a3c3210a6f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $028ff2a3c3210a6f$export$314cfea32580671c, (v) => $028ff2a3c3210a6f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $028ff2a3c3210a6f$export$513ccb98c53b8039, (v) => $028ff2a3c3210a6f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $028ff2a3c3210a6f$export$dbca993bc2d264a, (v) => $028ff2a3c3210a6f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $028ff2a3c3210a6f$export$4797a8006f0655d0, (v) => $028ff2a3c3210a6f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $028ff2a3c3210a6f$export$c78a37762a8d58e1, (v) => $028ff2a3c3210a6f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $028ff2a3c3210a6f$export$606f11b2eb45ecc6, (v) => $028ff2a3c3210a6f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $028ff2a3c3210a6f$export$f7e8a0bf92324b1e, (v) => $028ff2a3c3210a6f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $028ff2a3c3210a6f$export$83d89fbfd8236492, (v) => $028ff2a3c3210a6f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $028ff2a3c3210a6f$export$69ce8ef3fe5cead0;
var $028ff2a3c3210a6f$export$d39a5bbd09211389;
var $028ff2a3c3210a6f$export$cd75ccfd720a3cd4;
var $028ff2a3c3210a6f$export$a0816fa17a9e79be;
var $028ff2a3c3210a6f$export$7292efcadded39f3;
var $028ff2a3c3210a6f$export$da407abadb9b8f86;
var $028ff2a3c3210a6f$export$314cfea32580671c;
var $028ff2a3c3210a6f$export$513ccb98c53b8039;
var $028ff2a3c3210a6f$export$dbca993bc2d264a;
var $028ff2a3c3210a6f$export$4797a8006f0655d0;
var $028ff2a3c3210a6f$export$c78a37762a8d58e1;
var $028ff2a3c3210a6f$export$606f11b2eb45ecc6;
var $028ff2a3c3210a6f$export$f7e8a0bf92324b1e;
var $028ff2a3c3210a6f$export$83d89fbfd8236492;
"use strict";

var $8vqx4 = parcelRequire("8vqx4");
function $028ff2a3c3210a6f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $028ff2a3c3210a6f$var$noop() {}
var $028ff2a3c3210a6f$var$Internals = {
    d: {
        f: $028ff2a3c3210a6f$var$noop,
        r: function() {
            throw Error($028ff2a3c3210a6f$var$formatProdErrorMessage(522));
        },
        D: $028ff2a3c3210a6f$var$noop,
        C: $028ff2a3c3210a6f$var$noop,
        L: $028ff2a3c3210a6f$var$noop,
        m: $028ff2a3c3210a6f$var$noop,
        X: $028ff2a3c3210a6f$var$noop,
        S: $028ff2a3c3210a6f$var$noop,
        M: $028ff2a3c3210a6f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $028ff2a3c3210a6f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $028ff2a3c3210a6f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $028ff2a3c3210a6f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $028ff2a3c3210a6f$var$ReactSharedInternals = $8vqx4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $028ff2a3c3210a6f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$028ff2a3c3210a6f$export$69ce8ef3fe5cead0 = $028ff2a3c3210a6f$var$Internals;
$028ff2a3c3210a6f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($028ff2a3c3210a6f$var$formatProdErrorMessage(299));
    return $028ff2a3c3210a6f$var$createPortal$1(children, container, null, key);
};
$028ff2a3c3210a6f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $028ff2a3c3210a6f$var$ReactSharedInternals.T, previousUpdatePriority = $028ff2a3c3210a6f$var$Internals.p;
    try {
        if ($028ff2a3c3210a6f$var$ReactSharedInternals.T = null, $028ff2a3c3210a6f$var$Internals.p = 2, fn) return fn();
    } finally{
        $028ff2a3c3210a6f$var$ReactSharedInternals.T = previousTransition, $028ff2a3c3210a6f$var$Internals.p = previousUpdatePriority, $028ff2a3c3210a6f$var$Internals.d.f();
    }
};
$028ff2a3c3210a6f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $028ff2a3c3210a6f$var$Internals.d.C(href, options));
};
$028ff2a3c3210a6f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $028ff2a3c3210a6f$var$Internals.d.D(href);
};
$028ff2a3c3210a6f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $028ff2a3c3210a6f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $028ff2a3c3210a6f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$028ff2a3c3210a6f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $028ff2a3c3210a6f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $028ff2a3c3210a6f$var$Internals.d.M(href);
    }
};
$028ff2a3c3210a6f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $028ff2a3c3210a6f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$028ff2a3c3210a6f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $028ff2a3c3210a6f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $028ff2a3c3210a6f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $028ff2a3c3210a6f$var$Internals.d.m(href);
    }
};
$028ff2a3c3210a6f$export$4797a8006f0655d0 = function(form) {
    $028ff2a3c3210a6f$var$Internals.d.r(form);
};
$028ff2a3c3210a6f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$028ff2a3c3210a6f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $028ff2a3c3210a6f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$028ff2a3c3210a6f$export$f7e8a0bf92324b1e = function() {
    return $028ff2a3c3210a6f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$028ff2a3c3210a6f$export$83d89fbfd8236492 = "19.1.0";

});



var $607ae91d1eb97195$exports = {};
'use strict';

$607ae91d1eb97195$exports = (parcelRequire("irwyI"));


parcelRequire("8vqx4");
var $ffa230115876cfd8$exports = {};
'use strict';
function $ffa230115876cfd8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ffa230115876cfd8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ffa230115876cfd8$var$checkDCE();

$ffa230115876cfd8$exports = (parcelRequire("5xaMB"));




var $8vqx4 = parcelRequire("8vqx4");
const $9a8a56a12274a4e6$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $9a8a56a12274a4e6$export$2e2bcd8739ae039 = {
    randomUUID: $9a8a56a12274a4e6$var$randomUUID
};


let $f4a5158367982ab3$var$getRandomValues;
const $f4a5158367982ab3$var$rnds8 = new Uint8Array(16);
function $f4a5158367982ab3$export$2e2bcd8739ae039() {
    if (!$f4a5158367982ab3$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $f4a5158367982ab3$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $f4a5158367982ab3$var$getRandomValues($f4a5158367982ab3$var$rnds8);
}


var $ace9ac19994b3b54$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $2ae9293b8c262cdd$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $ace9ac19994b3b54$export$2e2bcd8739ae039).test(uuid);
}
var $2ae9293b8c262cdd$export$2e2bcd8739ae039 = $2ae9293b8c262cdd$var$validate;


const $f741dc08baac5627$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$f741dc08baac5627$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $f741dc08baac5627$export$8fb373d660548968(arr, offset = 0) {
    return ($f741dc08baac5627$var$byteToHex[arr[offset + 0]] + $f741dc08baac5627$var$byteToHex[arr[offset + 1]] + $f741dc08baac5627$var$byteToHex[arr[offset + 2]] + $f741dc08baac5627$var$byteToHex[arr[offset + 3]] + '-' + $f741dc08baac5627$var$byteToHex[arr[offset + 4]] + $f741dc08baac5627$var$byteToHex[arr[offset + 5]] + '-' + $f741dc08baac5627$var$byteToHex[arr[offset + 6]] + $f741dc08baac5627$var$byteToHex[arr[offset + 7]] + '-' + $f741dc08baac5627$var$byteToHex[arr[offset + 8]] + $f741dc08baac5627$var$byteToHex[arr[offset + 9]] + '-' + $f741dc08baac5627$var$byteToHex[arr[offset + 10]] + $f741dc08baac5627$var$byteToHex[arr[offset + 11]] + $f741dc08baac5627$var$byteToHex[arr[offset + 12]] + $f741dc08baac5627$var$byteToHex[arr[offset + 13]] + $f741dc08baac5627$var$byteToHex[arr[offset + 14]] + $f741dc08baac5627$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $f741dc08baac5627$var$stringify(arr, offset = 0) {
    const uuid = $f741dc08baac5627$export$8fb373d660548968(arr, offset);
    if (!(0, $2ae9293b8c262cdd$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $f741dc08baac5627$export$2e2bcd8739ae039 = $f741dc08baac5627$var$stringify;


function $922d6c3c8287bac3$var$v4(options, buf, offset) {
    if ((0, $9a8a56a12274a4e6$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $9a8a56a12274a4e6$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $f4a5158367982ab3$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $f741dc08baac5627$export$8fb373d660548968)(rnds);
}
var $922d6c3c8287bac3$export$2e2bcd8739ae039 = $922d6c3c8287bac3$var$v4;


var $62cfc7684ca064cb$exports = {};
/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    $62cfc7684ca064cb$exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : $62cfc7684ca064cb$exports, function() {
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var __defProp = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __export = (target, all)=>{
        for(var name in all)__defProp(target, name, {
            get: all[name],
            enumerable: true
        });
    };
    var __copyProps = (to, from, except, desc)=>{
        if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                get: ()=>from[key],
                enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
            });
        }
        return to;
    };
    var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
            value: true
        }), mod);
    // src/marked.ts
    var marked_exports = {};
    __export(marked_exports, {
        Hooks: ()=>_Hooks,
        Lexer: ()=>_Lexer,
        Marked: ()=>Marked,
        Parser: ()=>_Parser,
        Renderer: ()=>_Renderer,
        TextRenderer: ()=>_TextRenderer,
        Tokenizer: ()=>_Tokenizer,
        defaults: ()=>_defaults,
        getDefaults: ()=>_getDefaults,
        lexer: ()=>lexer,
        marked: ()=>marked,
        options: ()=>options,
        parse: ()=>parse,
        parseInline: ()=>parseInline,
        parser: ()=>parser,
        setOptions: ()=>setOptions,
        use: ()=>use,
        walkTokens: ()=>walkTokens
    });
    module1.exports = __toCommonJS(marked_exports);
    // src/defaults.ts
    function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    var _defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        _defaults = newDefaults;
    }
    // src/rules.ts
    var noopTest = {
        exec: ()=>null
    };
    function edit(regex, opt = "") {
        let source = typeof regex === "string" ? regex : regex.source;
        const obj = {
            replace: (name, val)=>{
                let valSource = typeof val === "string" ? val : val.source;
                valSource = valSource.replace(other.caret, "$1");
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(source, opt);
            }
        };
        return obj;
    }
    var other = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceTabs: /^\t+/,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] /,
        listReplaceTask: /^\[[ xX]\] +/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
        hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
        htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
    };
    var newline = /^(?:[ \t]*(?:\n|$))+/;
    var blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
    var fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    var hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    var heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    var bullet = /(?:[*+-]|\d{1,9}[.)])/;
    var lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
    var lheading = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
    var lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
    var _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    var blockText = /^[^\n]+/;
    var _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    var def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
    var list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
    var _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    var _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    var html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    var paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
    var blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
    var blockNormal = {
        blockquote: blockquote,
        code: blockCode,
        def: def,
        fences: fences,
        heading: heading,
        hr: hr,
        html: html,
        lheading: lheading,
        list: list,
        newline: newline,
        paragraph: paragraph,
        table: noopTest,
        text: blockText
    };
    var gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
    var blockGfm = {
        ...blockNormal,
        lheading: lheadingGfm,
        table: gfmTable,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex()
    };
    var blockPedantic = {
        ...blockNormal,
        html: edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    };
    var escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    var inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    var br = /^( {2,}|\\)\n(?!\s*$)/;
    var inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    var _punctuation = /[\p{P}\p{S}]/u;
    var _punctuationOrSpace = /[\s\p{P}\p{S}]/u;
    var _notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
    var punctuation = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, _punctuationOrSpace).getRegex();
    var _punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
    var _punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
    var _notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
    var blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
    var emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
    var emStrongLDelim = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuation).getRegex();
    var emStrongLDelimGfm = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    var emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
    var emStrongRDelimAst = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    var emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    var emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    var anyPunctuation = edit(/\\(punct)/, "gu").replace(/punct/g, _punctuation).getRegex();
    var autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
    var _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
    var tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
    var _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    var link = edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
    var reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
    var nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
    var reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
    var inlineNormal = {
        _backpedal: noopTest,
        anyPunctuation: // only used for GFM url
        anyPunctuation,
        autolink: autolink,
        blockSkip: blockSkip,
        br: br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim: emStrongLDelim,
        emStrongRDelimAst: emStrongRDelimAst,
        emStrongRDelimUnd: emStrongRDelimUnd,
        escape: escape,
        link: link,
        nolink: nolink,
        punctuation: punctuation,
        reflink: reflink,
        reflinkSearch: reflinkSearch,
        tag: tag,
        text: inlineText,
        url: noopTest
    };
    var inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
    };
    var inlineGfm = {
        ...inlineNormal,
        emStrongRDelimAst: emStrongRDelimAstGfm,
        emStrongLDelim: emStrongLDelimGfm,
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    var inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace("{2,}", "*").getRegex(),
        text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    };
    var block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic
    };
    var inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic
    };
    // src/helpers.ts
    var escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    var getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape2(html2, encode) {
        if (encode) {
            if (other.escapeTest.test(html2)) return html2.replace(other.escapeReplace, getEscapeReplacement);
        } else {
            if (other.escapeTestNoEncode.test(html2)) return html2.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html2;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(other.percentDecode, "%");
        } catch  {
            return null;
        }
        return href;
    }
    function splitCells(tableRow, count) {
        const row = tableRow.replace(other.findPipe, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) return "|";
            else return " |";
        }), cells = row.split(other.splitPipe);
        let i = 0;
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push("");
        }
        for(; i < cells.length; i++)cells[i] = cells[i].trim().replace(other.slashPipe, "|");
        return cells;
    }
    function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return "";
        let suffLen = 0;
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        if (level > 0) return -2;
        return -1;
    }
    // src/Tokenizer.ts
    function outputLink(cap, link2, raw, lexer2, rules) {
        const href = link2.href;
        const title = link2.title || null;
        const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
        lexer2.state.inLink = true;
        const token = {
            type: cap[0].charAt(0) === "!" ? "image" : "link",
            raw: raw,
            href: href,
            title: title,
            text: text,
            tokens: lexer2.inlineTokens(text)
        };
        lexer2.state.inLink = false;
        return token;
    }
    function indentCodeCompensation(raw, text, rules) {
        const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split("\n").map((node)=>{
            const matchIndentInNode = node.match(rules.other.beginningSpace);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    var _Tokenizer = class {
        options;
        rules;
        // set by the lexer
        lexer;
        // set by the lexer
        constructor(options2){
            this.options = options2 || _defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || "", this.rules);
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                if (this.rules.other.endingHash.test(text)) {
                    const trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: rtrim(cap[0], "\n")
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                let lines = rtrim(cap[0], "\n").split("\n");
                let raw = "";
                let text = "";
                const tokens = [];
                while(lines.length > 0){
                    let inBlockquote = false;
                    const currentLines = [];
                    let i;
                    for(i = 0; i < lines.length; i++){
                        if (this.rules.other.blockquoteStart.test(lines[i])) {
                            currentLines.push(lines[i]);
                            inBlockquote = true;
                        } else if (!inBlockquote) currentLines.push(lines[i]);
                        else break;
                    }
                    lines = lines.slice(i);
                    const currentRaw = currentLines.join("\n");
                    const currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                    raw = raw ? `${raw}
${currentRaw}` : currentRaw;
                    text = text ? `${text}
${currentText}` : currentText;
                    const top = this.lexer.state.top;
                    this.lexer.state.top = true;
                    this.lexer.blockTokens(currentText, tokens, true);
                    this.lexer.state.top = top;
                    if (lines.length === 0) break;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "code") break;
                    else if (lastToken?.type === "blockquote") {
                        const oldToken = lastToken;
                        const newText = oldToken.raw + "\n" + lines.join("\n");
                        const newToken = this.blockquote(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                        break;
                    } else if (lastToken?.type === "list") {
                        const oldToken = lastToken;
                        const newText = oldToken.raw + "\n" + lines.join("\n");
                        const newToken = this.list(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                        lines = newText.substring(tokens.at(-1).raw.length).split("\n");
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: raw,
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list2 = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                const itemRegex = this.rules.other.listItemRegex(bull);
                let endsWithBlankLine = false;
                while(src){
                    let endEarly = false;
                    let raw = "";
                    let itemContents = "";
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>" ".repeat(3 * t.length));
                    let nextLine = src.split("\n", 1)[0];
                    let blankLine = !line.trim();
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else if (blankLine) indent = cap[1].length + 1;
                    else {
                        indent = cap[2].search(this.rules.other.nonSpaceChar);
                        indent = indent > 4 ? 1 : indent;
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                        const hrRegex = this.rules.other.hrRegex(indent);
                        const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                        const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                        const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                        while(src){
                            const rawLine = src.split("\n", 1)[0];
                            let nextLineWithoutTabs;
                            nextLine = rawLine;
                            if (this.options.pedantic) {
                                nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                                nextLineWithoutTabs = nextLine;
                            } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                            if (fencesBeginRegex.test(nextLine)) break;
                            if (headingBeginRegex.test(nextLine)) break;
                            if (htmlBeginRegex.test(nextLine)) break;
                            if (nextBulletRegex.test(nextLine)) break;
                            if (hrRegex.test(nextLine)) break;
                            if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                            else {
                                if (blankLine) break;
                                if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLineWithoutTabs.slice(indent);
                        }
                    }
                    if (!list2.loose) {
                        if (endsWithBlankLine) list2.loose = true;
                        else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    if (this.options.gfm) {
                        istask = this.rules.other.listIsTask.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                        }
                    }
                    list2.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list2.raw += raw;
                }
                const lastItem = list2.items.at(-1);
                if (lastItem) {
                    lastItem.raw = lastItem.raw.trimEnd();
                    lastItem.text = lastItem.text.trimEnd();
                } else return;
                list2.raw = list2.raw.trimEnd();
                for(let i = 0; i < list2.items.length; i++){
                    this.lexer.state.top = false;
                    list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                    if (!list2.loose) {
                        const spacers = list2.items[i].tokens.filter((t)=>t.type === "space");
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                        list2.loose = hasMultipleLineBreaks;
                    }
                }
                if (list2.loose) for(let i = 0; i < list2.items.length; i++)list2.items[i].loose = true;
                return list2;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: "html",
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
                const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag2,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) return;
            if (!this.rules.other.tableDelimiter.test(cap[2])) return;
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
            const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
            const item = {
                type: "table",
                raw: cap[0],
                header: [],
                align: [],
                rows: []
            };
            if (headers.length !== aligns.length) return;
            for (const align of aligns){
                if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
                else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
                else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
                else item.align.push(null);
            }
            for(let i = 0; i < headers.length; i++)item.header.push({
                text: headers[i],
                tokens: this.lexer.inline(headers[i]),
                header: true,
                align: item.align[i]
            });
            for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell, i)=>{
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell),
                    header: false,
                    align: item.align[i]
                };
            }));
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: cap[1]
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                    if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    const lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex === -2) return;
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                let href = cap[2];
                let title = "";
                if (this.options.pedantic) {
                    const link2 = this.rules.other.pedanticHrefTitle.exec(href);
                    if (link2) {
                        href = link2[1];
                        title = link2[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (this.rules.other.startAngleBracket.test(href)) {
                    if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                }, cap[0], this.lexer, this.rules);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
                const link2 = links[linkString.toLowerCase()];
                if (!link2) {
                    const text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link2, cap[0], this.lexer, this.rules);
            }
        }
        emStrong(src, maskedSrc, prevChar = "") {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match) return;
            if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
            const nextChar = match[1] || match[2] || "";
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue;
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue;
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue;
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    const lastCharLength = [
                        ...match[0]
                    ][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    if (Math.min(lLength, rLength) % 2) {
                        const text2 = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: text2,
                            tokens: this.lexer.inlineTokens(text2)
                        };
                    }
                    const text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
                const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === "@") {
                    text = cap[1];
                    href = "mailto:" + text;
                } else {
                    text = cap[1];
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === "@") {
                    text = cap[0];
                    href = "mailto:" + text;
                } else {
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                    }while (prevCapZero !== cap[0]);
                    text = cap[0];
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                const escaped = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: cap[0],
                    text: cap[0],
                    escaped: escaped
                };
            }
        }
    };
    // src/Lexer.ts
    var _Lexer = class __Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options2){
            this.tokens = [];
            this.tokens.links = /* @__PURE__ */ Object.create(null);
            this.options = options2 || _defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                other: other,
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
   * Expose Rules
   */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
   * Static Lex Method
   */ static lex(src, options2) {
            const lexer2 = new __Lexer(options2);
            return lexer2.lex(src);
        }
        /**
   * Static Lex Inline Method
   */ static lexInline(src, options2) {
            const lexer2 = new __Lexer(options2);
            return lexer2.inlineTokens(src);
        }
        /**
   * Preprocessing
   */ lex(src) {
            src = src.replace(other.carriageReturn, "\n");
            this.blockTokens(src, this.tokens);
            for(let i = 0; i < this.inlineQueue.length; i++){
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = [], lastParagraphClipped = false) {
            if (this.options.pedantic) src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
            while(src){
                let token;
                if (this.options.extensions?.block?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                let cutSrc = src;
                if (this.options.extensions?.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    const lastToken = tokens.at(-1);
                    if (lastParagraphClipped && lastToken?.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
   * Lexing/Compiling
   */ inlineTokens(src, tokens = []) {
            let maskedSrc = src;
            let match = null;
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            let keepPrevChar = false;
            let prevChar = "";
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                let token;
                if (this.options.extensions?.inline?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.type === "text" && lastToken?.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                let cutSrc = src;
                if (this.options.extensions?.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    };
    // src/Renderer.ts
    var _Renderer = class {
        options;
        parser;
        // set by the parser
        constructor(options2){
            this.options = options2 || _defaults;
        }
        space(token) {
            return "";
        }
        code({ text: text, lang: lang, escaped: escaped }) {
            const langString = (lang || "").match(other.notSpaceStart)?.[0];
            const code = text.replace(other.endingNewline, "") + "\n";
            if (!langString) return "<pre><code>" + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
            return '<pre><code class="language-' + escape2(langString) + '">' + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
        }
        blockquote({ tokens: tokens }) {
            const body = this.parser.parse(tokens);
            return `<blockquote>
${body}</blockquote>
`;
        }
        html({ text: text }) {
            return text;
        }
        heading({ tokens: tokens, depth: depth }) {
            return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>
`;
        }
        hr(token) {
            return "<hr>\n";
        }
        list(token) {
            const ordered = token.ordered;
            const start = token.start;
            let body = "";
            for(let j = 0; j < token.items.length; j++){
                const item = token.items[j];
                body += this.listitem(item);
            }
            const type = ordered ? "ol" : "ul";
            const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
        }
        listitem(item) {
            let itemBody = "";
            if (item.task) {
                const checkbox = this.checkbox({
                    checked: !!item.checked
                });
                if (item.loose) {
                    if (item.tokens[0]?.type === "paragraph") {
                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                            item.tokens[0].tokens[0].text = checkbox + " " + escape2(item.tokens[0].tokens[0].text);
                            item.tokens[0].tokens[0].escaped = true;
                        }
                    } else item.tokens.unshift({
                        type: "text",
                        raw: checkbox + " ",
                        text: checkbox + " ",
                        escaped: true
                    });
                } else itemBody += checkbox + " ";
            }
            itemBody += this.parser.parse(item.tokens, !!item.loose);
            return `<li>${itemBody}</li>
`;
        }
        checkbox({ checked: checked }) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens: tokens }) {
            return `<p>${this.parser.parseInline(tokens)}</p>
`;
        }
        table(token) {
            let header = "";
            let cell = "";
            for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
            header += this.tablerow({
                text: cell
            });
            let body = "";
            for(let j = 0; j < token.rows.length; j++){
                const row = token.rows[j];
                cell = "";
                for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                body += this.tablerow({
                    text: cell
                });
            }
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        }
        tablerow({ text: text }) {
            return `<tr>
${text}</tr>
`;
        }
        tablecell(token) {
            const content = this.parser.parseInline(token.tokens);
            const type = token.header ? "th" : "td";
            const tag2 = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
            return tag2 + content + `</${type}>
`;
        }
        /**
   * span level renderer
   */ strong({ tokens: tokens }) {
            return `<strong>${this.parser.parseInline(tokens)}</strong>`;
        }
        em({ tokens: tokens }) {
            return `<em>${this.parser.parseInline(tokens)}</em>`;
        }
        codespan({ text: text }) {
            return `<code>${escape2(text, true)}</code>`;
        }
        br(token) {
            return "<br>";
        }
        del({ tokens: tokens }) {
            return `<del>${this.parser.parseInline(tokens)}</del>`;
        }
        link({ href: href, title: title, tokens: tokens }) {
            const text = this.parser.parseInline(tokens);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + escape2(title) + '"';
            out += ">" + text + "</a>";
            return out;
        }
        image({ href: href, title: title, text: text, tokens: tokens }) {
            if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return escape2(text);
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${escape2(title)}"`;
            out += ">";
            return out;
        }
        text(token) {
            return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : escape2(token.text);
        }
    };
    // src/TextRenderer.ts
    var _TextRenderer = class {
        // no need for block level renderers
        strong({ text: text }) {
            return text;
        }
        em({ text: text }) {
            return text;
        }
        codespan({ text: text }) {
            return text;
        }
        del({ text: text }) {
            return text;
        }
        html({ text: text }) {
            return text;
        }
        text({ text: text }) {
            return text;
        }
        link({ text: text }) {
            return "" + text;
        }
        image({ text: text }) {
            return "" + text;
        }
        br() {
            return "";
        }
    };
    // src/Parser.ts
    var _Parser = class __Parser {
        options;
        renderer;
        textRenderer;
        constructor(options2){
            this.options = options2 || _defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.renderer.parser = this;
            this.textRenderer = new _TextRenderer();
        }
        /**
   * Static Parse Method
   */ static parse(tokens, options2) {
            const parser2 = new __Parser(options2);
            return parser2.parse(tokens);
        }
        /**
   * Static Parse Inline Method
   */ static parseInline(tokens, options2) {
            const parser2 = new __Parser(options2);
            return parser2.parseInline(tokens);
        }
        /**
   * Parse Loop
   */ parse(tokens, top = true) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const genericToken = anyToken;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(genericToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case "space":
                        out += this.renderer.space(token);
                        continue;
                    case "hr":
                        out += this.renderer.hr(token);
                        continue;
                    case "heading":
                        out += this.renderer.heading(token);
                        continue;
                    case "code":
                        out += this.renderer.code(token);
                        continue;
                    case "table":
                        out += this.renderer.table(token);
                        continue;
                    case "blockquote":
                        out += this.renderer.blockquote(token);
                        continue;
                    case "list":
                        out += this.renderer.list(token);
                        continue;
                    case "html":
                        out += this.renderer.html(token);
                        continue;
                    case "paragraph":
                        out += this.renderer.paragraph(token);
                        continue;
                    case "text":
                        {
                            let textToken = token;
                            let body = this.renderer.text(textToken);
                            while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                textToken = tokens[++i];
                                body += "\n" + this.renderer.text(textToken);
                            }
                            if (top) out += this.renderer.paragraph({
                                type: "paragraph",
                                raw: body,
                                text: body,
                                tokens: [
                                    {
                                        type: "text",
                                        raw: body,
                                        text: body,
                                        escaped: true
                                    }
                                ]
                            });
                            else out += body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
   * Parse Inline Tokens
   */ parseInline(tokens, renderer = this.renderer) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const ret = this.options.extensions.renderers[anyToken.type].call({
                        parser: this
                    }, anyToken);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(anyToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case "escape":
                        out += renderer.text(token);
                        break;
                    case "html":
                        out += renderer.html(token);
                        break;
                    case "link":
                        out += renderer.link(token);
                        break;
                    case "image":
                        out += renderer.image(token);
                        break;
                    case "strong":
                        out += renderer.strong(token);
                        break;
                    case "em":
                        out += renderer.em(token);
                        break;
                    case "codespan":
                        out += renderer.codespan(token);
                        break;
                    case "br":
                        out += renderer.br(token);
                        break;
                    case "del":
                        out += renderer.del(token);
                        break;
                    case "text":
                        out += renderer.text(token);
                        break;
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    };
    // src/Hooks.ts
    var _Hooks = class {
        options;
        block;
        constructor(options2){
            this.options = options2 || _defaults;
        }
        static passThroughHooks = /* @__PURE__ */ new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        /**
   * Process markdown before marked
   */ preprocess(markdown) {
            return markdown;
        }
        /**
   * Process HTML after marked is finished
   */ postprocess(html2) {
            return html2;
        }
        /**
   * Process all tokens before walk tokens
   */ processAllTokens(tokens) {
            return tokens;
        }
        /**
   * Provide function to tokenize markdown
   */ provideLexer() {
            return this.block ? _Lexer.lex : _Lexer.lexInline;
        }
        /**
   * Provide function to parse tokens
   */ provideParser() {
            return this.block ? _Parser.parse : _Parser.parseInline;
        }
    };
    // src/Instance.ts
    var Marked = class {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.parseMarkdown(true);
        parseInline = this.parseMarkdown(false);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
   * Run callback for every token
   */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case "table":
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case "list":
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                const tokens2 = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens2, callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                const opts = {
                    ...pack
                };
                opts.async = this.defaults.async || opts.async || false;
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error("extension name required");
                        if ("renderer" in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) extensions.renderers[ext.name] = function(...args2) {
                                let ret = ext.renderer.apply(this, args2);
                                if (ret === false) ret = prevRenderer.apply(this, args2);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ("tokenizer" in ext) {
                            if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === "block") {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === "inline") {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(prop)) continue;
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        renderer[rendererProp] = (...args2)=>{
                            let ret = rendererFunc.apply(renderer, args2);
                            if (ret === false) ret = prevRenderer.apply(renderer, args2);
                            return ret || "";
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(prop)) continue;
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        tokenizer[tokenizerProp] = (...args2)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args2);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(prop)) continue;
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) hooks[hooksProp] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret2)=>{
                                return prevHook.call(hooks, ret2);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else hooks[hooksProp] = (...args2)=>{
                            let ret = hooksFunc.apply(hooks, args2);
                            if (ret === false) ret = prevHook.apply(hooks, args2);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                if (pack.walkTokens) {
                    const walkTokens2 = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        lexer(src, options2) {
            return _Lexer.lex(src, options2 ?? this.defaults);
        }
        parser(tokens, options2) {
            return _Parser.parse(tokens, options2 ?? this.defaults);
        }
        parseMarkdown(blockType) {
            const parse2 = (src, options2)=>{
                const origOpt = {
                    ...options2
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                const throwError = this.onError(!!opt.silent, !!opt.async);
                if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                if (opt.hooks) {
                    opt.hooks.options = opt;
                    opt.hooks.block = blockType;
                }
                const lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                const parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src2)=>lexer2(src2, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser2(tokens, opt)).then((html2)=>opt.hooks ? opt.hooks.postprocess(html2) : html2).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    let tokens = lexer2(src, opt);
                    if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html2 = parser2(tokens, opt);
                    if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                    return html2;
                } catch (e) {
                    return throwError(e);
                }
            };
            return parse2;
        }
        onError(silent, async) {
            return (e)=>{
                e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                if (silent) {
                    const msg = "<p>An error occurred:</p><pre>" + escape2(e.message + "", true) + "</pre>";
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    };
    // src/marked.ts
    var markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    marked.options = marked.setOptions = function(options2) {
        markedInstance.setOptions(options2);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = _getDefaults;
    marked.defaults = _defaults;
    marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    marked.parseInline = markedInstance.parseInline;
    marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    var options = marked.options;
    var setOptions = marked.setOptions;
    var use = marked.use;
    var walkTokens = marked.walkTokens;
    var parseInline = marked.parseInline;
    var parse = marked;
    var parser = _Parser.parse;
    var lexer = _Lexer.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});


const $540271f4c8f7b579$export$e73c8bd0f20705a = ()=>{
    return (0, $922d6c3c8287bac3$export$2e2bcd8739ae039)();
};
const $540271f4c8f7b579$export$eee65e95941714f9 = (str)=>{
    try {
        return encodeURIComponent(str || '');
    } catch (e) {
        console.error("Error encoding URI component:", str, e);
        return '';
    }
};
const $540271f4c8f7b579$export$bd6a2eae5de02ff5 = async (text)=>{
    try {
        return await (0, $62cfc7684ca064cb$exports.marked).parse(text);
    } catch (e) {
        console.error('Error parsing markdown:', e);
        // Fallback to basic markdown conversion
        return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\*(.*?)\*/g, '<em>$1</em>').replace(/\n/g, '<br>');
    }
};
const $540271f4c8f7b579$export$3ae94a2503e890a1 = (dateString)=>{
    try {
        const date = new Date(dateString);
        return date.toLocaleString();
    } catch (e) {
        return dateString;
    }
};
const $540271f4c8f7b579$export$e6a965f54a0a7c7 = (color)=>{
    const wineColor = (color || '').toLowerCase();
    if (wineColor === 'red') return 'red';
    if (wineColor === 'white') return 'white';
    if (wineColor === "ros\xe9" || wineColor === 'rose') return 'rose';
    return 'unknown';
};
const $540271f4c8f7b579$export$47ad85e557275125 = (warehouseName)=>{
    const warehouse = (warehouseName || '').toLowerCase();
    if (warehouse.includes('hong kong')) return {
        filename: 'hk.png',
        text: 'HK'
    };
    else if (warehouse.includes('united kingdom')) return {
        filename: 'uk.png',
        text: 'UK'
    };
    else if (warehouse.includes('bordeaux') || warehouse.includes('burgundy')) return {
        filename: 'fr.png',
        text: 'FR'
    };
    else if (warehouse.includes('singapore')) return {
        filename: 'sg.png',
        text: 'SG'
    };
    else return {
        filename: 'default.png',
        text: '?'
    };
};
const $540271f4c8f7b579$export$8be853786101e32a = (offer, user)=>{
    const baseUrl = "https://www.wwxplorer.com";
    // Extract and encode fields for new URL pattern
    const color = $540271f4c8f7b579$export$eee65e95941714f9(offer.color || 'Red');
    const wineType = $540271f4c8f7b579$export$eee65e95941714f9(offer.type || 'Still');
    const vintage = $540271f4c8f7b579$export$eee65e95941714f9(offer.vintage || 'NV');
    const packingSize = $540271f4c8f7b579$export$eee65e95941714f9(`${offer.quantity_per_case || '1'} x ${offer.volume || '75cl'}`);
    const country = 'all'; // Country not available in database, using 'all' as default
    const variety = '-'; // Variety not available in database, using '-' as placeholder
    const oid = $540271f4c8f7b579$export$eee65e95941714f9(offer.offer_oid || offer.offer_id);
    const displayName = $540271f4c8f7b579$export$eee65e95941714f9(offer.display_name || offer.processed_wine_name || '').toLowerCase().replace(/\s+/g, ' ');
    const producer = $540271f4c8f7b579$export$eee65e95941714f9(offer.processed_producer);
    const moreInfoUrl = `${baseUrl}/product${producer ? `/producer/${producer}` : ''}/product/${displayName}/color/${color}/type/${wineType}/vintage/${vintage}/packing/${packingSize}`;
    // Keep the buy now URL as is for now, or update if needed
    const wineHash = $540271f4c8f7b579$export$eee65e95941714f9(offer.wine_hash);
    const buyNowUrl = user ? `${baseUrl}/place-order/wine/${wineHash}/${color}/${wineType}/-/${vintage}/${packingSize}?offerId=${offer.offer_id}` : `${baseUrl}/signup`;
    return {
        moreInfoUrl: moreInfoUrl,
        buyNowUrl: buyNowUrl
    };
};
const $540271f4c8f7b579$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return function executedFunction(...args) {
        const later = ()=>{
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
const $540271f4c8f7b579$export$d0a8044dce8ff2fc = ()=>{
    return typeof window !== 'undefined' && window.innerWidth <= 768;
};
const $540271f4c8f7b579$export$ddcffe0146c8f882 = {
    get: (key)=>{
        try {
            return localStorage.getItem(key);
        } catch (e) {
            console.error('Error reading from localStorage:', e);
            return null;
        }
    },
    set: (key, value)=>{
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.error('Error writing to localStorage:', e);
        }
    },
    remove: (key)=>{
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.error('Error removing from localStorage:', e);
        }
    }
};


// Configurable static image path using environment variable
const $1844453eead66305$export$2b7ec69d3a5398bf = "https://zyra.wwxplorer.com/static/images";
const $1844453eead66305$export$af227afd9ab8dcbf = (path)=>`${$1844453eead66305$export$2b7ec69d3a5398bf}/${path}`;
const $1844453eead66305$export$7037112d28c7d171 = "https://zyra.wwxplorer.com";
const $1844453eead66305$export$22e11c0aab7270fe = "https://www.wwxplorer.com";




var $8vqx4 = parcelRequire("8vqx4");

parcelRequire("8vqx4");

const $c6f992c0bda97824$var$AssistantIcon = ()=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
        src: (0, $1844453eead66305$export$af227afd9ab8dcbf)('robot.svg'),
        className: "assistant-icon",
        alt: "AI Icon"
    });
var $c6f992c0bda97824$export$2e2bcd8739ae039 = $c6f992c0bda97824$var$AssistantIcon;



parcelRequire("8vqx4");
const $4f624a1400dc4e31$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "offer-loading-indicator",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "offer-spinner"
        })
    });
var $4f624a1400dc4e31$export$2e2bcd8739ae039 = $4f624a1400dc4e31$var$LoadingSpinner;




var $8vqx4 = parcelRequire("8vqx4");


var $8vqx4 = parcelRequire("8vqx4");


var $48c4cd70bac13fb6$exports = {};
$48c4cd70bac13fb6$exports = JSON.parse('{"greeting":"Hello! How can I help you with wine today?","thinking":"\u2728 Thinking...","thinkingStep":"\u2728 Thinking... {step}","askAboutWine":"E.g. 1990s Bordeaux Red around $1500 | Burgundy village white below $600","askAboutWineFirst":"I want to buy (region + color + vintage + budget)","waitingForResponse":"Waiting for response...","dailyLimitReached":"You\'ve reached the daily advisory limit. Please come back after 00:00 HKT to continue.","chatHistory":"Your Chat History","noChatHistory":"No chat history yet","startConversation":"Start a conversation to see it here","backToChat":"Back to Chat","newChat":"New Chat","history":"History","search":"Search","whatsapp":"WhatsApp","wineAdvisor":"Wine Advisor","chat":"Chat","chatNumber":"Chat {number}","wineRecommended":"{count} wine recommended","winesRecommended":"{count} wines recommended","justNow":"Just now","minuteAgo":"{count} minute ago","minutesAgo":"{count} minutes ago","hourAgo":"{count} hour ago","hoursAgo":"{count} hours ago","dayAgo":"{count} day ago","daysAgo":"{count} days ago","noMessagesYet":"No messages yet","perBottle":"Per Bottle","priceNA":"Price N/A","buyNow":"Buy Now","moreInformation":"More Information","share":{"button":"Share","title":"Share Conversation","description":"Share this conversation with your friends using the link below:","generating":"Generating share link...","error":"Failed to generate share link","copy":"Copy","copied":"Copied!","note":"Note: This link will expire in 30 days. When someone opens this link, they will see a copy of this conversation."},"checkOutWine":"Check out this wine: {name} {vintage}","linkCopied":"Link copied to clipboard!","contactWhatsApp":"Contact us on WhatsApp for more options","errorLoadingWine":"Sorry, I couldn\'t load the wine details.","errorOccurred":"An error occurred while fetching the response.","you":"You","welcome":{"intro":"Welcome to WWX, I\u2019m Zyra, your AI Wine Advisor. You can access:","features":{"globalMarket":"Global Fine Wine Market (UK, FR, HK sellers)","realTimeOffers":"Real-Time Best Offers Within Your Budget","personalized":"Personalized Recommendations Just For You","comparison":"Vintage & Brand Comparison Made Easy","instantCheckout":"Instant Quantities & Shipping Checkout"},"question":"What can I recommend for you today?","trendingPrompts":"Example Queries","promptExamples":{"title":"How to ask:","good":"\u2713 Good examples:","bad":"\u2717 Avoid prompts without budget:"},"prompts":{"bordeaux":"Bordeaux Red around $800","champagne":"Grower champagne below $2000","firstGrowth":"Best offer first growth 2010-2019"}},"feedback":{"helpful":"This was helpful","notHelpful":"This wasn\'t helpful","thankYou":"Thank you for your feedback!","whatDidYouLike":"What did you like?","whatCouldBeImproved":"What could be improved?","category":"Category","selectCategory":"Select a category","categories":{"accuracy":"Accuracy","helpfulness":"Helpfulness","responseSpeed":"Response Speed","clarity":"Clarity","other":"Other"},"comments":"Comments","placeholder":"Tell us more about your experience...","cancel":"Cancel","submit":"Submit Feedback","submitting":"Submitting..."},"auth":{"limitReached":"Daily Limit Reached","signUpToday":"Sign Up for More Messages","limitMessage":"You\'ve reached your daily message limit. Sign up for a free account to continue the chat.","benefitsMessage":"Create a free account to continue chatting and save your chat history across devices.","remainingMessages":"You have {count} messages remaining today","signUp":"Sign Up","login":"Log In","loggedInAs":"Logged in as {email}","logout":"Log Out"}}');


var $ae9935d62d3affa2$exports = {};
$ae9935d62d3affa2$exports = JSON.parse('{"greeting":"\u60A8\u597D\uFF01\u6211\u53EF\u4EE5\u5982\u4F55\u5354\u52A9\u60A8\u9078\u64C7\u8461\u8404\u9152\uFF1F","thinking":"\u2728 \u601D\u8003\u4E2D...","thinkingStep":"\u2728 \u601D\u8003\u4E2D... {step}","askAboutWine":"\u4F8B\u5982\uFF1A1990\u5E74\u4EE3\u6CE2\u723E\u591A\u7D05\u9152\u7D04$1500 | \u52C3\u6839\u5730\u6751\u838A\u767D\u9152\u4F4E\u65BC$600","askAboutWineFirst":"\u6211\u60F3\u5C0B\u627E\u8461\u8404\u9152...\uFF08\u7522\u5730 + \u8461\u8404\u9152\u984F\u8272 + \u5E74\u4EFD + \u50F9\u683C\uFF09","waitingForResponse":"\u7B49\u5F85\u56DE\u61C9\u4E2D...","dailyLimitReached":"\u60A8\u5DF2\u9054\u5230\u4ECA\u65E5\u7684\u8AEE\u8A62\u9650\u984D\u3002\u8ACB\u65BC\u9999\u6E2F\u6642\u9593 00:00 \u5F8C\u518D\u6B21\u8A2A\u554F\u3002","chatHistory":"\u60A8\u7684\u804A\u5929\u8A18\u9304","noChatHistory":"\u5C1A\u7121\u804A\u5929\u8A18\u9304","startConversation":"\u958B\u59CB\u5C0D\u8A71\u4EE5\u67E5\u770B\u8A18\u9304","backToChat":"\u8FD4\u56DE\u804A\u5929","newChat":"\u65B0\u804A\u5929","history":"\u8A18\u9304","search":"\u641C\u5C0B","whatsapp":"WhatsApp","wineAdvisor":"\u60A8\u7684\u5C08\u5C6C\u8461\u8404\u9152\u9867\u554F","chat":"\u804A\u5929","chatNumber":"\u804A\u5929 {number}","wineRecommended":"\u63A8\u85A6\u4E86 {count} \u6B3E\u8461\u8404\u9152","winesRecommended":"\u63A8\u85A6\u4E86 {count} \u6B3E\u8461\u8404\u9152","justNow":"\u525B\u525B","minuteAgo":"{count} \u5206\u9418\u524D","minutesAgo":"{count} \u5206\u9418\u524D","hourAgo":"{count} \u5C0F\u6642\u524D","hoursAgo":"{count} \u5C0F\u6642\u524D","dayAgo":"{count} \u5929\u524D","daysAgo":"{count} \u5929\u524D","noMessagesYet":"\u5C1A\u7121\u8A0A\u606F","perBottle":"\u6BCF\u74F6","priceNA":"\u50F9\u683C\u4E0D\u8A73","buyNow":"\u7ACB\u5373\u8CFC\u8CB7","moreInformation":"\u66F4\u591A\u8CC7\u8A0A","share":{"button":"\u5206\u4EAB","title":"\u5206\u4EAB\u5C0D\u8A71","description":"\u4F7F\u7528\u4E0B\u9762\u7684\u9023\u7D50\u8207\u670B\u53CB\u5206\u4EAB\u9019\u6BB5\u5C0D\u8A71\uFF1A","generating":"\u6B63\u5728\u751F\u6210\u5206\u4EAB\u9023\u7D50...","error":"\u751F\u6210\u5206\u4EAB\u9023\u7D50\u5931\u6557","copy":"\u8907\u88FD","copied":"\u5DF2\u8907\u88FD\uFF01","note":"\u6CE8\u610F\uFF1A\u6B64\u9023\u7D50\u5C07\u572830\u5929\u5F8C\u904E\u671F\u3002\u7576\u6709\u4EBA\u6253\u958B\u6B64\u9023\u7D50\u6642\uFF0C\u4ED6\u5011\u5C07\u770B\u5230\u9019\u6BB5\u5C0D\u8A71\u7684\u526F\u672C\u3002"},"checkOutWine":"\u770B\u770B\u9019\u6B3E\u8461\u8404\u9152\uFF1A{name} {vintage}","linkCopied":"\u9023\u7D50\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F\uFF01","contactWhatsApp":"\u900F\u904E WhatsApp \u806F\u7D61\u6211\u5011\u4EE5\u7372\u5F97\u66F4\u591A\u9078\u64C7","errorLoadingWine":"\u62B1\u6B49\uFF0C\u7121\u6CD5\u8F09\u5165\u8461\u8404\u9152\u8A73\u7D30\u8CC7\u8A0A\u3002","errorOccurred":"\u7372\u53D6\u56DE\u61C9\u6642\u767C\u751F\u932F\u8AA4\u3002","you":"\u60A8","welcome":{"intro":"\u6211\u662FZyra\uFF0C\u60A8\u7684\u667A\u80FD\u8461\u8404\u9152\u9867\u554F\uFF0C\u6211\u53EF\u4EE5\u70BA\u60A8\u5EFA\u8B70\uFF1A","features":{"globalMarket":"\u8DE8\u5E02\u5834\uFF08\u82F1\u570B\u3001\u6CD5\u570B\u3001\u9999\u6E2F\uFF09\u8CA8\u6E90\u5BE6\u6642\u5831\u50F9\u548C\u6578\u91CF","personalized":"\u6309\u60A8\u7684\u9810\u7B97\u5EFA\u8B70\u6700\u5408\u9069\u7684\u9078\u64C7","instantCheckout":"\u7D50\u5E33\u4ED8\u6B3E\u3001\u7269\u6D41\u914D\u9001\u548C\u5009\u5B58\u9078\u9805"},"question":"Zyra \u8AA0\u610F\u70BA\u60A8\u63A8\u85A6...","trendingPrompts":"\u7BC4\u4F8B\u67E5\u8A62\uFF08\u76EE\u524D\u8CA8\u5E63\u8A2D\u5B9A\u662F\u6E2F\u5E63\uFF09","promptExamples":{"title":"\u5982\u4F55\u8A62\u554F\uFF1A","good":"\u2713 \u826F\u597D\u7BC4\u4F8B\uFF1A","bad":"\u2717 \u907F\u514D\u6C92\u6709\u9810\u7B97\u7684\u67E5\u8A62\uFF1A"},"prompts":{"bordeaux":"800\u7F8E\u5143\u5DE6\u53F3\u7684\u6CE2\u723E\u591A\u7D05\u9152","champagne":"2000\u7F8E\u5143\u4EE5\u4E0B\u7684\u7A2E\u690D\u8005\u9999\u6AB3","firstGrowth":"2010-2019\u5E74\u4E00\u7D1A\u9152\u838A\u6700\u4F73\u5831\u50F9"}},"feedback":{"helpful":"\u9019\u5F88\u6709\u5E6B\u52A9","notHelpful":"\u9019\u6C92\u6709\u5E6B\u52A9","thankYou":"\u611F\u8B1D\u60A8\u7684\u53CD\u994B\uFF01","whatDidYouLike":"\u60A8\u559C\u6B61\u4EC0\u9EBC\uFF1F","whatCouldBeImproved":"\u6709\u4EC0\u9EBC\u53EF\u4EE5\u6539\u9032\u7684\uFF1F","category":"\u985E\u5225","selectCategory":"\u9078\u64C7\u985E\u5225","categories":{"accuracy":"\u6E96\u78BA\u6027","helpfulness":"\u5BE6\u7528\u6027","responseSpeed":"\u56DE\u61C9\u901F\u5EA6","clarity":"\u6E05\u6670\u5EA6","other":"\u5176\u4ED6"},"comments":"\u610F\u898B","placeholder":"\u544A\u8A34\u6211\u5011\u66F4\u591A\u95DC\u65BC\u60A8\u7684\u9AD4\u9A57...","cancel":"\u53D6\u6D88","submit":"\u63D0\u4EA4\u53CD\u994B","submitting":"\u63D0\u4EA4\u4E2D..."},"auth":{"limitReached":"\u5DF2\u9054\u6BCF\u65E5\u9650\u5236","signUpToday":"\u8A3B\u518A\u4EE5\u7372\u5F97\u66F4\u591A\u8A0A\u606F","limitMessage":"\u60A8\u5DF2\u9054\u5230\u6BCF\u65E5\u8A0A\u606F\u9650\u5236\u3002\u8A3B\u518A\u514D\u8CBB\u5E33\u6236\u4EE5\u7E7C\u7E8C\u804A\u5929\u3002","benefitsMessage":"\u5275\u5EFA\u514D\u8CBB\u5E33\u6236\u4EE5\u7E7C\u7E8C\u804A\u5929\u4E26\u5728\u5404\u8A2D\u5099\u4E0A\u4FDD\u5B58\u60A8\u7684\u804A\u5929\u8A18\u9304\u3002","remainingMessages":"\u60A8\u4ECA\u5929\u9084\u6709 {count} \u689D\u8A0A\u606F","signUp":"\u8A3B\u518A","login":"\u767B\u5165","loggedInAs":"\u5DF2\u767B\u5165\u70BA {email}","logout":"\u767B\u51FA"}}');


var $ddbe32ef7ded5982$exports = {};
$ddbe32ef7ded5982$exports = JSON.parse('{"greeting":"\u60A8\u597D\uFF01\u6211\u53EF\u4EE5\u5982\u4F55\u5E2E\u52A9\u60A8\u9009\u62E9\u8461\u8404\u9152\uFF1F","thinking":"\u2728 \u601D\u8003\u4E2D...","thinkingStep":"\u2728 \u601D\u8003\u4E2D... {step}","askAboutWine":"\u4F8B\u5982\uFF1A1990\u5E74\u4EE3\u6CE2\u5C14\u591A\u7EA2\u9152\u7EA6$1500 | \u52C3\u6839\u5730\u6751\u5E84\u767D\u9152\u4F4E\u4E8E$600","askAboutWineFirst":"\u6211\u60F3\u5BFB\u627E\u8461\u8404\u9152...\uFF08\u4EA7\u5730 + \u8461\u8404\u9152\u989C\u8272 + \u5E74\u4EFD + \u4EF7\u683C\uFF09","waitingForResponse":"\u7B49\u5F85\u56DE\u5E94\u4E2D...","dailyLimitReached":"\u60A8\u5DF2\u8FBE\u5230\u4ECA\u65E5\u7684\u54A8\u8BE2\u9650\u989D\u3002\u8BF7\u4E8E\u9999\u6E2F\u65F6\u95F4 00:00 \u540E\u518D\u6B21\u8BBF\u95EE\u3002","chatHistory":"\u60A8\u7684\u804A\u5929\u8BB0\u5F55","noChatHistory":"\u5C1A\u65E0\u804A\u5929\u8BB0\u5F55","startConversation":"\u5F00\u59CB\u5BF9\u8BDD\u4EE5\u67E5\u770B\u8BB0\u5F55","backToChat":"\u8FD4\u56DE\u804A\u5929","newChat":"\u65B0\u804A\u5929","history":"\u8BB0\u5F55","search":"\u641C\u7D22","whatsapp":"WhatsApp","wineAdvisor":"\u60A8\u7684\u4E13\u5C5E\u8461\u8404\u9152\u987E\u95EE","chat":"\u804A\u5929","chatNumber":"\u804A\u5929 {number}","wineRecommended":"\u63A8\u8350\u4E86 {count} \u6B3E\u8461\u8404\u9152","winesRecommended":"\u63A8\u8350\u4E86 {count} \u6B3E\u8461\u8404\u9152","justNow":"\u521A\u521A","minuteAgo":"{count} \u5206\u949F\u524D","minutesAgo":"{count} \u5206\u949F\u524D","hourAgo":"{count} \u5C0F\u65F6\u524D","hoursAgo":"{count} \u5C0F\u65F6\u524D","dayAgo":"{count} \u5929\u524D","daysAgo":"{count} \u5929\u524D","noMessagesYet":"\u5C1A\u65E0\u6D88\u606F","perBottle":"\u6BCF\u74F6","priceNA":"\u4EF7\u683C\u4E0D\u8BE6","buyNow":"\u7ACB\u5373\u8D2D\u4E70","moreInformation":"\u66F4\u591A\u4FE1\u606F","share":{"button":"\u5206\u4EAB","title":"\u5206\u4EAB\u5BF9\u8BDD","description":"\u4F7F\u7528\u4E0B\u9762\u7684\u94FE\u63A5\u4E0E\u670B\u53CB\u5206\u4EAB\u8FD9\u6BB5\u5BF9\u8BDD\uFF1A","generating":"\u6B63\u5728\u751F\u6210\u5206\u4EAB\u94FE\u63A5...","error":"\u751F\u6210\u5206\u4EAB\u94FE\u63A5\u5931\u8D25","copy":"\u590D\u5236","copied":"\u5DF2\u590D\u5236\uFF01","note":"\u6CE8\u610F\uFF1A\u6B64\u94FE\u63A5\u5C06\u572830\u5929\u540E\u8FC7\u671F\u3002\u5F53\u6709\u4EBA\u6253\u5F00\u6B64\u94FE\u63A5\u65F6\uFF0C\u4ED6\u4EEC\u5C06\u770B\u5230\u8FD9\u6BB5\u5BF9\u8BDD\u7684\u526F\u672C\u3002"},"checkOutWine":"\u770B\u770B\u8FD9\u6B3E\u8461\u8404\u9152\uFF1A{name} {vintage}","linkCopied":"\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F\uFF01","contactWhatsApp":"\u901A\u8FC7 WhatsApp \u8054\u7CFB\u6211\u4EEC\u4EE5\u83B7\u5F97\u66F4\u591A\u9009\u62E9","errorLoadingWine":"\u62B1\u6B49\uFF0C\u65E0\u6CD5\u52A0\u8F7D\u8461\u8404\u9152\u8BE6\u7EC6\u4FE1\u606F\u3002","errorOccurred":"\u83B7\u53D6\u56DE\u5E94\u65F6\u53D1\u751F\u9519\u8BEF\u3002","you":"\u60A8","welcome":{"intro":"\u6211\u662FZyra\uFF0C\u60A8\u7684\u667A\u80FD\u8461\u8404\u9152\u987E\u95EE\uFF0C\u6211\u53EF\u4EE5\u4E3A\u60A8\u5EFA\u8BAE\uFF1A  ","features":{"globalMarket":"\u8DE8\u5E02\u573A\uFF08\u82F1\u56FD\u3001\u6CD5\u56FD\u3001\u9999\u6E2F\uFF09\u8D27\u6E90\u5B9E\u65F6\u62A5\u4EF7\u548C\u6570\u91CF","personalized":"\u4E2A\u4EBA\u5316\u8461\u8404\u9152\u5EFA\u8BAE \u6309\u9884\u7B97\u63D0\u4F9B\u6700\u9002\u5408\u7684\u9009\u62E9","instantCheckout":"\u7ED3\u5E10\u4ED8\u6B3E\u3001\u7269\u6D41\u914D\u9001\u548C\u4ED3\u5B58\u9009\u9879"},"question":"Zyra \u8BDA\u610F\u4E3A\u60A8\u63A8\u8350...","trendingPrompts":"\u8303\u4F8B\u67E5\u8BE2  \uFF08\u76EE\u524D\u8D27\u5E01\u8BBE\u5B9A\u662F\u6E2F\u5E01\uFF09","promptExamples":{"title":"\u5982\u4F55\u8BE2\u95EE\uFF1A","good":"\u2713 \u826F\u597D\u8303\u4F8B\uFF1A","bad":"\u2717 \u907F\u514D\u6CA1\u6709\u9884\u7B97\u7684\u67E5\u8BE2\uFF1A"},"prompts":{"bordeaux":"800\u7F8E\u5143\u5DE6\u53F3\u7684\u6CE2\u5C14\u591A\u7EA2\u9152","champagne":"2000\u7F8E\u5143\u4EE5\u4E0B\u7684\u79CD\u690D\u8005\u9999\u69DF","firstGrowth":"2010-2019\u5E74\u4E00\u7EA7\u9152\u5E84\u6700\u4F73\u62A5\u4EF7"}},"feedback":{"helpful":"\u8FD9\u5F88\u6709\u5E2E\u52A9","notHelpful":"\u8FD9\u6CA1\u6709\u5E2E\u52A9","thankYou":"\u611F\u8C22\u60A8\u7684\u53CD\u9988\uFF01","whatDidYouLike":"\u60A8\u559C\u6B22\u4EC0\u4E48\uFF1F","whatCouldBeImproved":"\u6709\u4EC0\u4E48\u53EF\u4EE5\u6539\u8FDB\u7684\uFF1F","category":"\u7C7B\u522B","selectCategory":"\u9009\u62E9\u7C7B\u522B","categories":{"accuracy":"\u51C6\u786E\u6027","helpfulness":"\u5B9E\u7528\u6027","responseSpeed":"\u56DE\u5E94\u901F\u5EA6","clarity":"\u6E05\u6670\u5EA6","other":"\u5176\u4ED6"},"comments":"\u610F\u89C1","placeholder":"\u544A\u8BC9\u6211\u4EEC\u66F4\u591A\u5173\u4E8E\u60A8\u7684\u4F53\u9A8C...","cancel":"\u53D6\u6D88","submit":"\u63D0\u4EA4\u53CD\u9988","submitting":"\u63D0\u4EA4\u4E2D..."},"auth":{"limitReached":"\u5DF2\u8FBE\u6BCF\u65E5\u9650\u5236","signUpToday":"\u6CE8\u518C\u4EE5\u83B7\u5F97\u66F4\u591A\u6D88\u606F","limitMessage":"\u60A8\u5DF2\u8FBE\u5230\u6BCF\u65E5\u6D88\u606F\u9650\u5236\u3002\u6CE8\u518C\u514D\u8D39\u8D26\u6237\u4EE5\u7EE7\u7EED\u804A\u5929\u3002","benefitsMessage":"\u521B\u5EFA\u514D\u8D39\u8D26\u6237\u4EE5\u7EE7\u7EED\u804A\u5929\u5E76\u5728\u5404\u8BBE\u5907\u4E0A\u4FDD\u5B58\u60A8\u7684\u804A\u5929\u8BB0\u5F55\u3002","remainingMessages":"\u60A8\u4ECA\u5929\u8FD8\u6709 {count} \u6761\u6D88\u606F","signUp":"\u6CE8\u518C","login":"\u767B\u5F55","loggedInAs":"\u5DF2\u767B\u5F55\u4E3A {email}","logout":"\u9000\u51FA\u767B\u5F55"}}');


const $10bbf922fc88f04e$var$translations = {
    'en': {},
    'zh-TW': {},
    'zh-CN': {}
};
let $10bbf922fc88f04e$var$translationsLoaded = false;
const $10bbf922fc88f04e$var$loadTranslations = ()=>{
    if ($10bbf922fc88f04e$var$translationsLoaded) return;
    try {
        $10bbf922fc88f04e$var$translations.en = (0, (/*@__PURE__*/$parcel$interopDefault($48c4cd70bac13fb6$exports)));
        $10bbf922fc88f04e$var$translations['zh-TW'] = (0, (/*@__PURE__*/$parcel$interopDefault($ae9935d62d3affa2$exports)));
        $10bbf922fc88f04e$var$translations['zh-CN'] = (0, (/*@__PURE__*/$parcel$interopDefault($ddbe32ef7ded5982$exports)));
        $10bbf922fc88f04e$var$translationsLoaded = true;
    } catch (error) {
        console.error('Failed to load translations:', error);
        // Fallback to empty objects if loading fails
        $10bbf922fc88f04e$var$translationsLoaded = true;
    }
};
$10bbf922fc88f04e$var$loadTranslations();
const $10bbf922fc88f04e$export$9fc83ad70ead8663 = (language = 'en')=>{
    // Normalize language code
    const normalizedLang = $10bbf922fc88f04e$var$normalizeLanguage(language);
    const t = (key, params)=>{
        // Support nested keys with dot notation
        const keys = key.split('.');
        let translation = $10bbf922fc88f04e$var$translations[normalizedLang] || $10bbf922fc88f04e$var$translations.en;
        // Navigate through nested objects
        for (const k of keys){
            translation = translation?.[k];
            if (translation === undefined) {
                // Try fallback to English
                translation = $10bbf922fc88f04e$var$translations.en;
                for (const k2 of keys){
                    translation = translation?.[k2];
                    if (translation === undefined) break;
                }
                break;
            }
        }
        // If no translation found, return the key
        if (translation === undefined || typeof translation !== 'string') return key;
        // Replace parameters in the translation
        if (params) Object.entries(params).forEach(([paramKey, value])=>{
            translation = translation.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(value));
        });
        return translation;
    };
    return {
        t: t
    };
};
const $10bbf922fc88f04e$var$normalizeLanguage = (language)=>{
    const lang = language.toLowerCase();
    if (lang.includes('zh')) {
        if (lang.includes('tw') || lang.includes('hk') || lang.includes('hant')) return 'zh-TW';
        else if (lang.includes('cn') || lang.includes('hans')) return 'zh-CN';
        // Default to Traditional Chinese for other Chinese variants
        return 'zh-TW';
    }
    return 'en';
};
var $10bbf922fc88f04e$export$2e2bcd8739ae039 = $10bbf922fc88f04e$export$9fc83ad70ead8663;


const $82a40ebe7c831bad$var$OfferCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).memo(({ offer: offer, isBestOffer: isBestOffer, currency: currency, language: language, user: user, onCardClick: onCardClick, onInfoClick: onInfoClick, onShareClick: onShareClick })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    const colorClass = (0, $540271f4c8f7b579$export$e6a965f54a0a7c7)(offer.color);
    const { moreInfoUrl: moreInfoUrl, buyNowUrl: buyNowUrl } = (0, $540271f4c8f7b579$export$8be853786101e32a)(offer, user);
    const flag = (0, $540271f4c8f7b579$export$47ad85e557275125)(offer.warehouse_name);
    const produceAndName = offer.display_name?.split(',') || [
        offer.processed_wine_name
    ];
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: `offer-card ${isBestOffer ? 'best-offer' : ''}`,
        onClick: ()=>onCardClick(buyNowUrl),
        children: [
            isBestOffer && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "best-offer-ribbon"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "offer-action-icons",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "action-icon info-icon",
                        onClick: (e)=>onInfoClick(e, moreInfoUrl),
                        title: t('moreInformation'),
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                            className: "fas fa-info-circle"
                        })
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "action-icon share-icon",
                        onClick: (e)=>onShareClick(e, offer, moreInfoUrl),
                        title: t('share'),
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                            className: "fas fa-paper-plane"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "offer-image-container",
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                    src: offer.image_url || (0, $1844453eead66305$export$af227afd9ab8dcbf)('logo.png'),
                    alt: offer.display_name || 'Wine bottle',
                    onError: (e)=>{
                        const target = e.target;
                        target.src = (0, $1844453eead66305$export$af227afd9ab8dcbf)('logo.png');
                    }
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "offer-details",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                        className: `fas fa-wine-bottle wine-type-icon ${colorClass}`
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "offer-vintage-name",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "offer-vintage",
                                children: offer.vintage || 'NV'
                            }),
                            produceAndName.length > 1 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "offer-producer",
                                children: produceAndName[0]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "offer-name",
                                children: produceAndName.length > 1 ? produceAndName[1] : produceAndName[0]
                            })
                        ]
                    }),
                    offer.ratings_and_notes?.rating && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("span", {
                        className: "offer-rating-container",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "rating-label",
                                children: "WA"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                className: "rating-value",
                                children: offer.ratings_and_notes.rating
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "offer-price-buttons",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "offer-price",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "offer-case-format",
                                        children: [
                                            offer.quantity_per_case || '?',
                                            " x ",
                                            offer.volume || '?',
                                            " (",
                                            offer.quantity,
                                            " qty)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "offer-price-target",
                                        children: [
                                            offer.per_bottle_price ? `${offer.calculated_currency || currency} ${offer.per_bottle_price.toLocaleString()}` : t('priceNA'),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                className: "price-label",
                                                children: offer.volume ? `per ${offer.volume}` : t('perBottle')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "offer-buttons",
                                children: [
                                    offer.original_currency && offer.original_price && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "offer-price-original",
                                        children: [
                                            offer.original_currency,
                                            " ",
                                            Math.round(offer.original_price).toLocaleString(),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                                className: "price-label",
                                                children: [
                                                    offer.quantity_per_case || '?',
                                                    " x ",
                                                    offer.volume || '?'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("a", {
                                        href: buyNowUrl,
                                        target: "_blank",
                                        className: "buy-now-button",
                                        rel: "noopener noreferrer",
                                        children: t('buyNow')
                                    })
                                ]
                            }),
                            flag.filename && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "warehouse-flag-container",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                        src: (0, $1844453eead66305$export$af227afd9ab8dcbf)(flag.filename),
                                        alt: `${offer.warehouse_name} Flag`,
                                        className: "warehouse-flag"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        className: "warehouse-flag-text",
                                        children: flag.text
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$82a40ebe7c831bad$var$OfferCard.displayName = 'OfferCard';
var $82a40ebe7c831bad$export$2e2bcd8739ae039 = $82a40ebe7c831bad$var$OfferCard;



const $deadd984a95bc97e$var$OfferCarousel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).memo(({ offers: offers, currency: currency, language: language, user: user })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    // Find minimum price for best offer detection
    const minPrice = (0, $8vqx4.useMemo)(()=>{
        return offers.reduce((min, offer)=>{
            return offer.per_bottle_price !== null && offer.per_bottle_price !== undefined && offer.per_bottle_price < min ? offer.per_bottle_price : min;
        }, Infinity);
    }, [
        offers
    ]);
    const hasValidPrices = minPrice !== Infinity;
    const handleCardClick = (0, $8vqx4.useCallback)((buyNowUrl)=>{
        window.open(buyNowUrl, '_blank', 'noopener,noreferrer');
    }, []);
    const handleInfoClick = (0, $8vqx4.useCallback)((e, moreInfoUrl)=>{
        e.stopPropagation();
        window.open(moreInfoUrl, '_blank', 'noopener,noreferrer');
    }, []);
    const handleShareClick = (0, $8vqx4.useCallback)((e, offer, moreInfoUrl)=>{
        e.stopPropagation();
        if (navigator.share) navigator.share({
            title: `${offer.display_name} ${offer.vintage}`,
            text: t('checkOutWine', {
                name: offer.display_name,
                vintage: offer.vintage
            }),
            url: moreInfoUrl
        }).catch((err)=>console.error('Error sharing:', err));
        else navigator.clipboard.writeText(moreInfoUrl).then(()=>alert(t('linkCopied'))).catch((err)=>console.error('Error copying link:', err));
    }, [
        t
    ]);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "offer-carousel-container",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
            className: "offer-carousel",
            children: offers.map((offer, index)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $82a40ebe7c831bad$export$2e2bcd8739ae039), {
                    offer: offer,
                    isBestOffer: hasValidPrices && offer.per_bottle_price === minPrice,
                    currency: currency,
                    language: language,
                    user: user,
                    onCardClick: handleCardClick,
                    onInfoClick: handleInfoClick,
                    onShareClick: handleShareClick
                }, `${offer.offer_id}-${index}`))
        })
    });
});
$deadd984a95bc97e$var$OfferCarousel.displayName = 'OfferCarousel';
var $deadd984a95bc97e$export$2e2bcd8739ae039 = $deadd984a95bc97e$var$OfferCarousel;



parcelRequire("8vqx4");

const $e6c35d4867967d71$var$WelcomeScreen = ({ language: language, user: user, onSignupClick: onSignupClick })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    const features = [
        {
            icon: "\uD83C\uDF0D",
            text: t('welcome.features.globalMarket')
        },
        {
            icon: "\uD83C\uDFAF",
            text: t('welcome.features.personalized')
        },
        {
            icon: "\u26A1",
            text: t('welcome.features.instantCheckout')
        }
    ];
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        style: {
            padding: '20px',
            backgroundColor: '#f8f8f8',
            borderRadius: '15px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                style: {
                    marginBottom: '4px'
                },
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                    style: {
                        margin: 0,
                        color: '#333',
                        fontSize: '15px',
                        lineHeight: '1.6'
                    },
                    children: t('welcome.intro')
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                style: {
                    marginBottom: '5px'
                },
                children: features.map((feature, index)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            marginBottom: '0',
                            color: '#666'
                        },
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                style: {
                                    fontSize: '16px'
                                },
                                children: feature.icon
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                style: {
                                    fontSize: '14px',
                                    fontWeight: '500'
                                },
                                children: feature.text
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                style: {
                    marginBottom: '5px'
                },
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("h4", {
                        style: {
                            color: '#333',
                            fontSize: '14px',
                            fontWeight: '600'
                        },
                        children: t('welcome.trendingPrompts')
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        style: {
                            marginBottom: '5px'
                        },
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            style: {
                                backgroundColor: '#f5f5f5',
                                borderRadius: '8px',
                                fontSize: '12px',
                                fontStyle: 'italic',
                                lineHeight: '1.6',
                                color: '#000'
                            },
                            children: [
                                language === 'zh-TW' && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "1. \u8ACB\u63A8\u85A6\u6700\u512A\u60E0\u5831\u50F9\uFF08\u8A3B\u660E\u9152\u985E\u54C1\u724C + \u6307\u5B9A\u7279\u5B9A\u5E74\u4EFD\u6216\u7BC4\u570D\u7686\u53EF\uFF0C\u4F8B\u5982\uFF1A",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "\u7D05\u984F\u5BB9\u9152\u838A 2010-2019"
                                                }),
                                                "\uFF09"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "2. \u6211\u60F3\u8CFC\u8CB7",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "1990\u5E74\u4EFD\u7684\u6CE2\u723E\u591A\u7D05\u9152"
                                                }),
                                                "\uFF0C\u9810\u7B97\u7D04$1500\u3002"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "3. \u8ACB\u7D66\u6211\u63A8\u85A6\u52C3\u826E\u7B2C\u6751\u7530\u767D\u9152\uFF0C",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "\u50F9\u683C$600\u4EE5\u4E0B"
                                                }),
                                                "\u3002"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "4. \u8ACB\u5EFA\u8B70",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "\u73FE\u5728\u9069\u5B9C\u98F2\u7528"
                                                }),
                                                "\u7684\u8D85\u7D1A\u6258\u65AF\u5361\u7D0D\u7D05\u9152\u6700\u512A\u60E0\u5831\u50F9\u3002"
                                            ]
                                        })
                                    ]
                                }),
                                language === 'zh-CN' && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "1. \u63A8\u8350\u6700\u4F18\u60E0\u62A5\u4EF7\uFF08\u6CE8\u660E\u9152\u7C7B\u54C1\u724C + \u6307\u5B9A\u7279\u5B9A\u5E74\u4EFD\u6216\u8303\u56F4\u7686\u53EF\uFF0C\u4F8B\u5982\uFF1A",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "\u7EA2\u989C\u5BB9\u9152\u5E84 2010-2019"
                                                }),
                                                "\uFF09"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "2. \u6211\u60F3\u8D2D\u4E70",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "1990\u5E74\u4EFD\u7684\u6CE2\u5C14\u591A\u7EA2\u9152"
                                                }),
                                                "\uFF0C\u9884\u7B97\u7EA6$1500\u3002 "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "3. \u8BF7\u7ED9\u6211\u63A8\u8350\u52C3\u826E\u7B2C\u6751\u7530\u767D\u9152\uFF0C",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "\u4EF7\u683C$600\u4EE5\u4E0B"
                                                }),
                                                "\u3002"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "4. \u8BF7\u5EFA\u8BAE",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "\u73B0\u5728\u9002\u5B9C\u996E\u7528"
                                                }),
                                                "\u7684\u8D85\u7EA7\u6258\u65AF\u5361\u7EB3\u7EA2\u9152\u6700\u4F18\u60E0\u62A5\u4EF7\u3002"
                                            ]
                                        })
                                    ]
                                }),
                                language !== 'zh-TW' && language !== 'zh-CN' && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "1. Please recommend best offer (specific wine brand + vintage eg. ",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "Haut Brion 2010-2019"
                                                }),
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "2. I want to buy ",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "1990s Bordeaux Red"
                                                }),
                                                " around $1500"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "3. Burgundy village white ",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "below $600"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                            children: [
                                                "4. Best offer Super Tuscan red ",
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("b", {
                                                    children: "ready to drink now"
                                                }),
                                                " around $1000"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        style: {
                            marginBottom: '5px'
                        },
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                            style: {
                                margin: 0,
                                color: '#333',
                                fontSize: '15px',
                                fontWeight: '500'
                            },
                            children: t('welcome.question')
                        })
                    })
                ]
            })
        ]
    });
};
var $e6c35d4867967d71$export$2e2bcd8739ae039 = $e6c35d4867967d71$var$WelcomeScreen;




var $8vqx4 = parcelRequire("8vqx4");


const $649f276bf3c6ce6f$export$a90600c9da52b40c = ({ sessionId: sessionId, messageId: messageId, onFeedbackSubmitted: onFeedbackSubmitted, language: language })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    const [showForm, setShowForm] = (0, $8vqx4.useState)(false);
    const [feedbackData, setFeedbackData] = (0, $8vqx4.useState)({
        rating: null,
        comment: '',
        category: ''
    });
    const [isSubmitting, setIsSubmitting] = (0, $8vqx4.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $8vqx4.useState)(false);
    const handleThumbClick = (rating)=>{
        setFeedbackData({
            ...feedbackData,
            rating: rating
        });
        setShowForm(true);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!feedbackData.rating) return;
        setIsSubmitting(true);
        try {
            const response = await fetch(`${(0, $1844453eead66305$export$7037112d28c7d171)}/api/feedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    session_id: sessionId,
                    message_id: messageId,
                    rating: feedbackData.rating,
                    comment: feedbackData.comment,
                    category: feedbackData.category,
                    timestamp: new Date().toISOString()
                })
            });
            if (response.ok) {
                setHasSubmitted(true);
                setShowForm(false);
                onFeedbackSubmitted?.();
                // Reset after a delay
                setTimeout(()=>{
                    setHasSubmitted(false);
                    setFeedbackData({
                        rating: null,
                        comment: '',
                        category: ''
                    });
                }, 3000);
            } else console.error('Failed to submit feedback');
        } catch (error) {
            console.error('Error submitting feedback:', error);
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleCancel = ()=>{
        setShowForm(false);
        setFeedbackData({
            rating: null,
            comment: '',
            category: ''
        });
    };
    if (hasSubmitted) return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "feedback-component feedback-success",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                className: "fas fa-check-circle"
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                children: t('feedback.thankYou')
            })
        ]
    });
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "feedback-component",
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "feedback-buttons",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                        className: `feedback-btn feedback-positive ${feedbackData.rating === 'positive' ? 'active' : ''}`,
                        onClick: ()=>handleThumbClick('positive'),
                        title: t('feedback.helpful'),
                        disabled: hasSubmitted,
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                            className: "fas fa-thumbs-up"
                        })
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                        className: `feedback-btn feedback-negative ${feedbackData.rating === 'negative' ? 'active' : ''}`,
                        onClick: ()=>handleThumbClick('negative'),
                        title: t('feedback.notHelpful'),
                        disabled: hasSubmitted,
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                            className: "fas fa-thumbs-down"
                        })
                    })
                ]
            }),
            showForm && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "feedback-popup-overlay",
                onClick: handleCancel,
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "feedback-popup",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("h3", {
                            children: feedbackData.rating === 'positive' ? t('feedback.whatDidYouLike') : t('feedback.whatCouldBeImproved')
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("label", {
                                            htmlFor: "feedback-category",
                                            children: t('feedback.category')
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("select", {
                                            id: "feedback-category",
                                            value: feedbackData.category,
                                            onChange: (e)=>setFeedbackData({
                                                    ...feedbackData,
                                                    category: e.target.value
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                                    value: "",
                                                    children: t('feedback.selectCategory')
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                                    value: "accuracy",
                                                    children: t('feedback.categories.accuracy')
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                                    value: "helpfulness",
                                                    children: t('feedback.categories.helpfulness')
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                                    value: "speed",
                                                    children: t('feedback.categories.responseSpeed')
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                                    value: "clarity",
                                                    children: t('feedback.categories.clarity')
                                                }),
                                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("option", {
                                                    value: "other",
                                                    children: t('feedback.categories.other')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "form-group",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("label", {
                                            htmlFor: "feedback-comment",
                                            children: t('feedback.comments')
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("textarea", {
                                            id: "feedback-comment",
                                            value: feedbackData.comment,
                                            onChange: (e)=>setFeedbackData({
                                                    ...feedbackData,
                                                    comment: e.target.value
                                                }),
                                            placeholder: t('feedback.placeholder'),
                                            rows: 4
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                    className: "form-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn-cancel",
                                            onClick: handleCancel,
                                            disabled: isSubmitting,
                                            children: t('feedback.cancel')
                                        }),
                                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                            type: "submit",
                                            className: "btn-submit",
                                            disabled: isSubmitting,
                                            children: isSubmitting ? t('feedback.submitting') : t('feedback.submit')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



const $b320433ddd1a8beb$var$Message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).memo(({ message: message, currency: currency, language: language, user: user, sessionId: sessionId, onTrendingPromptClick: onTrendingPromptClick, onSignupClick: onSignupClick })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    const isAssistant = message.role === 'assistant';
    const isUser = message.role === 'user';
    const showFeedback = isAssistant && !message.isLoading && !message.isWelcome && !message.isThinking;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: `message ${message.role} ${message.isThinking ? 'thinking flash' : ''}`,
        "data-message-id": message.id,
        children: [
            isAssistant && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $c6f992c0bda97824$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "message-content-wrapper",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "message-content",
                        children: message.isWelcome ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $e6c35d4867967d71$export$2e2bcd8739ae039), {
                            language: language || 'en',
                            user: user,
                            onSignupClick: onSignupClick || (()=>{})
                        }) : message.isComponent ? message.content : message.isLoading ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $4f624a1400dc4e31$export$2e2bcd8739ae039), {}) : message.isCarousel ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $deadd984a95bc97e$export$2e2bcd8739ae039), {
                            offers: message.carouselData || [],
                            currency: currency,
                            language: language,
                            user: user
                        }) : /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: message.content
                            }
                        })
                    }),
                    showFeedback && sessionId && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        className: "message-feedback",
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $649f276bf3c6ce6f$export$a90600c9da52b40c), {
                            sessionId: sessionId,
                            messageId: message.id,
                            language: language
                        })
                    })
                ]
            })
        ]
    });
});
$b320433ddd1a8beb$var$Message.displayName = 'Message';
var $b320433ddd1a8beb$export$2e2bcd8739ae039 = $b320433ddd1a8beb$var$Message;



parcelRequire("8vqx4");

const $39f396b236ee9909$var$HistoryView = ({ historyData: historyData, language: language, onSelectSession: onSelectSession, onBack: onBack })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    const formatRelativeTime = (dateString)=>{
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now.getTime() - date.getTime();
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffMins < 1) return t('justNow');
        if (diffMins < 60) return diffMins === 1 ? t('minuteAgo', {
            count: diffMins
        }) : t('minutesAgo', {
            count: diffMins
        });
        if (diffHours < 24) return diffHours === 1 ? t('hourAgo', {
            count: diffHours
        }) : t('hoursAgo', {
            count: diffHours
        });
        if (diffDays < 7) return diffDays === 1 ? t('dayAgo', {
            count: diffDays
        }) : t('daysAgo', {
            count: diffDays
        });
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
        });
    };
    const formatMessagePreview = (message)=>{
        if (!message) return t('noMessagesYet');
        const cleaned = message.trim();
        if (cleaned.length <= 60) return cleaned;
        return cleaned.substring(0, 60) + '...';
    };
    const formatWineCount = (count)=>{
        if (!count || count === 0) return '';
        return count === 1 ? t('wineRecommended', {
            count: count
        }) : t('winesRecommended', {
            count: count
        });
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        style: {
            flex: 1,
            overflow: 'auto',
            backgroundColor: '#fff',
            borderRadius: '20px',
            margin: '10px',
            padding: '20px'
        },
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("h2", {
                style: {
                    color: '#AB7C40',
                    fontSize: '1.3em',
                    marginBottom: '20px',
                    fontWeight: 'bold'
                },
                children: t('chatHistory')
            }),
            historyData.length > 0 ? /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                },
                children: historyData.map((session, index)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        onClick: ()=>onSelectSession(session.session_id),
                        style: {
                            backgroundColor: '#f9f9f9',
                            border: '1px solid #eee',
                            borderRadius: '12px',
                            padding: '15px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            ':hover': {
                                backgroundColor: '#f5f5f5',
                                borderColor: '#D8A420',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }
                        },
                        onMouseEnter: (e)=>{
                            e.currentTarget.style.backgroundColor = '#f5f5f5';
                            e.currentTarget.style.borderColor = '#D8A420';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                        },
                        onMouseLeave: (e)=>{
                            e.currentTarget.style.backgroundColor = '#f9f9f9';
                            e.currentTarget.style.borderColor = '#eee';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        },
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    marginBottom: '8px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            color: '#AB7C40',
                                            fontWeight: 'bold'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                                                className: "fas fa-comments",
                                                style: {
                                                    fontSize: '1.1em'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                                children: t('chatNumber', {
                                                    number: historyData.length - index
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        style: {
                                            fontSize: '0.85em',
                                            color: '#999',
                                            fontStyle: 'italic'
                                        },
                                        children: formatRelativeTime(session.last_message_time)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                style: {
                                    color: '#666',
                                    fontSize: '0.95em',
                                    lineHeight: '1.4',
                                    marginBottom: session.total_wines_recommended ? '8px' : '0'
                                },
                                children: formatMessagePreview(session.first_user_message)
                            }),
                            session.total_wines_recommended > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    fontSize: '0.85em',
                                    color: '#AB7C40',
                                    fontWeight: 'bold'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                                        className: "fas fa-wine-bottle",
                                        style: {
                                            fontSize: '1em'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        children: formatWineCount(session.total_wines_recommended)
                                    })
                                ]
                            })
                        ]
                    }, session.session_id))
            }) : /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                style: {
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#999'
                },
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                        className: "fas fa-inbox",
                        style: {
                            fontSize: '3em',
                            marginBottom: '15px',
                            display: 'block',
                            opacity: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                        style: {
                            fontSize: '1.1em',
                            marginBottom: '10px'
                        },
                        children: t('noChatHistory')
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                        style: {
                            fontSize: '0.9em'
                        },
                        children: t('startConversation')
                    })
                ]
            })
        ]
    });
};
var $39f396b236ee9909$export$2e2bcd8739ae039 = $39f396b236ee9909$var$HistoryView;



parcelRequire("8vqx4");

const $5e1b9f9c363a4484$var$WhatsAppButton = ({ language: language })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "whatsapp-button-container",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("a", {
            href: "https://api.whatsapp.com/send?phone=85297100398",
            target: "_blank",
            className: "whatsapp-button",
            rel: "noopener noreferrer",
            children: t('contactWhatsApp')
        })
    });
};
var $5e1b9f9c363a4484$export$2e2bcd8739ae039 = $5e1b9f9c363a4484$var$WhatsAppButton;




var $8vqx4 = parcelRequire("8vqx4");
const $431ed5bb4a3b972b$var$WineSelectionButtons = ({ onSelectionClick: onSelectionClick, language: language = 'en' })=>{
    const [activeCategory, setActiveCategory] = (0, $8vqx4.useState)(null);
    const translations = {
        en: {
            popular: 'Popular',
            region: 'Region',
            color: 'Color',
            vintage: 'Vintage',
            grape: 'Grape',
            budget: 'Budget',
            red: 'Red',
            white: 'White',
            rose: 'Rose',
            around: 'Around',
            under: 'Under',
            bestOffer: 'Best offer'
        },
        'zh-CN': {
            popular: "\u70ED\u641C",
            region: "\u4EA7\u5730",
            color: "\u8461\u8404\u9152\u989C\u8272",
            vintage: "\u5E74\u4EFD",
            grape: "\u8461\u8404\u54C1\u79CD",
            budget: "\u9884\u7B97",
            red: "\u7EA2\u9152",
            white: "\u767D\u9152",
            rose: "\u6843\u7EA2\u9152",
            around: "\u7EA6",
            under: "\u4F4E\u4E8E",
            bestOffer: "\u6700\u4F18\u4EF7\u683C"
        },
        'zh-TW': {
            popular: "\u71B1\u641C",
            region: "\u7522\u5730",
            color: "\u8461\u8404\u9152\u984F\u8272",
            vintage: "\u5E74\u4EFD",
            grape: "\u8461\u8404\u54C1\u7A2E",
            budget: "\u9810\u7B97",
            red: "\u7D05\u9152",
            white: "\u767D\u9152",
            rose: "\u6843\u7D05\u9152",
            around: "\u7D04",
            under: "\u4F4E\u65BC",
            bestOffer: "\u6700\u512A\u50F9\u683C"
        }
    };
    const t = translations[language] || translations.en;
    const categories = [
        {
            key: 'popular',
            label: t.popular,
            options: [
                {
                    label: 'Grower champagne',
                    value: 'grower champagne'
                },
                {
                    label: 'First growth',
                    value: 'first growth'
                },
                {
                    label: 'Super Tuscan',
                    value: 'super tuscan'
                },
                {
                    label: 'Right bank merlot',
                    value: 'right bank merlot'
                },
                {
                    label: 'Chablis premier cru',
                    value: 'chablis premier cru'
                },
                {
                    label: 'Napa Chardonnay',
                    value: 'napa chardonnay'
                }
            ]
        },
        {
            key: 'region',
            label: t.region,
            options: [
                {
                    label: 'Margaux',
                    value: 'Margaux'
                },
                {
                    label: 'Chambolle Musigny 1er Cru',
                    value: 'Chambolle Musigny 1er Cru'
                },
                {
                    label: 'Chambertin Grand Cru',
                    value: 'Chambertin Grand Cru'
                },
                {
                    label: 'Brunello di Montalcino',
                    value: 'Brunello di Montalcino'
                },
                {
                    label: 'Oregon',
                    value: 'Oregon'
                },
                {
                    label: 'New Zealand',
                    value: 'New Zealand'
                },
                {
                    label: 'Priorat',
                    value: 'Priorat'
                },
                {
                    label: 'Loire Valley',
                    value: 'Loire Valley'
                }
            ]
        },
        {
            key: 'color',
            label: t.color,
            options: [
                {
                    label: t.red,
                    value: 'red'
                },
                {
                    label: t.white,
                    value: 'white'
                },
                {
                    label: t.rose,
                    value: "ros\xe9"
                }
            ]
        },
        {
            key: 'vintage',
            label: t.vintage,
            options: [
                {
                    label: '1990s',
                    value: '1990-1999'
                },
                {
                    label: '2000-2010',
                    value: '2000-2010'
                },
                {
                    label: '2009, 2010',
                    value: '2009-2010'
                }
            ]
        },
        {
            key: 'grape',
            label: t.grape,
            options: [
                {
                    label: 'Pinot Noir',
                    value: 'pinot noir'
                },
                {
                    label: 'Cabernet Sauvignon',
                    value: 'cabernet sauvignon'
                },
                {
                    label: 'Sauvignon Blanc',
                    value: 'sauvignon blanc'
                },
                {
                    label: 'Merlot',
                    value: 'merlot'
                },
                {
                    label: 'Syrah/Shiraz',
                    value: 'syrah'
                },
                {
                    label: 'Tempranillo',
                    value: 'tempranillo'
                },
                {
                    label: 'Chardonnay',
                    value: 'chardonnay'
                },
                {
                    label: 'Riesling',
                    value: 'riesling'
                },
                {
                    label: 'Sangiovese',
                    value: 'sangiovese'
                }
            ]
        },
        {
            key: 'budget',
            label: t.budget,
            options: [
                {
                    label: `${t.around} $1000`,
                    value: 'around $1000'
                },
                {
                    label: `${t.under} $800`,
                    value: 'under $800'
                },
                {
                    label: '$1000 - $1200',
                    value: '$1000-$1200'
                },
                {
                    label: t.bestOffer,
                    value: 'best offer'
                }
            ]
        }
    ];
    const handleCategoryClick = (categoryKey)=>{
        setActiveCategory(activeCategory === categoryKey ? null : categoryKey);
    };
    const handleOptionClick = (category, value)=>{
        onSelectionClick(category, value);
        setActiveCategory(null);
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        style: {
            marginTop: '10px'
        },
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px',
                    marginBottom: activeCategory ? '10px' : '0'
                },
                children: categories.map((category)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>handleCategoryClick(category.key),
                        style: {
                            backgroundColor: activeCategory === category.key ? '#B8860B' : '#f5f5f5',
                            color: activeCategory === category.key ? 'white' : '#333',
                            border: 'none',
                            borderRadius: '20px',
                            padding: '6px 14px',
                            fontSize: '13px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            fontWeight: '500'
                        },
                        children: [
                            category.label,
                            activeCategory === category.key && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                style: {
                                    marginLeft: '4px'
                                },
                                children: "\u25BC"
                            })
                        ]
                    }, category.key))
            }),
            activeCategory && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                style: {
                    backgroundColor: '#f9f9f9',
                    borderRadius: '8px',
                    padding: '8px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px'
                },
                children: categories.find((cat)=>cat.key === activeCategory)?.options.map((option)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleOptionClick(activeCategory, option.value),
                        style: {
                            backgroundColor: 'white',
                            border: '1px solid #ddd',
                            borderRadius: '16px',
                            padding: '4px 12px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            color: '#555'
                        },
                        onMouseOver: (e)=>{
                            e.currentTarget.style.backgroundColor = '#f0f0f0';
                            e.currentTarget.style.borderColor = '#B8860B';
                        },
                        onMouseOut: (e)=>{
                            e.currentTarget.style.backgroundColor = 'white';
                            e.currentTarget.style.borderColor = '#ddd';
                        },
                        children: option.label
                    }, option.value))
            })
        ]
    });
};
var $431ed5bb4a3b972b$export$2e2bcd8739ae039 = $431ed5bb4a3b972b$var$WineSelectionButtons;



parcelRequire("8vqx4");

const $7b60667e149e9d6c$var$AuthPrompt = ({ onSignUp: onSignUp, onLogin: onLogin, remainingMessages: remainingMessages, language: language })=>{
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "auth-prompt",
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
            className: "auth-prompt-content",
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                    className: "auth-prompt-icon",
                    children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("svg", {
                        width: "48",
                        height: "48",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                                stroke: "#FFA500",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                d: "M12 8V12",
                                stroke: "#FFA500",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("path", {
                                d: "M12 16H12.01",
                                stroke: "#FFA500",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("h3", {
                    className: "auth-prompt-title",
                    children: remainingMessages !== null && remainingMessages <= 0 ? t('auth.limitReached') : t('auth.signUpToday')
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                    className: "auth-prompt-message",
                    children: remainingMessages !== null && remainingMessages <= 0 ? t('auth.limitMessage') : t('auth.benefitsMessage')
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "auth-prompt-buttons",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                            onClick: onSignUp,
                            className: "auth-btn auth-btn-primary",
                            children: t('auth.signUp')
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                            onClick: onLogin,
                            className: "auth-btn auth-btn-secondary",
                            children: t('auth.login')
                        })
                    ]
                })
            ]
        })
    });
};
var $7b60667e149e9d6c$export$2e2bcd8739ae039 = $7b60667e149e9d6c$var$AuthPrompt;




var $8vqx4 = parcelRequire("8vqx4");
const $a65eb5cd434293e4$var$VoiceControls = ({ isListening: isListening, onStartListening: onStartListening, onStopListening: onStopListening, disabled: disabled = false, language: language })=>{
    const [permissionDenied, setPermissionDenied] = (0, $8vqx4.useState)(false);
    const handleMicrophoneClick = async ()=>{
        if (disabled) return;
        if (isListening) onStopListening();
        else try {
            await navigator.mediaDevices.getUserMedia({
                audio: true
            });
            setPermissionDenied(false);
            onStartListening();
        } catch (error) {
            console.error('Microphone permission denied:', error);
            setPermissionDenied(true);
            setTimeout(()=>setPermissionDenied(false), 3000);
        }
    };
    const getMicrophoneTooltip = ()=>{
        if (permissionDenied) return language === 'zh-TW' ? "\u8ACB\u5141\u8A31\u9EA5\u514B\u98A8\u6B0A\u9650" : language === 'zh-CN' ? "\u8BF7\u5141\u8BB8\u9EA6\u514B\u98CE\u6743\u9650" : 'Please allow microphone access';
        if (isListening) return language === 'zh-TW' ? "\u9EDE\u64CA\u505C\u6B62\u9304\u97F3" : language === 'zh-CN' ? "\u70B9\u51FB\u505C\u6B62\u5F55\u97F3" : 'Click to stop recording';
        return language === 'zh-TW' ? "\u9EDE\u64CA\u958B\u59CB\u8A9E\u97F3\u8F38\u5165" : language === 'zh-CN' ? "\u70B9\u51FB\u5F00\u59CB\u8BED\u97F3\u8F93\u5165" : 'Click to start voice input';
    };
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        className: "voice-controls",
        style: {
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            marginRight: '8px'
        },
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("button", {
                type: "button",
                className: `voice-control-btn microphone-btn ${isListening ? 'listening' : ''} ${permissionDenied ? 'error' : ''}`,
                onClick: handleMicrophoneClick,
                disabled: disabled,
                title: getMicrophoneTooltip(),
                style: {
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    border: isListening ? '2px solid #ff4444' : '1px solid #ddd',
                    backgroundColor: isListening ? '#ffeeee' : 'white',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    animation: isListening ? 'pulse 1.5s infinite' : 'none'
                },
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                        className: `fas ${isListening ? 'fa-microphone-slash' : 'fa-microphone'}`,
                        style: {
                            color: permissionDenied ? '#ff4444' : isListening ? '#ff4444' : '#666',
                            fontSize: '16px'
                        }
                    }),
                    isListening && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                        className: "recording-indicator",
                        style: {
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#ff4444',
                            borderRadius: '50%',
                            animation: 'blink 1s infinite'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("style", {
                jsx: true,
                children: `
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(255, 68, 68, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255, 68, 68, 0);
          }
        }

        @keyframes blink {
          0%, 50%, 100% {
            opacity: 1;
          }
          25%, 75% {
            opacity: 0.5;
          }
        }

        .voice-control-btn:hover:not(:disabled) {
          transform: scale(1.1);
        }

        .voice-control-btn:active:not(:disabled) {
          transform: scale(0.95);
        }

        .voice-control-btn:disabled {
          opacity: 0.5;
        }
      `
            })
        ]
    });
};
var $a65eb5cd434293e4$export$2e2bcd8739ae039 = $a65eb5cd434293e4$var$VoiceControls;




var $8vqx4 = parcelRequire("8vqx4");


const $64d03a4946ae276d$var$ShareDialog = ({ sessionId: sessionId, isOpen: isOpen, onClose: onClose, language: language = 'en' })=>{
    const [shareUrl, setShareUrl] = (0, $8vqx4.useState)('');
    const [isLoading, setIsLoading] = (0, $8vqx4.useState)(false);
    const [error, setError] = (0, $8vqx4.useState)('');
    const [isCopied, setIsCopied] = (0, $8vqx4.useState)(false);
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(language);
    (0, (/*@__PURE__*/$parcel$interopDefault($8vqx4))).useEffect(()=>{
        if (isOpen && !shareUrl) generateShareLink();
    }, [
        isOpen
    ]);
    const generateShareLink = async ()=>{
        setIsLoading(true);
        setError('');
        try {
            const response = await fetch(`${(0, $1844453eead66305$export$7037112d28c7d171)}/api/share/${sessionId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Failed to generate share link');
            const data = await response.json();
            setShareUrl(data.share_url);
        } catch (err) {
            console.error('Error generating share link:', err);
            setError(t('share.error') || 'Failed to generate share link');
        } finally{
            setIsLoading(false);
        }
    };
    const copyToClipboard = async ()=>{
        try {
            await navigator.clipboard.writeText(shareUrl);
            setIsCopied(true);
            setTimeout(()=>setIsCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
        className: "wwx-share-dialog-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
            className: "wwx-share-dialog",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "wwx-share-dialog-header",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("h3", {
                            children: t('share.title') || 'Share Conversation'
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                            className: "wwx-share-dialog-close",
                            onClick: onClose,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "wwx-share-dialog-content",
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("p", {
                            className: "wwx-share-dialog-description",
                            children: t('share.description') || 'Share this conversation with your friends using the link below:'
                        }),
                        isLoading && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "wwx-share-dialog-loading",
                            children: t('share.generating') || 'Generating share link...'
                        }),
                        error && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "wwx-share-dialog-error",
                            children: error
                        }),
                        shareUrl && !isLoading && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            className: "wwx-share-dialog-link-container",
                            children: [
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("input", {
                                    type: "text",
                                    value: shareUrl,
                                    readOnly: true,
                                    className: "wwx-share-dialog-link-input",
                                    onClick: (e)=>e.currentTarget.select()
                                }),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                    className: "wwx-share-dialog-copy-button",
                                    onClick: copyToClipboard,
                                    children: isCopied ? t('share.copied') || 'Copied!' : t('share.copy') || 'Copy'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                            className: "wwx-share-dialog-note",
                            children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("small", {
                                children: t('share.note') || 'Note: This link will expire in 30 days. When someone opens this link, they will see a copy of this conversation.'
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $64d03a4946ae276d$export$2e2bcd8739ae039 = $64d03a4946ae276d$var$ShareDialog;



class $523a5f6fca69e8b2$export$f9c837a54db411d extends Error {
    constructor(message, options){
        super(message), this.name = "ParseError", this.type = options.type, this.field = options.field, this.value = options.value, this.line = options.line;
    }
}
function $523a5f6fca69e8b2$var$noop(_arg) {}
function $523a5f6fca69e8b2$export$88a1156fad04455f(callbacks) {
    if (typeof callbacks == "function") throw new TypeError("`callbacks` must be an object, got a function instead. Did you mean `{onEvent: fn}`?");
    const { onEvent: onEvent = $523a5f6fca69e8b2$var$noop, onError: onError = $523a5f6fca69e8b2$var$noop, onRetry: onRetry = $523a5f6fca69e8b2$var$noop, onComment: onComment } = callbacks;
    let incompleteLine = "", isFirstChunk = !0, id, data = "", eventType = "";
    function feed(newChunk) {
        const chunk = isFirstChunk ? newChunk.replace(/^\xEF\xBB\xBF/, "") : newChunk, [complete, incomplete] = $523a5f6fca69e8b2$var$splitLines(`${incompleteLine}${chunk}`);
        for (const line of complete)parseLine(line);
        incompleteLine = incomplete, isFirstChunk = !1;
    }
    function parseLine(line) {
        if (line === "") {
            dispatchEvent();
            return;
        }
        if (line.startsWith(":")) {
            onComment && onComment(line.slice(line.startsWith(": ") ? 2 : 1));
            return;
        }
        const fieldSeparatorIndex = line.indexOf(":");
        if (fieldSeparatorIndex !== -1) {
            const field = line.slice(0, fieldSeparatorIndex), offset = line[fieldSeparatorIndex + 1] === " " ? 2 : 1, value = line.slice(fieldSeparatorIndex + offset);
            processField(field, value, line);
            return;
        }
        processField(line, "", line);
    }
    function processField(field, value, line) {
        switch(field){
            case "event":
                eventType = value;
                break;
            case "data":
                data = `${data}${value}
`;
                break;
            case "id":
                id = value.includes("\0") ? void 0 : value;
                break;
            case "retry":
                /^\d+$/.test(value) ? onRetry(parseInt(value, 10)) : onError(new $523a5f6fca69e8b2$export$f9c837a54db411d(`Invalid \`retry\` value: "${value}"`, {
                    type: "invalid-retry",
                    value: value,
                    line: line
                }));
                break;
            default:
                onError(new $523a5f6fca69e8b2$export$f9c837a54db411d(`Unknown field "${field.length > 20 ? `${field.slice(0, 20)}\u2026` : field}"`, {
                    type: "unknown-field",
                    field: field,
                    value: value,
                    line: line
                }));
                break;
        }
    }
    function dispatchEvent() {
        data.length > 0 && onEvent({
            id: id,
            event: eventType || void 0,
            // If the data buffer's last character is a U+000A LINE FEED (LF) character,
            // then remove the last character from the data buffer.
            data: data.endsWith(`
`) ? data.slice(0, -1) : data
        }), id = void 0, data = "", eventType = "";
    }
    function reset(options = {}) {
        incompleteLine && options.consume && parseLine(incompleteLine), isFirstChunk = !0, id = void 0, data = "", eventType = "", incompleteLine = "";
    }
    return {
        feed: feed,
        reset: reset
    };
}
function $523a5f6fca69e8b2$var$splitLines(chunk) {
    const lines = [];
    let incompleteLine = "", searchIndex = 0;
    for(; searchIndex < chunk.length;){
        const crIndex = chunk.indexOf("\r", searchIndex), lfIndex = chunk.indexOf(`
`, searchIndex);
        let lineEnd = -1;
        if (crIndex !== -1 && lfIndex !== -1 ? lineEnd = Math.min(crIndex, lfIndex) : crIndex !== -1 ? lineEnd = crIndex : lfIndex !== -1 && (lineEnd = lfIndex), lineEnd === -1) {
            incompleteLine = chunk.slice(searchIndex);
            break;
        } else {
            const line = chunk.slice(searchIndex, lineEnd);
            lines.push(line), searchIndex = lineEnd + 1, chunk[searchIndex - 1] === "\r" && chunk[searchIndex] === `
` && searchIndex++;
        }
    }
    return [
        lines,
        incompleteLine
    ];
}


const $34899c866e47f869$export$93594b43c988aea3 = "connecting", $34899c866e47f869$export$bb29a81b503a982c = "open", $34899c866e47f869$export$19c4f83398a8dbce = "closed", $34899c866e47f869$var$noop = ()=>{};
function $34899c866e47f869$var$createEventSource$1(optionsOrUrl, { getStream: getStream2 }) {
    const options = typeof optionsOrUrl == "string" || optionsOrUrl instanceof URL ? {
        url: optionsOrUrl
    } : optionsOrUrl, { onMessage: onMessage, onConnect: onConnect = $34899c866e47f869$var$noop, onDisconnect: onDisconnect = $34899c866e47f869$var$noop, onScheduleReconnect: onScheduleReconnect = $34899c866e47f869$var$noop } = options, { fetch: fetch, url: url, initialLastEventId: initialLastEventId } = $34899c866e47f869$var$validate(options), requestHeaders = {
        ...options.headers
    }, onCloseSubscribers = [], subscribers = onMessage ? [
        onMessage
    ] : [], emit = (event)=>subscribers.forEach((fn)=>fn(event)), parser = (0, $523a5f6fca69e8b2$export$88a1156fad04455f)({
        onEvent: onEvent,
        onRetry: onRetry
    });
    let request, currentUrl = url.toString(), controller = new AbortController(), lastEventId = initialLastEventId, reconnectMs = 2e3, reconnectTimer, readyState = $34899c866e47f869$export$19c4f83398a8dbce;
    return connect(), {
        close: close,
        connect: connect,
        [Symbol.iterator]: ()=>{
            throw new Error("EventSource does not support synchronous iteration. Use `for await` instead.");
        },
        [Symbol.asyncIterator]: getEventIterator,
        get lastEventId () {
            return lastEventId;
        },
        get url () {
            return currentUrl;
        },
        get readyState () {
            return readyState;
        }
    };
    function connect() {
        request || (readyState = $34899c866e47f869$export$93594b43c988aea3, controller = new AbortController(), request = fetch(url, getRequestOptions()).then(onFetchResponse).catch((err)=>{
            request = null, !(err.name === "AbortError" || err.type === "aborted") && scheduleReconnect();
        }));
    }
    function close() {
        readyState = $34899c866e47f869$export$19c4f83398a8dbce, controller.abort(), parser.reset(), clearTimeout(reconnectTimer), onCloseSubscribers.forEach((fn)=>fn());
    }
    function getEventIterator() {
        const pullQueue = [], pushQueue = [];
        function pullValue() {
            return new Promise((resolve)=>{
                const value = pushQueue.shift();
                value ? resolve({
                    value: value,
                    done: !1
                }) : pullQueue.push(resolve);
            });
        }
        const pushValue = function(value) {
            const resolve = pullQueue.shift();
            resolve ? resolve({
                value: value,
                done: !1
            }) : pushQueue.push(value);
        };
        function unsubscribe() {
            for(subscribers.splice(subscribers.indexOf(pushValue), 1); pullQueue.shift(););
            for(; pushQueue.shift(););
        }
        function onClose() {
            const resolve = pullQueue.shift();
            resolve && (resolve({
                done: !0,
                value: void 0
            }), unsubscribe());
        }
        return onCloseSubscribers.push(onClose), subscribers.push(pushValue), {
            next () {
                return readyState === $34899c866e47f869$export$19c4f83398a8dbce ? this.return() : pullValue();
            },
            return () {
                return unsubscribe(), Promise.resolve({
                    done: !0,
                    value: void 0
                });
            },
            throw (error) {
                return unsubscribe(), Promise.reject(error);
            },
            [Symbol.asyncIterator] () {
                return this;
            }
        };
    }
    function scheduleReconnect() {
        onScheduleReconnect({
            delay: reconnectMs
        }), readyState = $34899c866e47f869$export$93594b43c988aea3, reconnectTimer = setTimeout(connect, reconnectMs);
    }
    async function onFetchResponse(response) {
        onConnect(), parser.reset();
        const { body: body, redirected: redirected, status: status } = response;
        if (status === 204) {
            onDisconnect(), close();
            return;
        }
        if (!body) throw new Error("Missing response body");
        redirected && (currentUrl = response.url);
        const stream = getStream2(body), decoder = new TextDecoder(), reader = stream.getReader();
        let open = !0;
        readyState = $34899c866e47f869$export$bb29a81b503a982c;
        do {
            const { done: done, value: value } = await reader.read();
            value && parser.feed(decoder.decode(value, {
                stream: !done
            })), done && (open = !1, request = null, parser.reset(), scheduleReconnect(), onDisconnect());
        }while (open);
    }
    function onEvent(msg) {
        typeof msg.id == "string" && (lastEventId = msg.id), emit(msg);
    }
    function onRetry(ms) {
        reconnectMs = ms;
    }
    function getRequestOptions() {
        const { mode: mode, credentials: credentials, body: body, method: method, redirect: redirect, referrer: referrer, referrerPolicy: referrerPolicy } = options, headers = {
            Accept: "text/event-stream",
            ...requestHeaders,
            ...lastEventId ? {
                "Last-Event-ID": lastEventId
            } : void 0
        };
        return {
            mode: mode,
            credentials: credentials,
            body: body,
            method: method,
            redirect: redirect,
            referrer: referrer,
            referrerPolicy: referrerPolicy,
            headers: headers,
            cache: "no-store",
            signal: controller.signal
        };
    }
}
function $34899c866e47f869$var$validate(options) {
    const fetch = options.fetch || globalThis.fetch;
    if (!$34899c866e47f869$var$isFetchLike(fetch)) throw new Error("No fetch implementation provided, and one was not found on the global object.");
    if (typeof AbortController != "function") throw new Error("Missing AbortController implementation");
    const { url: url, initialLastEventId: initialLastEventId } = options;
    if (typeof url != "string" && !(url instanceof URL)) throw new Error("Invalid URL provided - must be string or URL instance");
    if (typeof initialLastEventId != "string" && initialLastEventId !== void 0) throw new Error("Invalid initialLastEventId provided - must be string or undefined");
    return {
        fetch: fetch,
        url: url,
        initialLastEventId: initialLastEventId
    };
}
function $34899c866e47f869$var$isFetchLike(fetch) {
    return typeof fetch == "function";
}
const $34899c866e47f869$var$defaultAbstractions = {
    getStream: $34899c866e47f869$var$getStream
};
function $34899c866e47f869$export$e2b92a0132f9586f(optionsOrUrl) {
    return $34899c866e47f869$var$createEventSource$1(optionsOrUrl, $34899c866e47f869$var$defaultAbstractions);
}
function $34899c866e47f869$var$getStream(body) {
    if (!(body instanceof ReadableStream)) throw new Error("Invalid stream, expected a web ReadableStream");
    return body;
}


class $2c181732ca03de80$var$VoiceService {
    constructor(config){
        this.recognition = null;
        this.synthesis = null;
        this.isListening = false;
        this.isSpeaking = false;
        this.currentUtterance = null;
        this.voiceEnabled = true;
        this.silenceTimer = null;
        this.lastSpeechTime = 0;
        this.SILENCE_TIMEOUT = 10000 // 10 seconds of silence triggers auto-stop
        ;
        this.hasReceivedSpeech = false;
        this.config = config;
        this.initializeSpeechRecognition();
        this.initializeSpeechSynthesis();
    }
    initializeSpeechRecognition() {
        if (typeof window === 'undefined') return;
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            console.warn('Speech recognition not supported in this browser');
            return;
        }
        this.recognition = new SpeechRecognition();
        this.recognition.continuous = true; // Changed to true for silence detection
        this.recognition.interimResults = true;
        this.recognition.maxAlternatives = 1;
        this.updateLanguage(this.config.language);
        this.recognition.onstart = ()=>{
            this.isListening = true;
            this.hasReceivedSpeech = false;
            this.finalTranscript = '';
            this.lastSpeechTime = Date.now();
            this.startSilenceDetection();
            this.config.onStart?.();
        };
        this.recognition.onresult = (event)=>{
            const last = event.results.length - 1;
            const transcript = event.results[last][0].transcript;
            const isFinal = event.results[last].isFinal;
            // Update last speech time when we receive any speech
            this.lastSpeechTime = Date.now();
            this.hasReceivedSpeech = true;
            // Reset silence timer on new speech
            this.resetSilenceTimer();
            if (isFinal) this.config.onTranscript?.(transcript);
        };
        this.recognition.onspeechend = ()=>{
            // Speech has ended, start countdown for auto-stop
            this.startSilenceTimer();
        };
        this.recognition.onerror = (event)=>{
            this.isListening = false;
            this.clearSilenceDetection();
            console.error('Speech recognition error:', event.error);
            if (event.error === 'not-allowed') this.config.onError?.(new Error('Microphone access denied. Please allow microphone access to use voice input.'));
            else if (event.error !== 'aborted') this.config.onError?.(new Error(`Speech recognition error: ${event.error}`));
        };
        this.recognition.onend = ()=>{
            this.isListening = false;
            this.clearSilenceDetection();
            this.config.onEnd?.();
        };
    }
    initializeSpeechSynthesis() {
        if (typeof window === 'undefined') return;
        if ('speechSynthesis' in window) this.synthesis = window.speechSynthesis;
        else console.warn('Speech synthesis not supported in this browser');
    }
    startSilenceDetection() {
        // Check for silence every 500ms
        const checkInterval = setInterval(()=>{
            if (!this.isListening) {
                clearInterval(checkInterval);
                return;
            }
            const timeSinceLastSpeech = Date.now() - this.lastSpeechTime;
            // If we've had speech and now silence for more than threshold
            if (this.hasReceivedSpeech && timeSinceLastSpeech > this.SILENCE_TIMEOUT) {
                console.log('Auto-stopping due to silence');
                this.stopListening();
                clearInterval(checkInterval);
            }
        }, 500);
    }
    startSilenceTimer() {
        this.clearSilenceTimer();
        this.silenceTimer = setTimeout(()=>{
            if (this.isListening && this.hasReceivedSpeech) {
                console.log('Auto-stopping due to silence after speech');
                this.stopListening();
            }
        }, this.SILENCE_TIMEOUT);
    }
    resetSilenceTimer() {
        this.clearSilenceTimer();
        // Restart the timer
        this.startSilenceTimer();
    }
    clearSilenceTimer() {
        if (this.silenceTimer) {
            clearTimeout(this.silenceTimer);
            this.silenceTimer = null;
        }
    }
    clearSilenceDetection() {
        this.clearSilenceTimer();
        this.hasReceivedSpeech = false;
    }
    getLanguageCode(language) {
        const languageMap = {
            'en': 'en-US',
            'zh-TW': 'zh-HK',
            'zh-CN': 'zh-CN',
            'es': 'es-ES',
            'fr': 'fr-FR',
            'de': 'de-DE',
            'it': 'it-IT',
            'ja': 'ja-JP',
            'ko': 'ko-KR'
        };
        return languageMap[language] || 'en-US';
    }
    updateLanguage(language) {
        this.config.language = language;
        if (this.recognition) this.recognition.lang = this.getLanguageCode(language);
    }
    startListening() {
        return new Promise((resolve, reject)=>{
            if (!this.recognition) {
                reject(new Error('Speech recognition not supported'));
                return;
            }
            if (this.isListening) {
                reject(new Error('Already listening'));
                return;
            }
            if (this.isSpeaking) this.stopSpeaking();
            try {
                this.recognition.start();
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
    stopListening() {
        if (this.recognition && this.isListening) {
            this.clearSilenceDetection();
            this.recognition.stop();
        }
    }
    speak(text, options) {
        return new Promise((resolve, reject)=>{
            if (!this.synthesis || !this.voiceEnabled) {
                resolve();
                return;
            }
            if (this.isSpeaking) this.stopSpeaking();
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = this.getLanguageCode(this.config.language);
            utterance.rate = options?.rate || 1;
            utterance.pitch = options?.pitch || 1;
            utterance.volume = options?.volume || 1;
            const voices = this.synthesis.getVoices();
            const langCode = this.getLanguageCode(this.config.language);
            const voice = voices.find((v)=>v.lang === langCode) || voices[0];
            if (voice) utterance.voice = voice;
            utterance.onstart = ()=>{
                this.isSpeaking = true;
                this.currentUtterance = utterance;
            };
            utterance.onend = ()=>{
                this.isSpeaking = false;
                this.currentUtterance = null;
                resolve();
            };
            utterance.onerror = (event)=>{
                this.isSpeaking = false;
                this.currentUtterance = null;
                console.error('Speech synthesis error:', event);
                reject(new Error('Speech synthesis failed'));
            };
            this.synthesis.speak(utterance);
        });
    }
    stopSpeaking() {
        if (this.synthesis && this.isSpeaking) {
            this.synthesis.cancel();
            this.isSpeaking = false;
            this.currentUtterance = null;
        }
    }
    toggleVoice(enabled) {
        this.voiceEnabled = enabled;
        if (!enabled) this.stopSpeaking();
    }
    setSilenceTimeout(milliseconds) {
        this.SILENCE_TIMEOUT = milliseconds;
    }
    getIsListening() {
        return this.isListening;
    }
    getIsSpeaking() {
        return this.isSpeaking;
    }
    isVoiceEnabled() {
        return this.voiceEnabled;
    }
    isSupported() {
        const hasSpeechRecognition = !!window.SpeechRecognition || !!window.webkitSpeechRecognition;
        const hasSpeechSynthesis = 'speechSynthesis' in window;
        return hasSpeechRecognition && hasSpeechSynthesis;
    }
    destroy() {
        this.stopListening();
        this.stopSpeaking();
        this.clearSilenceDetection();
        this.recognition = null;
        this.synthesis = null;
    }
}
var $2c181732ca03de80$export$2e2bcd8739ae039 = $2c181732ca03de80$var$VoiceService;


const $2365c19848a47fac$var$ChatWidget = ({ initialConfig: initialConfig, isVisible: isVisible, onClose: onClose, sessionId: sessionId })=>{
    const [config, setConfig] = (0, $8vqx4.useState)(initialConfig);
    const [messages, setMessages] = (0, $8vqx4.useState)([]);
    const [inputValue, setInputValue] = (0, $8vqx4.useState)('');
    const [isWaitingForResponse, setIsWaitingForResponse] = (0, $8vqx4.useState)(false);
    const [showHistory, setShowHistory] = (0, $8vqx4.useState)(false);
    const [historyData, setHistoryData] = (0, $8vqx4.useState)([]);
    const [currentSessionId, setCurrentSessionId] = (0, $8vqx4.useState)(window.location.search.includes('session_id=') ? new URLSearchParams(window.location.search).get('session_id') : null);
    const [isDragging, setIsDragging] = (0, $8vqx4.useState)(false);
    const [dragOffset, setDragOffset] = (0, $8vqx4.useState)({
        x: 0,
        y: 0
    });
    const [position, setPosition] = (0, $8vqx4.useState)({
        x: 20,
        y: 20
    });
    const [dailyLimitStatus, setDailyLimitStatus] = (0, $8vqx4.useState)({
        remaining: null,
        limit: null,
        isExceeded: false,
        message: ''
    });
    const [displayedOffers, setDisplayedOffers] = (0, $8vqx4.useState)(new Map());
    const [isResizing, setIsResizing] = (0, $8vqx4.useState)(false);
    const [size, setSize] = (0, $8vqx4.useState)({
        width: 800,
        height: window.innerHeight * 0.8
    });
    const [resizeStart, setResizeStart] = (0, $8vqx4.useState)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const [selectedCategories, setSelectedCategories] = (0, $8vqx4.useState)({});
    const [showAuthPrompt, setShowAuthPrompt] = (0, $8vqx4.useState)(false);
    const [userToken, setUserToken] = (0, $8vqx4.useState)(null);
    const [isFullScreen, setIsFullScreen] = (0, $8vqx4.useState)(false);
    const [isListening, setIsListening] = (0, $8vqx4.useState)(false);
    const [showShareDialog, setShowShareDialog] = (0, $8vqx4.useState)(false);
    const [hasFirstResult, setHasFirstResult] = (0, $8vqx4.useState)(false);
    const [isSharedConversation, setIsSharedConversation] = (0, $8vqx4.useState)(false);
    const [originalSharedSessionId, setOriginalSharedSessionId] = (0, $8vqx4.useState)(null);
    const messagesEndRef = (0, $8vqx4.useRef)(null);
    const eventSourceRef = (0, $8vqx4.useRef)(null);
    const widgetRef = (0, $8vqx4.useRef)(null);
    const voiceServiceRef = (0, $8vqx4.useRef)(null);
    const { t: t } = (0, $10bbf922fc88f04e$export$9fc83ad70ead8663)(config.language);
    // Update config when initialConfig changes
    (0, $8vqx4.useEffect)(()=>{
        const prevCurrency = config.currency;
        const prevLanguage = config.language;
        setConfig(initialConfig);
        // If currency changed and we have displayed offers, refresh them
        if (prevCurrency !== initialConfig.currency && displayedOffers.size > 0) refreshAllOffers(initialConfig.currency);
        // Update voice service language if changed
        if (prevLanguage !== initialConfig.language && voiceServiceRef.current) voiceServiceRef.current.updateLanguage(initialConfig.language || 'en');
    }, [
        initialConfig,
        displayedOffers
    ]);
    // Initialize voice service
    (0, $8vqx4.useEffect)(()=>{
        if (!voiceServiceRef.current) voiceServiceRef.current = new (0, $2c181732ca03de80$export$2e2bcd8739ae039)({
            language: config.language || 'en',
            onTranscript: (text)=>{
                setInputValue((o)=>o + ' ' + text);
            },
            onError: (error)=>{
                console.error('Voice error:', error);
            },
            onStart: ()=>setIsListening(true),
            onEnd: ()=>setIsListening(false)
        });
        return ()=>{
            if (voiceServiceRef.current) {
                voiceServiceRef.current.destroy();
                voiceServiceRef.current = null;
            }
        };
    }, []);
    // Initialize session management and check for token in URL
    (0, $8vqx4.useEffect)(()=>{
        // Check if we're in full-screen mode (widget takes up whole viewport)
        const checkFullScreen = ()=>{
            const container = document.querySelector('.wwx-chat-widget-container');
            if (container) {
                const rect = container.getBoundingClientRect();
                const isFullViewport = rect.width >= window.innerWidth * 0.95 && rect.height >= window.innerHeight * 0.95;
                setIsFullScreen(isFullViewport);
            }
        };
        checkFullScreen();
        window.addEventListener('resize', checkFullScreen);
        // Check for token in URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = urlParams.get('token');
        if (tokenFromUrl) {
            // Store the token
            setUserToken(tokenFromUrl);
            (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_user_token', tokenFromUrl);
            // Update the config with the token
            setConfig((prev)=>({
                    ...prev,
                    user: tokenFromUrl
                }));
            // Clean up the URL to remove the token parameter
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('token');
            window.history.replaceState({}, document.title, newUrl.toString());
            console.log('User authenticated via token from URL');
        } else {
            // Check if we have a stored token
            const storedToken = (0, $540271f4c8f7b579$export$ddcffe0146c8f882).get('wwx_user_token');
            if (storedToken) {
                setUserToken(storedToken);
                setConfig((prev)=>({
                        ...prev,
                        user: storedToken
                    }));
            }
        }
        initializeSession();
        return ()=>{
            window.removeEventListener('resize', checkFullScreen);
        };
    }, []);
    // Load history when sessionId prop changes
    (0, $8vqx4.useEffect)(()=>{
        if (sessionId && sessionId !== currentSessionId) {
            loadSessionHistory(sessionId);
            setCurrentSessionId(sessionId);
        }
    }, [
        sessionId,
        currentSessionId
    ]);
    // Cleanup EventSource on unmount
    (0, $8vqx4.useEffect)(()=>{
        return ()=>{
            if (eventSourceRef.current) eventSourceRef.current.close();
        };
    }, []);
    // Drag functionality
    (0, $8vqx4.useEffect)(()=>{
        if (isDragging) {
            const handleMouseMove = (e)=>{
                if (!isDragging || (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)()) return;
                const newX = e.clientX - dragOffset.x;
                const newY = e.clientY - dragOffset.y;
                const maxX = window.innerWidth - size.width;
                const maxY = window.innerHeight * 0.2;
                setPosition({
                    x: Math.max(0, Math.min(newX, maxX)),
                    y: Math.max(0, Math.min(newY, maxY))
                });
            };
            const handleMouseUp = ()=>{
                setIsDragging(false);
            };
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.body.style.userSelect = 'none';
            return ()=>{
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                document.body.style.userSelect = '';
            };
        }
    }, [
        isDragging,
        dragOffset,
        size.width
    ]);
    // Resize functionality
    (0, $8vqx4.useEffect)(()=>{
        if (isResizing) {
            const handleMouseMove = (e)=>{
                if (!isResizing || (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)()) return;
                const deltaX = e.clientX - resizeStart.x;
                const deltaY = e.clientY - resizeStart.y;
                const newWidth = Math.max(600, Math.min(resizeStart.width + deltaX, window.innerWidth * 0.9));
                const newHeight = Math.max(400, Math.min(resizeStart.height + deltaY, window.innerHeight * 0.9));
                setSize({
                    width: newWidth,
                    height: newHeight
                });
            };
            const handleMouseUp = ()=>{
                setIsResizing(false);
            };
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.body.style.userSelect = 'none';
            document.body.style.cursor = 'nwse-resize';
            return ()=>{
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                document.body.style.userSelect = '';
                document.body.style.cursor = '';
            };
        }
    }, [
        isResizing,
        resizeStart
    ]);
    const scrollToBottom = (0, $8vqx4.useCallback)(()=>{
        setTimeout(()=>{
            messagesEndRef.current?.scrollIntoView({
                behavior: 'smooth'
            });
        }, 50);
    }, []);
    const initializeSession = async ()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const requestedSessionId = urlParams.get('session_id');
        const shareId = urlParams.get('share');
        const startNewChat = urlParams.get('new') === 'true';
        const storedSessionId = (0, $540271f4c8f7b579$export$ddcffe0146c8f882).get('wwx_session_id');
        let sessionToLoad = null;
        if (shareId) {
            // Handle shared conversation
            console.log(`Loading shared conversation: ${shareId}`);
            await loadSharedConversation(shareId);
            return;
        } else if (startNewChat) {
            console.log("Starting new chat explicitly via 'new=true' parameter.");
            sessionToLoad = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
            (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', sessionToLoad);
            setCurrentSessionId(sessionToLoad);
            setMessages([
                createWelcomeMessage()
            ]);
        } else if (requestedSessionId) {
            console.log(`Loading session from query param: ${requestedSessionId}`);
            sessionToLoad = requestedSessionId;
            (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', sessionToLoad);
            setCurrentSessionId(sessionToLoad);
            await loadSessionHistory(sessionToLoad);
        } else if (storedSessionId) {
            console.log(`Continuing session from localStorage: ${storedSessionId}`);
            sessionToLoad = storedSessionId;
            setCurrentSessionId(sessionToLoad);
            await loadSessionHistory(sessionToLoad);
        } else {
            console.log("No session found. Starting new chat implicitly.");
            sessionToLoad = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
            (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', sessionToLoad);
            setCurrentSessionId(sessionToLoad);
            setMessages([
                createWelcomeMessage()
            ]);
        }
    };
    const loadSharedConversation = async (shareId)=>{
        try {
            const response = await fetch(`${(0, $1844453eead66305$export$7037112d28c7d171)}/api/shared/${shareId}`, {
                credentials: 'include'
            });
            if (!response.ok) {
                console.error('Shared conversation not found or expired');
                // Start a new session instead
                const newSessionId = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
                (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', newSessionId);
                setCurrentSessionId(newSessionId);
                setMessages([
                    createWelcomeMessage()
                ]);
                return;
            }
            const data = await response.json();
            const { session_id: originalSessionId, history: history, is_shared: is_shared } = data;
            // Create a new session for this user
            const newSessionId = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
            (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', newSessionId);
            setCurrentSessionId(newSessionId);
            setIsSharedConversation(true);
            setOriginalSharedSessionId(originalSessionId);
            // Copy the conversation to the new session
            await fetch(`${(0, $1844453eead66305$export$7037112d28c7d171)}/api/copy_shared`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    original_session_id: originalSessionId,
                    new_session_id: newSessionId
                })
            });
            // Load the history
            if (history && history.length > 0) {
                const loadedMessages = await Promise.all(history.map(async (msg)=>{
                    const message = {
                        role: msg.role,
                        content: msg.role === 'assistant' && typeof msg.content === 'string' ? await (0, $540271f4c8f7b579$export$bd6a2eae5de02ff5)(msg.content) : msg.content,
                        id: (0, $540271f4c8f7b579$export$e73c8bd0f20705a)(),
                        offer_ids: msg.offer_ids
                    };
                    if (msg.offer_ids && msg.offer_ids.length > 0) setHasFirstResult(true);
                    return message;
                }));
                setMessages(loadedMessages);
                // Clean up the URL to remove the share parameter
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.delete('share');
                window.history.replaceState({}, document.title, newUrl.toString());
            }
        } catch (error) {
            console.error('Error loading shared conversation:', error);
            // Start a new session on error
            const newSessionId = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
            (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', newSessionId);
            setCurrentSessionId(newSessionId);
            setMessages([
                createWelcomeMessage()
            ]);
        }
    };
    const loadSessionHistory = async (sessionId)=>{
        try {
            const response = await fetch(`${(0, $1844453eead66305$export$7037112d28c7d171)}/api/history/${sessionId}`, {
                credentials: 'include',
                headers: {
                    ...config.user ? {
                        'Authorization': `Bearer ${config.user}`
                    } : {}
                }
            });
            if (response.ok) {
                const history = await response.json();
                if (history && history.length > 0) {
                    const formattedMessages = await Promise.all(history.map(async (msg)=>({
                            role: msg.role,
                            content: msg.role === 'assistant' && typeof msg.content === 'string' ? await (0, $540271f4c8f7b579$export$bd6a2eae5de02ff5)(msg.content) : msg.content,
                            id: msg.id || (0, $540271f4c8f7b579$export$e73c8bd0f20705a)(),
                            offer_ids: msg.offer_ids
                        })));
                    setMessages(formattedMessages);
                } else setMessages([
                    createWelcomeMessage()
                ]);
            } else setMessages([
                createWelcomeMessage()
            ]);
        } catch (error) {
            console.error('Error loading session history:', error);
            setMessages([
                createWelcomeMessage()
            ]);
        }
    };
    const loadHistoryList = async ()=>{
        try {
            const response = await fetch(`${(0, $1844453eead66305$export$7037112d28c7d171)}/api/history`, {
                credentials: 'include',
                headers: {
                    ...config.user ? {
                        'Authorization': `Bearer ${config.user}`
                    } : {}
                }
            });
            if (response.ok) {
                const history = await response.json();
                setHistoryData(history);
                setShowHistory(true);
            }
        } catch (error) {
            console.error('Error loading history list:', error);
        }
    };
    const addMessage = (0, $8vqx4.useCallback)((content, role, options = {})=>{
        const newMessage = {
            role: role,
            content: content,
            id: (0, $540271f4c8f7b579$export$e73c8bd0f20705a)(),
            ...options
        };
        setMessages((prevMessages)=>[
                ...prevMessages,
                newMessage
            ]);
        return newMessage;
    }, []);
    const updateLastMessage = (0, $8vqx4.useCallback)((content, removeThinking = false)=>{
        setMessages((prevMessages)=>{
            const newMessages = [
                ...prevMessages
            ];
            // Search from the end for the appropriate message
            let targetIndex = -1;
            for(let i = newMessages.length - 1; i >= 0; i--){
                const message = newMessages[i];
                if (removeThinking) // Look for a message that is not a component and is thinking
                {
                    if (!message.isComponent && message.isThinking) {
                        targetIndex = i;
                        break;
                    }
                } else // Look for a message that is not a component
                if (!message.isComponent) {
                    targetIndex = i;
                    break;
                }
            }
            if (targetIndex !== -1) {
                const targetMessage = {
                    ...newMessages[targetIndex]
                };
                targetMessage.content = content;
                if (removeThinking) targetMessage.isThinking = false;
                newMessages[targetIndex] = targetMessage;
            }
            return newMessages;
        });
    }, []);
    const handleFormSubmit = (0, $8vqx4.useCallback)((e)=>{
        e.preventDefault();
        if (isWaitingForResponse) {
            console.log("Already waiting for a response. Ignoring new submission.");
            return;
        }
        // Format categories with square brackets and place at end
        const userInput = inputValue.trim();
        const categoryValues = Object.values(selectedCategories).map((value)=>`[${value}]`).join(' ');
        const fullMessage = userInput && categoryValues ? `${userInput} ${categoryValues}` : userInput || categoryValues;
        if (fullMessage) {
            if (eventSourceRef.current) eventSourceRef.current.close();
            addMessage(fullMessage, 'user');
            const currentThinkingMessage = addMessage(t('thinking'), 'assistant', {
                isThinking: true
            });
            setInputValue('');
            setSelectedCategories({}); // Clear selected categories after sending
            setIsWaitingForResponse(true);
            const queryParams = new URLSearchParams({
                message: fullMessage,
                session_id: currentSessionId || '',
                currency: config.currency
            });
            const es = eventSourceRef.current = (0, $34899c866e47f869$export$e2b92a0132f9586f)({
                url: `${(0, $1844453eead66305$export$7037112d28c7d171)}/chat?${queryParams.toString()}`,
                credentials: 'include',
                headers: {
                    'Authorization': `Bearer ${config.user}`
                },
                onDisconnect: ()=>{
                    console.log('here');
                    es.close();
                },
                onMessage: async ({ data: data, event: event, id: id })=>{
                    console.log('Received SSE event:', {
                        event: event,
                        id: id,
                        data: data
                    });
                    if (!event || event === 'message') {
                        // Default message event
                        const htmlContent = await (0, $540271f4c8f7b579$export$bd6a2eae5de02ff5)(data.replace(/\\n/g, '\n'));
                        updateLastMessage(htmlContent, true);
                    } else if (event === 'step') updateLastMessage(t('thinkingStep', {
                        step: data
                    }));
                    else if (event === 'done') {
                        console.log("SSE stream ended by server.");
                        es.close();
                        setIsWaitingForResponse(false);
                    } else if (event === 'ui_action') {
                        if (data === 'show_whatsapp') addWhatsAppButton();
                    } else if (event === 'offers') {
                        console.log("Received offers event:", data);
                        try {
                            const offerIds = JSON.parse(data);
                            if (Array.isArray(offerIds) && offerIds.length > 0) {
                                // Mark that we have received our first result
                                setHasFirstResult(true);
                                const targetMessageId = currentThinkingMessage?.id || null;
                                fetchOfferDetailsAndDisplayCarousel(offerIds, targetMessageId);
                            }
                        } catch (e) {
                            console.error("Error parsing offer IDs:", e);
                        }
                    } else if (event === 'limit_status') try {
                        const statusData = JSON.parse(data);
                        console.log("Received limit_status event:", statusData);
                        setDailyLimitStatus({
                            remaining: statusData.remaining,
                            limit: statusData.limit,
                            isExceeded: statusData.is_exceeded,
                            message: statusData.message || (statusData.is_exceeded ? t('dailyLimitReached') : '')
                        });
                        if (statusData.is_exceeded) {
                            setIsWaitingForResponse(false);
                            setMessages((prevMessages)=>{
                                const lastMsg = prevMessages[prevMessages.length - 1];
                                if (lastMsg && lastMsg.isThinking) {
                                    const newMessages = [
                                        ...prevMessages
                                    ];
                                    const updatedLastMessage = {
                                        ...lastMsg,
                                        content: statusData.message || t('dailyLimitReached'),
                                        isThinking: false
                                    };
                                    newMessages[newMessages.length - 1] = updatedLastMessage;
                                    return newMessages;
                                }
                                return prevMessages;
                            });
                            // Show auth prompt if user is not logged in
                            if (!userToken) setShowAuthPrompt(true);
                        }
                    } catch (e) {
                        console.error("Error parsing limit_status event:", e);
                    }
                }
            });
        }
    }, [
        isWaitingForResponse,
        inputValue,
        currentSessionId,
        config.currency,
        messages,
        addMessage,
        updateLastMessage,
        t
    ]);
    const addWhatsAppButton = (0, $8vqx4.useCallback)(()=>{
        const hasWhatsApp = messages.some((msg)=>msg.isWhatsApp || typeof msg.content === 'string' && msg.content.includes('whatsapp-button'));
        if (!hasWhatsApp) addMessage(/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $5e1b9f9c363a4484$export$2e2bcd8739ae039), {
            language: config.language
        }), 'assistant', {
            isComponent: true,
            isWhatsApp: true
        });
    }, [
        messages,
        addMessage,
        config.language
    ]);
    const refreshAllOffers = (0, $8vqx4.useCallback)((currency)=>{
        // Remove existing carousel messages
        setMessages((prevMessages)=>prevMessages.filter((msg)=>!msg.isCarousel));
        // Re-fetch each carousel with its original position
        displayedOffers.forEach((offerData)=>{
            fetchOfferDetailsAndDisplayCarousel(offerData.oids, offerData.messageId, currency);
        });
        setDisplayedOffers(new Map());
    }, [
        displayedOffers
    ]);
    const displayOfferCarousel = (0, $8vqx4.useCallback)((offersData, targetMessageId = null, oids = [])=>{
        const carouselId = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
        // Track this carousel with its oids and position
        if (oids.length > 0 && targetMessageId) setDisplayedOffers((prev)=>{
            const newMap = new Map(prev);
            newMap.set(carouselId, {
                oids: oids,
                messageId: targetMessageId
            });
            return newMap;
        });
        const carouselMessage = {
            role: 'assistant',
            content: '',
            id: carouselId,
            isCarousel: true,
            carouselData: offersData,
            skipHistoricalProcessing: true,
            targetMessageId: targetMessageId || undefined
        };
        if (targetMessageId) setMessages((prevMessages)=>{
            const targetIndex = prevMessages.findIndex((msg)=>msg.id === targetMessageId);
            if (targetIndex !== -1) {
                const newMessages = [
                    ...prevMessages
                ];
                newMessages.splice(targetIndex, 0, carouselMessage);
                return newMessages;
            }
            return [
                ...prevMessages,
                carouselMessage
            ];
        });
        else setMessages((prevMessages)=>[
                ...prevMessages,
                carouselMessage
            ]);
    }, []);
    const fetchOfferDetailsAndDisplayCarousel = (0, $8vqx4.useCallback)((offerIds, targetMessageId = null, overrideCurrency)=>{
        const loadingMessageId = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
        const loadingMessage = {
            role: 'assistant',
            content: '',
            id: loadingMessageId,
            isLoading: true,
            skipHistoricalProcessing: true,
            targetMessageId: targetMessageId || undefined
        };
        if (targetMessageId) setMessages((prevMessages)=>{
            const targetIndex = prevMessages.findIndex((msg)=>msg.id === targetMessageId);
            if (targetIndex !== -1) {
                const newMessages = [
                    ...prevMessages
                ];
                newMessages.splice(targetIndex, 0, loadingMessage);
                return newMessages;
            }
            return [
                ...prevMessages,
                loadingMessage
            ];
        });
        else setMessages((prevMessages)=>[
                ...prevMessages,
                loadingMessage
            ]);
        fetch(`${(0, $1844453eead66305$export$7037112d28c7d171)}/get_offer_details`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                ...config.user ? {
                    'Authorization': `Bearer ${config.user}`
                } : {},
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                offer_ids: offerIds,
                currency: overrideCurrency || config.currency
            })
        }).then((response)=>{
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
        }).then((offersData)=>{
            setMessages((prevMessages)=>prevMessages.filter((msg)=>msg.id !== loadingMessageId));
            if (Array.isArray(offersData) && offersData.length > 0) {
                // Extract oids from the offers data
                const oids = offersData.map((offer)=>offer.offer_oid).filter(Boolean);
                displayOfferCarousel(offersData, targetMessageId, oids);
            }
        }).catch((error)=>{
            console.error('Error fetching offer details:', error);
            setMessages((prevMessages)=>prevMessages.filter((msg)=>msg.id !== loadingMessageId));
            const errorMessage = {
                role: 'assistant',
                content: t('errorLoadingWine'),
                id: (0, $540271f4c8f7b579$export$e73c8bd0f20705a)(),
                skipHistoricalProcessing: true,
                targetMessageId: targetMessageId || undefined
            };
            if (targetMessageId) setMessages((prevMessages)=>{
                const targetIndex = prevMessages.findIndex((msg)=>msg.id === targetMessageId);
                if (targetIndex !== -1) {
                    const newMessages = [
                        ...prevMessages
                    ];
                    newMessages.splice(targetIndex, 0, errorMessage);
                    return newMessages;
                }
                return [
                    ...prevMessages,
                    errorMessage
                ];
            });
            else setMessages((prevMessages)=>[
                    ...prevMessages,
                    errorMessage
                ]);
        });
    }, [
        config.currency,
        t
    ]);
    const handleHistoricalOffers = (0, $8vqx4.useCallback)(()=>{
        messages.forEach((msg)=>{
            if (msg.role === 'assistant' && msg.offer_ids && Array.isArray(msg.offer_ids) && msg.offer_ids.length > 0 && !msg.offersProcessed && !msg.skipHistoricalProcessing) {
                console.log(`Rendering historical offers for message ${msg.id}:`, msg.offer_ids);
                msg.offersProcessed = true;
                fetchOfferDetailsAndDisplayCarousel(msg.offer_ids, msg.id);
            }
        });
    }, [
        messages,
        fetchOfferDetailsAndDisplayCarousel
    ]);
    // Scroll to bottom when messages change
    (0, $8vqx4.useEffect)(()=>{
        scrollToBottom();
        handleHistoricalOffers();
    }, [
        messages
    ]);
    const handleMouseDown = (0, $8vqx4.useCallback)((e)=>{
        if ((0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)()) return;
        if (!e.target.closest('.xr-banner')) return;
        if (e.target.closest('button')) return;
        setIsDragging(true);
        const rect = widgetRef.current?.getBoundingClientRect();
        if (rect) setDragOffset({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        });
        e.preventDefault();
    }, []);
    const handleResizeMouseDown = (0, $8vqx4.useCallback)((e)=>{
        if ((0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)()) return;
        e.preventDefault();
        e.stopPropagation();
        setIsResizing(true);
        setResizeStart({
            x: e.clientX,
            y: e.clientY,
            width: size.width,
            height: size.height
        });
    }, [
        size
    ]);
    const handleNewChat = (0, $8vqx4.useCallback)(()=>{
        const newSessionId = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
        (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', newSessionId);
        setCurrentSessionId(newSessionId);
        setMessages([
            createWelcomeMessage()
        ]);
        // Clear tracked offers for new chat
        setDisplayedOffers(new Map());
        // Clear selected categories
        setSelectedCategories({});
    }, [
        config.language,
        isWaitingForResponse
    ]);
    const handleSelectSession = (0, $8vqx4.useCallback)((sessionId)=>{
        loadSessionHistory(sessionId);
        setShowHistory(false);
        // Clear tracked offers when switching sessions
        setDisplayedOffers(new Map());
        // Clear selected categories
        setSelectedCategories({});
    }, []);
    const createWelcomeMessage = (0, $8vqx4.useCallback)(()=>{
        return {
            role: 'assistant',
            content: '',
            id: (0, $540271f4c8f7b579$export$e73c8bd0f20705a)(),
            isWelcome: true
        };
    }, []);
    const handleSelectionClick = (0, $8vqx4.useCallback)((category, value)=>{
        if (!isWaitingForResponse) {
            // Update selected categories
            setSelectedCategories((prev)=>({
                    ...prev,
                    [category]: value
                }));
            // Don't modify the input value directly since we're showing categories as tags
            // The user can still type additional text in the input
            // Focus back on the input
            setTimeout(()=>{
                const input = document.getElementById('messageInput');
                if (input) input.focus();
            }, 50);
        }
    }, [
        isWaitingForResponse,
        selectedCategories
    ]);
    const handleSignupClick = (0, $8vqx4.useCallback)(()=>{
        // Redirect to main website signup with sent_from parameter
        window.location.href = `${0, $1844453eead66305$export$22e11c0aab7270fe}/signup?sent_from=zyra`;
    }, []);
    const handleLoginClick = (0, $8vqx4.useCallback)(()=>{
        // Redirect to main website login with sent_from parameter
        window.location.href = `${0, $1844453eead66305$export$22e11c0aab7270fe}/login?sent_from=zyra`;
    }, []);
    const handleLogout = (0, $8vqx4.useCallback)(()=>{
        // Clear the stored token
        (0, $540271f4c8f7b579$export$ddcffe0146c8f882).remove('wwx_user_token');
        setUserToken(null);
        setConfig((prev)=>({
                ...prev,
                user: null
            }));
        // Reset session
        const newSessionId = (0, $540271f4c8f7b579$export$e73c8bd0f20705a)();
        (0, $540271f4c8f7b579$export$ddcffe0146c8f882).set('wwx_session_id', newSessionId);
        setCurrentSessionId(newSessionId);
        setMessages([
            createWelcomeMessage()
        ]);
        console.log('User logged out');
    }, []);
    // Voice control handlers
    const handleStartListening = (0, $8vqx4.useCallback)(async ()=>{
        if (voiceServiceRef.current && !isListening) try {
            await voiceServiceRef.current.startListening();
        } catch (error) {
            console.error('Failed to start listening:', error);
        }
    }, [
        isListening
    ]);
    const handleStopListening = (0, $8vqx4.useCallback)(()=>{
        if (voiceServiceRef.current) voiceServiceRef.current.stopListening();
    }, []);
    // Add method to refresh limit status
    const refreshLimitStatus = (0, $8vqx4.useCallback)(()=>{
        // Reset the limit status to allow new requests
        setDailyLimitStatus({
            remaining: null,
            limit: null,
            isExceeded: false,
            message: ''
        });
    }, []);
    // Expose refresh method to window for testing
    (0, $8vqx4.useEffect)(()=>{
        if (typeof window !== 'undefined') window.refreshLimitStatus = refreshLimitStatus;
        return ()=>{
            if (typeof window !== 'undefined') delete window.refreshLimitStatus;
        };
    }, [
        refreshLimitStatus
    ]);
    if (!isVisible) return null;
    const containerStyle = {
        position: 'fixed',
        top: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? '60px' : `${position.y}px`,
        left: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? '10px' : `${position.x}px`,
        right: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? '10px' : 'auto',
        bottom: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? '20px' : 'auto',
        width: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? 'auto' : `${size.width}px`,
        height: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? 'auto' : `${size.height}px`,
        maxWidth: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? 'none' : '90vw',
        maxHeight: (0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? 'none' : '90vh',
        border: '1px solid #ccc',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        backgroundColor: '#f4f4f4',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1000,
        borderRadius: '10px',
        overflow: 'hidden',
        cursor: isDragging ? 'grabbing' : 'default'
    };
    if (showHistory) return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        ref: widgetRef,
        className: "wwx-chat-widget-container",
        style: containerStyle,
        onMouseDown: handleMouseDown,
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("header", {
                className: "app-header",
                style: {
                    cursor: !(0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? 'grab' : 'default'
                },
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                    className: "header-icons",
                    style: {
                        width: '100%',
                        justifyContent: 'space-between'
                    },
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                            style: {
                                color: '#999',
                                fontWeight: 'bold'
                            },
                            children: t('chatHistory')
                        }),
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                            onClick: onClose,
                            className: "close-banner-button",
                            style: {
                                position: 'static',
                                opacity: 1,
                                marginRight: '10px'
                            },
                            children: "\xd7"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $39f396b236ee9909$export$2e2bcd8739ae039), {
                historyData: historyData,
                language: config.language,
                onSelectSession: handleSelectSession,
                onBack: ()=>setShowHistory(false)
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                style: {
                    backgroundColor: '#fff',
                    borderTop: '1px solid #eee',
                    padding: '15px',
                    textAlign: 'center'
                },
                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("a", {
                    href: "#",
                    onClick: (e)=>{
                        e.preventDefault();
                        setShowHistory(false);
                    },
                    style: {
                        color: '#AB7C40',
                        textDecoration: 'none',
                        fontWeight: 'bold'
                    },
                    children: [
                        /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                            className: "fas fa-arrow-left"
                        }),
                        " ",
                        t('backToChat')
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
        ref: widgetRef,
        className: "wwx-chat-widget-container",
        style: containerStyle,
        onMouseDown: handleMouseDown,
        children: [
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "chatbox-background",
                style: {
                    height: '100%',
                    overflow: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "xr-banner",
                        onMouseDown: handleMouseDown,
                        style: {
                            cursor: !(0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() ? 'grab' : 'default'
                        },
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                src: (0, $1844453eead66305$export$af227afd9ab8dcbf)('xr-avatar.webp'),
                                alt: "XR Avatar",
                                className: "xr-avatar"
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "xr-text",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("span", {
                                        className: "xr-name",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                                src: (0, $1844453eead66305$export$af227afd9ab8dcbf)('zyra.png'),
                                                className: "zyra"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                                src: (0, $1844453eead66305$export$af227afd9ab8dcbf)('xr-ai.png'),
                                                alt: "XR Star",
                                                className: "xr-star"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        className: "xr-title",
                                        children: t('wineAdvisor')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                className: "header-auth-buttons",
                                children: [
                                    !userToken && isFullScreen && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)((0, $607ae91d1eb97195$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                                className: "header-auth-btn",
                                                onClick: handleSignupClick,
                                                children: t('auth.signUp')
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                                className: "header-auth-btn header-auth-btn-login",
                                                onClick: handleLoginClick,
                                                children: t('auth.login')
                                            })
                                        ]
                                    }),
                                    userToken && isFullScreen && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                        className: "header-auth-btn header-auth-btn-logout",
                                        onClick: handleLogout,
                                        children: t('auth.logout')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                onClick: onClose,
                                className: "close-banner-button",
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                        id: "chatbox",
                        style: {
                            borderRadius: '30px',
                            margin: '10px',
                            height: 'calc(100% - 120px)',
                            paddingBottom: '10px',
                            overflow: 'hidden'
                        },
                        children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                            id: "messages",
                            style: {
                                height: '100%',
                                overflowY: 'auto',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '15px'
                            },
                            children: [
                                messages.map((msg)=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $b320433ddd1a8beb$export$2e2bcd8739ae039), {
                                        message: msg,
                                        currency: config.currency,
                                        language: config.language,
                                        user: config.user,
                                        sessionId: currentSessionId || undefined,
                                        onSignupClick: handleSignupClick
                                    }, msg.id)),
                                /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                    ref: messagesEndRef
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                className: "bottom-bar",
                children: [
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("nav", {
                        className: "bottom-nav-icons",
                        children: [
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("a", {
                                href: "https://api.whatsapp.com/send?phone=85297100398",
                                target: "_blank",
                                className: "nav-icon",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                                        className: "fab fa-whatsapp"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        children: t('whatsapp')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("a", {
                                href: "#",
                                className: "nav-icon",
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                                        className: "fas fa-search"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        children: t('search')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("a", {
                                href: "#",
                                className: "nav-icon",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleNewChat();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("img", {
                                        src: (0, $1844453eead66305$export$af227afd9ab8dcbf)('robot.svg'),
                                        alt: "New Chat Icon",
                                        className: "new-chat-icon"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        children: t('newChat')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("a", {
                                href: "#",
                                className: "nav-icon",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    loadHistoryList();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                                        className: "fas fa-history"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        children: t('history')
                                    })
                                ]
                            }),
                            hasFirstResult && currentSessionId && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("a", {
                                href: "#",
                                className: "nav-icon",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setShowShareDialog(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                                        className: "fas fa-share-alt"
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("span", {
                                        children: t('share.button') || 'Share'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                        className: "message-input-area",
                        children: [
                            showAuthPrompt && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $7b60667e149e9d6c$export$2e2bcd8739ae039), {
                                onSignUp: handleSignupClick,
                                onLogin: handleLoginClick,
                                remainingMessages: dailyLimitStatus.remaining,
                                language: config.language
                            }),
                            !showAuthPrompt && dailyLimitStatus.limit !== null && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                className: "limit-indicator",
                                children: dailyLimitStatus.isExceeded ? dailyLimitStatus.message || t('dailyLimitReached') : t('dailyLimitMessage', {
                                    remaining: dailyLimitStatus.remaining,
                                    limit: dailyLimitStatus.limit
                                })
                            }),
                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("form", {
                                id: "messageForm",
                                onSubmit: handleFormSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "messageInput",
                                        children: [
                                            Object.keys(selectedCategories).length > 0 && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                                                style: {
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '6px',
                                                    marginBottom: '8px'
                                                },
                                                children: Object.entries(selectedCategories).map(([category, value])=>/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("span", {
                                                        style: {
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            backgroundColor: '#B8860B',
                                                            color: 'white',
                                                            padding: '4px 12px',
                                                            borderRadius: '16px',
                                                            fontSize: '12px',
                                                            fontWeight: '500'
                                                        },
                                                        children: [
                                                            value,
                                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>{
                                                                    setSelectedCategories((prev)=>{
                                                                        const newCategories = {
                                                                            ...prev
                                                                        };
                                                                        delete newCategories[category];
                                                                        return newCategories;
                                                                    });
                                                                    setInputValue((prev)=>{
                                                                        // Remove this value from input
                                                                        return prev.replace(value, '').replace(/\s+/g, ' ').trim();
                                                                    });
                                                                },
                                                                style: {
                                                                    marginLeft: '6px',
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    color: 'white',
                                                                    cursor: 'pointer',
                                                                    padding: 0,
                                                                    fontSize: '14px',
                                                                    lineHeight: 1
                                                                },
                                                                children: "\xd7"
                                                            })
                                                        ]
                                                    }, category))
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("input", {
                                                type: "text",
                                                id: "messageInput",
                                                placeholder: dailyLimitStatus.isExceeded ? dailyLimitStatus.message || t('dailyLimitReached') : isWaitingForResponse ? t('waitingForResponse') : messages.length <= 1 ? t('askAboutWineFirst') : t('askAboutWine'),
                                                autoComplete: "off",
                                                value: inputValue,
                                                onChange: (e)=>setInputValue(e.target.value),
                                                disabled: isWaitingForResponse || dailyLimitStatus.isExceeded
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $431ed5bb4a3b972b$export$2e2bcd8739ae039), {
                                                onSelectionClick: handleSelectionClick,
                                                language: config.language || 'en'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsxs)("div", {
                                        className: "input-buttons-stack",
                                        children: [
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $a65eb5cd434293e4$export$2e2bcd8739ae039), {
                                                isListening: isListening,
                                                onStartListening: handleStartListening,
                                                onStopListening: handleStopListening,
                                                disabled: isWaitingForResponse || dailyLimitStatus.isExceeded,
                                                language: config.language || 'en'
                                            }),
                                            /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("button", {
                                                type: "submit",
                                                className: "send-button",
                                                disabled: isWaitingForResponse || dailyLimitStatus.isExceeded,
                                                children: /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("i", {
                                                    className: "fas fa-paper-plane"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !(0, $540271f4c8f7b579$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)("div", {
                className: "resize-handle",
                onMouseDown: handleResizeMouseDown,
                style: {
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: '20px',
                    height: '20px',
                    cursor: 'nwse-resize',
                    background: 'linear-gradient(135deg, transparent 50%, #AB7C40 50%)',
                    borderBottomRightRadius: '10px'
                }
            }),
            showShareDialog && currentSessionId && /*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $64d03a4946ae276d$export$2e2bcd8739ae039), {
                sessionId: currentSessionId,
                isOpen: showShareDialog,
                onClose: ()=>setShowShareDialog(false),
                language: config.language
            })
        ]
    });
};
var $2365c19848a47fac$export$2e2bcd8739ae039 = $2365c19848a47fac$var$ChatWidget;


let $103f3ea2d591e76b$var$targetElement = null;
let $103f3ea2d591e76b$var$currentConfig = {
    currency: 'HKD',
    user: null,
    language: 'EN',
    sessionId: null
};
let $103f3ea2d591e76b$var$isWidgetVisible = false;
let $103f3ea2d591e76b$var$reactRoot = null; // For React 18
const $103f3ea2d591e76b$var$renderWidget = ()=>{
    if ($103f3ea2d591e76b$var$targetElement) {
        const widgetProps = {
            initialConfig: {
                ...$103f3ea2d591e76b$var$currentConfig
            },
            isVisible: $103f3ea2d591e76b$var$isWidgetVisible,
            sessionId: $103f3ea2d591e76b$var$currentConfig.sessionId,
            onClose: ()=>{
                if (window.WWXChatWidget) window.WWXChatWidget.hide();
            }
        };
        if (!$103f3ea2d591e76b$var$reactRoot) $103f3ea2d591e76b$var$reactRoot = (0, (/*@__PURE__*/$parcel$interopDefault($ffa230115876cfd8$exports))).createRoot($103f3ea2d591e76b$var$targetElement);
        $103f3ea2d591e76b$var$reactRoot.render(/*#__PURE__*/ (0, $607ae91d1eb97195$exports.jsx)((0, $2365c19848a47fac$export$2e2bcd8739ae039), {
            ...widgetProps
        }));
    }
};
const $103f3ea2d591e76b$var$WWXChatWidget = {
    init: (config)=>{
        if (!config || !config.targetElementId) {
            console.error("WWX Chat Widget: 'targetElementId' is required in config.");
            return;
        }
        $103f3ea2d591e76b$var$targetElement = document.getElementById(config.targetElementId);
        if (!$103f3ea2d591e76b$var$targetElement) {
            console.error(`WWX Chat Widget: Target element with ID '${config.targetElementId}' not found.`);
            return;
        }
        $103f3ea2d591e76b$var$currentConfig.currency = config.currency || $103f3ea2d591e76b$var$currentConfig.currency;
        $103f3ea2d591e76b$var$currentConfig.user = config.user || $103f3ea2d591e76b$var$currentConfig.user;
        $103f3ea2d591e76b$var$currentConfig.language = config.language || $103f3ea2d591e76b$var$currentConfig.language;
        $103f3ea2d591e76b$var$currentConfig.sessionId = config.sessionId || $103f3ea2d591e76b$var$currentConfig.sessionId;
        $103f3ea2d591e76b$var$isWidgetVisible = config.startVisible || false; // Optionally start visible
        $103f3ea2d591e76b$var$renderWidget();
    },
    show: ()=>{
        $103f3ea2d591e76b$var$isWidgetVisible = true;
        $103f3ea2d591e76b$var$renderWidget();
    },
    hide: ()=>{
        $103f3ea2d591e76b$var$isWidgetVisible = false;
        $103f3ea2d591e76b$var$renderWidget();
    },
    setCurrency: (currency)=>{
        if (typeof currency === 'string') {
            $103f3ea2d591e76b$var$currentConfig.currency = currency;
            $103f3ea2d591e76b$var$renderWidget();
        } else console.warn("WWX Chat Widget: setCurrency expects a string.");
    },
    setUser: (user)=>{
        // User is JWT string
        $103f3ea2d591e76b$var$currentConfig.user = user;
        $103f3ea2d591e76b$var$renderWidget();
    },
    setLanguage: (language)=>{
        if (typeof language === 'string') {
            $103f3ea2d591e76b$var$currentConfig.language = language;
            $103f3ea2d591e76b$var$renderWidget();
        } else console.warn("WWX Chat Widget: setLanguage expects a string.");
    },
    setSessionId: (sessionId)=>{
        $103f3ea2d591e76b$var$currentConfig.sessionId = sessionId;
        $103f3ea2d591e76b$var$renderWidget();
    },
    isInitialized: ()=>!!$103f3ea2d591e76b$var$targetElement,
    isVisible: ()=>$103f3ea2d591e76b$var$isWidgetVisible
};
// Explicitly attach to window object to ensure global availability
window.WWXChatWidget = $103f3ea2d591e76b$var$WWXChatWidget;
var // Also make it available as a named export for potential future use
$103f3ea2d591e76b$export$2e2bcd8739ae039 = $103f3ea2d591e76b$var$WWXChatWidget;


//# sourceMappingURL=react_test.bc36add8.js.map
